var SHTHelper = window.SHTHelper || {};

var TRAP_FOCUS_HANDLERS = {};

SHTHelper.fetchConfigHTTP = {
  method: "POST",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/javascript",
  },
};

SHTHelper.fetchConfigJSON = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

SHTHelper.isColor = function (strColor) {
  let s = new Option().style;
  s.color = strColor;
  return s.color == strColor;
};

SHTHelper.debounce = function (fn, delay) {
  let id = null;
  return function (args) {
    clearTimeout(id);
    id = null;
    id = setTimeout(function () {
      fn.call(this, args);
    }, delay);
  };
};

SHTHelper.removeTrapFocus = function (elementToFocus = null) {
  document.removeEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);
  document.removeEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);

  if (elementToFocus) elementToFocus.focus();
};

SHTHelper.trapFocus = function (element, elementToFocus = element) {
  let focusableEls = element.querySelectorAll(`a[href]:not([disabled]):not(.disable), [tabindex]:not([tabindex^='-']), summary, button:enabled:not([tabindex^='-']), textarea:not([disabled]), input:not([type=hidden]):enabled, input[type="text"]:not([disabled]), object, iframe, input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), [draggable], area`);

  let firstFocusableEl = focusableEls[0];

  let lastFocusableEl = focusableEls[focusableEls.length - 1];

  // console.log(element, firstFocusableEl, lastFocusableEl);

  // console.log(focusableEls);

  let KEYCODE_TAB = 9;

  SHTHelper.removeTrapFocus();

  TRAP_FOCUS_HANDLERS.focusin = event => {

    if (event.target !== element && event.target !== lastFocusableEl && event.target !== firstFocusableEl) return;

    document.addEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.focusout = function () {
    document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
  };

  TRAP_FOCUS_HANDLERS.keydown = function (e) {
    let isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (e.target === element || e.target === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  };

  document.addEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout);
  document.addEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin);

  elementToFocus.focus();
};

SHTHelper.initTabLogging = function() {
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Tab') {
      setTimeout(() => {
        console.log('Tabbed to element:', document.activeElement);
        // console.log('Element tag:', document.activeElement.tagName);
        // console.log('Element classes:', document.activeElement.className);
      }, 0);
    }
  });
};

// SHTHelper.initTabLogging();

SHTHelper.isColor = function (strColor) {
  let s = new Option().style;
  s.color = strColor;
  return s.color == strColor;
};

SHTHelper.isHexColor = function (color) {
  return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(color);
};

SHTHelper.isImage = function (url) {
  return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg|.webp|.heic|.gif|.svg)(\?[^\s[",><]*)?/gi.test(url);
};

SHTHelper.formatMoney = function (cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.theme_variables.settings.money_format;

  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = SHTHelper.formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = SHTHelper.formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = SHTHelper.formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = SHTHelper.formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = SHTHelper.formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = SHTHelper.formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = SHTHelper.formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = SHTHelper.formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

SHTHelper.defaultTo = function (value2, defaultValue) {
  return value2 == null || value2 !== value2 ? defaultValue : value2;
};

SHTHelper.formatWithDelimiters = function (number, precision, thousands, decimal) {
  precision = SHTHelper.defaultTo(precision, 2);
  thousands = SHTHelper.defaultTo(thousands, ",");
  decimal = SHTHelper.defaultTo(decimal, ".");
  if (isNaN(number) || number == null) {
    return 0;
  }
  number = (number / 100).toFixed(precision);
  let parts = number.split("."),
    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
    centsAmount = parts[1] ? decimal + parts[1] : "";
  return dollarsAmount + centsAmount;
};

SHTHelper.preventStickyHeaderReveal = function () {
  let stickyHeader = SHTHelper.qs("sht-header-sticky");
  stickyHeader && stickyHeader.dispatchEvent(new Event("preventStickyHeaderReveal"));
};
SHTHelper.loadScript = function (id, file, callback) {
  if (!SHTHelper.qs(`#${id}`)) {
    let script = document.createElement("script");
    script.setAttribute("src", `${file}`);
    script.setAttribute("id", `${id}`);
    script.onload = function () {
      callback();
    };
    script.onreadystatechange = function () {
      if (this.readyState == "complete" || this.readyState == "loaded") {
        callback();
      }
    };
    script.onerror = function (event) {
      console.log("Failed to load script file " + file, event);
      callback();
    };
    document.body.appendChild(script);
  } else {
    callback();
  }
};

SHTHelper.forceUpdateCartStatus = function (res) {
  let sections = [
    {
      section: "cart-drawer",
      selector: `.js-cart-drawer-wrapper`,
      space_selector: `.js-cart-drawer-wrapper`,
    },
    {
      section: "header-cart-status",
      space_selector: `.shopify-section`,
      selector: `#headerCartStatus`,
      cart_notification: false,
    },
    {
      section: "main-cart",
      space_selector: `#mainCartContainer`,
      selector: `#mainCartContainer`,
      cart_notification: false,
    }
  ];

  let cartNotification = SHTHelper.qs("sht-cart-noti");
  let stickyHeader = SHTHelper.qs("sht-header-sticky");

  let sectionsToStr = sections.map(section => section.section).join(",");

  fetch(`${window.location.pathname}?sections=${sectionsToStr}`)
    .then(response => {
      return response.json();
    })
    .then(json => {
      // if (stickyHeader) {
      //   if (stickyHeader.dataset.isEnabled) {
      //     stickyHeader.reveal();
      //   }
      // }
      sections.forEach(e => {
        let sectionHtml = json[e.section];
        let shouldBeUpdateElm = SHTHelper.qs(e.selector);
        if (sectionHtml && shouldBeUpdateElm) {
          let newElm = new DOMParser().parseFromString(sectionHtml, "text/html").querySelector(e.space_selector);
          if (newElm) {
            shouldBeUpdateElm.innerHTML = newElm.innerHTML;
          }

          if (e.cart_notification && cartNotification) {
            cartNotification.open();
          }
        }
      });
    })
    .catch(e => {
      console.log("Cannot force Update Cart Status");
    });
};

class SHTElementLazyLoad {
  constructor() {
    this.elements = SHTHelper.qsa(".js-main-body .js-animate");
    this.viewportHeight = window.innerHeight;
    this.setupEventListeners();
  }

  setupEventListeners() {
    const longObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animated");
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: "-50px" });

    const shortObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animated");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    this.elements.forEach(element => {
      const height = element.offsetHeight;
      if (height > this.viewportHeight * 0.8) {
        longObserver.observe(element);
      } else {
        shortObserver.observe(element);
      }
    });
  }
}
setTimeout(() => {
  typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    typeof SHTElementLazyLoad !== "undefined" && new SHTElementLazyLoad();
  });
}

class SHTCustomComponent extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }
}

class SHTAccordion extends SHTCustomComponent {
  constructor() {
    super();
    this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {};
    this.accordionItems = this.$$(".js-accordion-item");
    this.accordionTriggers = this.$$(".js-accordion-trigger");
    this.accordionContents = this.$$(".js-accordion-content");
  }

  connectedCallback() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.accordionTriggers.forEach(ele => {
      ele.addEventListener("click", e => {
        e.preventDefault();
        this.onTriggerClick(e.currentTarget);
      });
    });
    this.onResize();
  }

  onResize() {
    this.resizeObserver = new ResizeObserver(entries => {
      this.accordionItems.forEach(e => {
        if (e.querySelector(".js-accordion-trigger").classList.contains('open')) {
          e.querySelector(".js-accordion-content").style.maxHeight = `${this.calculateMaxHeightContent(e.querySelector(".js-accordion-content"))}px`;
          Array.from(e.querySelector(".js-accordion-content").children).forEach(child => {
            child.style.transform = "translateY(0)";
          });
        }
      });
    });
    this.resizeObserver.observe(this);
  }

  onTriggerClick(e) {
    let open = e.getAttribute("aria-expanded") === "true";
    if (this.properties.multiple === true) {
      this.toggleAll();
    }
    this.toggle(!open, e);
  }

  toggle(open, e) {
    e.setAttribute("aria-expanded", `${open}`);

    let content = this.$(`#${e.getAttribute("aria-controls")}`);
    let children = Array.from(content.children);

    if (open) {
      e.classList.add("open");
      content.classList.add("open");
      content.style.maxHeight = `${this.calculateMaxHeightContent(content)}px`;
      children.forEach(child => {
        child.style.transform = "translateY(0)";
      });
    } else {
      e.classList.remove("open");
      content.classList.remove("open");
      content.style.maxHeight = `0px`;
      children.forEach(child => {
        child.style.transform = `translateY(-${this.calculateMaxHeightContent(content)}px)`;
      });
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }

  toggleAll() {
    this.accordionTriggers.forEach(ele => {
      ele.setAttribute("aria-expanded", `false`);
      ele.classList.remove(`open`);
    });

    this.accordionContents.forEach(ele => {
      ele.classList.remove("open");
      ele.style.maxHeight = `0px`;
    });
  }

  calculateMaxHeightContent(target) {
    return target.scrollHeight;
  }
}

customElements.define("sht-accordion", SHTAccordion);

class SHTDropdownSelect extends SHTCustomComponent {
  constructor() {
    super();
    this.selectElement = this.querySelector('select');
    this.selectedItemDiv = document.createElement('div');
    this.optionsContainerDiv = document.createElement('div');
    this.observer = new MutationObserver(this.handleMutations.bind(this));
  }

  connectedCallback() {
    this.init();
    this.observeSelectElement();
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  init() {

    this.setAttribute('role', 'combobox');
    this.setAttribute('aria-haspopup', 'listbox');
    this.setAttribute('aria-expanded', 'false');

    this.selectedItemDiv.classList.add('select-selected');
    this.selectedItemDiv.setAttribute('role', 'button');
    this.selectedItemDiv.setAttribute('tabindex', '0');
    this.selectedItemDiv.setAttribute('aria-label', 'Select option');

    this.optionsContainerDiv.classList.add('select-items', 'select-hide');
    this.optionsContainerDiv.setAttribute('role', 'listbox');

    this.updateSelectedItem();
    this.populateOptions();
    this.addEventListeners();
    this.appendChild(this.selectedItemDiv);
    this.appendChild(this.optionsContainerDiv);
  }

  updateSelectedItem() {
    this.selectedItemDiv.textContent = this.selectElement.options[this.selectElement.selectedIndex]?.textContent || '';
  }

  populateOptions() {
    this.optionsContainerDiv.innerHTML = ''; // Clear existing options
    Array.from(this.selectElement.options).forEach((option, index) => {
      const optionItemDiv = document.createElement('div');
      optionItemDiv.classList.add('select-item');
      optionItemDiv.setAttribute('role', 'option');
      optionItemDiv.setAttribute('tabindex', '0');
      optionItemDiv.setAttribute('aria-selected', 'false');
      optionItemDiv.textContent = option.textContent;
      optionItemDiv.dataset.index = index;
      if (index === this.selectElement.selectedIndex) {
        optionItemDiv.setAttribute('aria-selected', 'true');
      }
      optionItemDiv.addEventListener('click', () => {
        this.handleOptionClick(index);
      });

      this.optionsContainerDiv.appendChild(optionItemDiv);
    });
  }

  addEventListeners() {
    this.selectedItemDiv.addEventListener('click', (event) => {
      event.stopPropagation();
      this.toggleDropdown();
    });

    document.addEventListener('click', () => this.closeAllDropdowns());

    this.selectedItemDiv.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleDropdown();
      }
    });

    this.addEventListener('keydown', (event) => {
      const options = this.optionsContainerDiv.querySelectorAll('.select-item');
      const currentIndex = Array.from(options).findIndex(opt => opt === document.activeElement);

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          if (currentIndex < options.length - 1) {
            options[currentIndex + 1].focus();
          }
          break;
        case 'ArrowUp':
          event.preventDefault();
          if (currentIndex > 0) {
            options[currentIndex - 1].focus();
          }
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          if (document.activeElement.classList.contains('select-item')) {
            this.handleOptionClick(parseInt(document.activeElement.dataset.index));
          }
          break;
        case 'Escape':
          this.closeAllDropdowns();
          this.selectedItemDiv.focus();
          break;
      }
    });
  }

  handleOptionClick(index) {
    this.selectElement.selectedIndex = index;
    this.selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    this.updateSelectedItem();
    this.closeAllDropdowns();
  }

  toggleDropdown() {
    const isExpanded = !this.optionsContainerDiv.classList.contains('select-hide');
    this.setAttribute('aria-expanded', (!isExpanded).toString());
    SHTHelper.qsa('.select-items').forEach(item => {
      if (!this.contains(item)) {
        item.classList.add('select-hide');
      }
    });
    SHTHelper.qsa('.select-selected').forEach(item => {
      if (!this.contains(item)) {
        item.classList.remove('select-arrow-active');
      }
    });

    this.optionsContainerDiv.classList.toggle('select-hide');
    this.selectedItemDiv.classList.toggle('select-arrow-active');
  }

  closeAllDropdowns() {
    SHTHelper.qsa('.select-items').forEach(item => item.classList.add('select-hide'));
    SHTHelper.qsa('.select-selected').forEach(selected => selected.classList.remove('select-arrow-active'));
  }

  observeSelectElement() {
    this.observer.observe(this.selectElement, {
      childList: true, // Listen for added/removed options
      subtree: false,
    });
  }

  handleMutations(mutations) {
    let optionsChanged = false;
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        optionsChanged = true;
      }
    });

    if (optionsChanged) {
      this.populateOptions();
      this.updateSelectedItem();
    }
  }
}

customElements.define('sht-select', SHTDropdownSelect);


/* Carousel */
class SHTCarousel extends SHTCustomComponent {
  constructor() {
    super();

    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.pagination = this.$(".js-carousel-pagination-dots");
    this.pagination_items = this.pagination?.querySelectorAll(".js-carousel-pagination-dot");

    this.scrollbarThumb = this.$(".js-scrollbar-thumb");
    this.scrollbarTrack = this.$(".js-scrollbar-track");
    this.desktopThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbDesk);
    this.tabletThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbTablet);
    this.mobileThumbItemCount = parseInt(this.scrollbarTrack?.dataset.thumbMobile);
    this.totalItems = parseInt(this.scrollbarTrack?.dataset.thumbTotal);
  }

  connectedCallback() {
    this.init();
    this.bindEventHandlers();
  }

  init() {
    if (this.dataset.enable == "false" && this.dataset.enableMobile == "false") return;
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));
    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);

    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }

  pauseAllVideo() {
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
      video.player?.pauseVideo();
    });
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
      video.playerVimeo?.pause();
    });
    SHTHelper.qsa(".js-media-item-video").forEach(video => {
      video.pause();
    });
  }

  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement?.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }

    this.updatePagination();
    this.pauseAllVideo();
    this.updateScrollIndicator();
  }

  updatePagination() {
    if (this.pagination) {
      let item = this.pagination.querySelector(`li[data-dot-index="${this.currentPage}"]`);
      if (item) {
        this.pagination_items.forEach(el => el.classList.remove("is-active"));
        item.classList.add("is-active");
      }
    }
  }

  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
    } else {
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  isItemVisible(element, offset = 0) {
    if (typeof element == "undefined") return false;

    const carouselSpecial = this.classList.contains('carousel--special');
    let lastVisibleItem;
    let paddingContainer;

    if (carouselSpecial) {
      lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset - Math.abs(this.container.offsetLeft) + 1;
      paddingContainer = 0;
    } else {
      lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset;
      paddingContainer = parseInt(getComputedStyle(this.container).paddingLeft);
    }

    return Math.floor(element.getBoundingClientRect().width + paddingContainer + element.offsetLeft) <= Math.round(lastVisibleItem) && element.offsetLeft >= this.container.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = event.currentTarget.dataset.stepMb;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 459px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }

  updateScrollIndicator () {
    if (!this.scrollbarTrack) return;

    this.maxScroll = this.container.scrollWidth - this.container.clientWidth;
    this.scrollPercent = (this.container.scrollLeft / this.maxScroll) * 100;

    this.thumbPercentDesk = this.calculateThumbPercent(this.desktopThumbItemCount);
    this.thumbPercentTablet = this.calculateThumbPercent(this.tabletThumbItemCount);
    this.thumbPercentMobile = this.calculateThumbPercent(this.mobileThumbItemCount);

    this.scrollbarTrack.style.setProperty('--width-thumb-desktop', `${ this.thumbPercentDesk }%`);
    this.scrollbarTrack.style.setProperty('--width-thumb-tablet', `${ this.thumbPercentTablet }%`);
    this.scrollbarTrack.style.setProperty('--width-thumb-mobile', `${ this.thumbPercentMobile }%`);
  }

  calculateThumbPercent(dataThumb) {
    return (dataThumb + this.scrollPercent / 100 * (this.totalItems - dataThumb)) * 100 / this.totalItems;
  }

  bindEventHandlers() {
    if (this.dataset.enable == "false" && this.dataset.enableMobile == "false") return;
    const resizeObserver = new ResizeObserver(entries => this.init());

    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    this.prevBtnElement?.addEventListener("click", (e) => {
      this.updateScrollIndicator();
      this.onButtonClick(e);
    });
    this.nextBtnElement?.addEventListener("click", (e) => {
      this.updateScrollIndicator();
      this.onButtonClick(e);
    });
    this.container.addEventListener("scroll", () => {
      this.updateScrollIndicator();
      SHTHelper.debounce(this.updateCarousel(), 100);
    });
  }
}
customElements.define("sht-carousel", SHTCarousel);

//Popup
class SHTPopup extends SHTCustomComponent {
  static currentZIndex = 100;
  constructor() {
    super();
    this.closeButton = this.$(".js-popup-btn-close");
    this.delayTime = parseInt(this.dataset.delayTime || 0);
    this.popupId = this.dataset.sectionId;
    this.overlay = this.$(".js-dialog-overlay");
    this.container = this.$(".js-popup-container");
    this.enabledOverlay = this.dataset.enabledOverlay;
    this.isAdminEditor = Shopify?.designMode || false;
    this.eleFocusRemove = SHTHelper.qs("a");
    this.init();
  }

  init() {
    this.checkPopupState();
    this.bindEventHandlers();
    if (this.isAdminEditor) this.handlePopupInAdmin();
  }

  getStorageKey() {
    return `popupDismissedDate_${this.popupId}`;
  }

  bindEventHandlers() {
    this.closeButton?.addEventListener("click", this.handleClose.bind(this));
    this.overlay?.addEventListener("click", this.handleClose.bind(this));
    if (!this.classList.contains('hidden-xs') && this.enabledOverlay == 'true') this.handleOverlay();
    this.querySelector('form')?.addEventListener('submit', () => {
      if (!this.isAdminEditor) {
        if (this.delayTime > 0) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          localStorage.setItem(this.getStorageKey(), today.toString());
        } else {
          localStorage.setItem(this.getStorageKey(), 'permanent');
        }
      }
    });
  }

  checkPopupState() {
    const dismissedDate = localStorage.getItem(this.getStorageKey());
    if (this.isPopupDismissed(dismissedDate)) {
      this.hidePopup();
      return true;
    } else if (dismissedDate !== 'permanent') {
      localStorage.removeItem(this.getStorageKey());
      this.hidePopup();
    } else {
      this.hidePopup();
    }
    return false;
  }

  isPopupDismissed(dismissedDate = localStorage.getItem(this.getStorageKey())) {
    if (this.isAdminEditor) return false;

    if (dismissedDate === 'permanent') return true;
    if (!dismissedDate || !this.delayTime) return false;

    const today = new Date().toDateString();
    const lastDismissed = new Date(dismissedDate).toDateString();
    const daysPassed = Math.floor((new Date(today) - new Date(lastDismissed)) / (1000 * 60 * 60 * 24));

    return daysPassed < this.delayTime;
  }

  handleOverlay() {
    if (!this.isAdminEditor) {
      if (this.enabledOverlay == 'true') {
        document.body.classList.add('o-hidden');
      } else {
        document.body.classList.remove('o-hidden');
      }
      const allPopups = SHTHelper.qsa('.js-sht-popup');
      allPopups.forEach(popup => {
        if (!popup.classList.contains('hidden-xs') && popup.dataset.enabledOverlay == 'true') document.body.classList.add('o-hidden');
      });
    }
  }
  updateZIndex() {
    SHTPopup.currentZIndex += 2;
    this.querySelector('.js-popup-container').style.zIndex = SHTPopup.currentZIndex.toString();
  }

  handleClose() {
    this.hidePopup();

    if (!this.isAdminEditor) {
      if (this.delayTime > 0) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        localStorage.setItem(this.getStorageKey(), today.toString());
      } else {
        localStorage.setItem(this.getStorageKey(), 'permanent');
      }
    }
  }

  hidePopup() {
    this.querySelector('.js-drawer-content-container')?.classList.add(...['h-100', 'p-fixed', 'zi-10', 'left-0', 'top-0']);
    void this.offsetHeight;
    this.classList.add("drawer-out");
    setTimeout(() => {
      this.classList.remove("is-active");
      this.classList.replace("drawer-out", "hidden-xs");
      document.body.classList.remove('o-hidden');
      const allPopups = SHTHelper.qsa('.js-sht-popup');
      allPopups.forEach(popup => {
        if (!popup.classList.contains('hidden-xs') && popup.dataset.enabledOverlay == 'true') document.body.classList.add('o-hidden');
      });
    }, 300);
  }

  showPopup() {
    setTimeout(() => {
      if (!this.isAdminEditor) {
        this.handleOverlay();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            void this.offsetHeight;
            this.classList.add('is-active');
            this.classList.remove('hidden-xs');
            this.updateZIndex();
          });
        });
      }
    }, 300);
    setTimeout(() => {
      this.querySelector('.js-drawer-content-container')?.classList.remove(...['h-100', 'p-fixed', 'zi-10', 'left-0', 'top-0']);
    }, 600);
    setTimeout(() => {
      if (this.enabledOverlay == 'false') {
        this.classList.add('dialog-enable-overlay');
      } else {
        this.classList.remove('dialog-enable-overlay');
      }
    }, 1000);
  }

  handlePopupInAdmin () {
    if (this.isAdminEditor) {
      document.addEventListener('shopify:section:select', (event) => {
        if(event.target.id.includes('popup')) {
          const popup = event.target.querySelector('.popup');
          setTimeout(() => {
            popup.classList.remove('hidden-xs');
            popup.classList.add('is-active');
            if (popup.dataset.enabledOverlay == 'true') {
              document.body.classList.add('o-hidden');
            } else {
              document.body.classList.remove('o-hidden');
            }
          }, 300);
        setTimeout(() => {
          this.querySelector('.js-drawer-content-container')?.classList.remove(...['h-100', 'p-fixed', 'zi-10', 'left-0', 'top-0']);
        }, 600);
        }
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if(event.target.id.includes('popup')) this.hidePopup();
      });
    }
  }
}

class SHTInteractionPopup extends SHTPopup {
  constructor() {
    super();
    this.footer = document.querySelector("footer");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.initInteractionHandlers();
  }
  initInteractionHandlers() {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isPopupDismissed()) {
            this.showPopup();
            SHTHelper.trapFocus(this);
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    if (this.footer) {
      footerObserver.observe(this.footer);
    }

    if (this.cartNotification) {
      this.cartNotification.addEventListener("opened", this.handleShowPopupAddToCart.bind(this));
    }
  }

  handleShowPopupAddToCart() {
    let sitePopupStatus = this.checkPopupState();
    if (!sitePopupStatus) {
      this.showPopup();
      SHTHelper.trapFocus(this);
    }
  }
}

customElements.define("sht-interaction-popup", SHTInteractionPopup);

class SHTTimeDelayPopup extends SHTPopup {
  constructor() {
    super();
    this.delayUntil = parseInt(this.dataset.delayUntil);
    this.initDelayUntil();
  }

  initDelayUntil() {
    if (this.isPopupDismissed()) {
      return;
    }

    if (this.delayUntil === 0) {
      this.showPopup(this);
      SHTHelper.trapFocus(this.$(".js-popup-btn-close"));
    } else if (this.delayUntil > 0) {
      setTimeout(() => {
        if (!this.isPopupDismissed()) {
          this.showPopup(this);
          SHTHelper.trapFocus(this.$(".js-popup-btn-close"));
        }
      }, this.delayUntil * 1000);
    }
  }
}

customElements.define("sht-time-delay-popup", SHTTimeDelayPopup);

/* Drawer */
class SHTCoreDrawer extends SHTCustomComponent {
  constructor() {
    super();
    this.drawerWrapperElement = this.$(".js-drawer-wrapper");
    this.drawerOverlayElement = this.$(".js-drawer-overlay");
    this.closeBtnElement = this.$$(".js-drawer-btn-close");
    this.opener = null;
    this.bodyElement = document.body;
    this.isMobileMenuDrawer = this.closest('sht-menu-drwer');
    this.bindEventHandlers();
    this.scrollElement = this.$(".js-scroll-element");
    this.containerOverflowElement = this.$(".js-container-overflow");
  }

  bindEventHandlers() {
    this.drawerOverlayElement.addEventListener("click", this.closeDrawer.bind(this));

    this.closeBtnElement.forEach((btn) => {
      btn.addEventListener("click", this.closeDrawer.bind(this));
      window.addEventListener("load", () => {
        this.removeAttribute("hidden");
      });
    })
    this.addEventListener("keyup", event => {
      if (event.code.toUpperCase() === "ESCAPE" ) {
        const isBaseDrawer = this.checkLevelDrawer('sht-menu-drwer');
        if(!this.isMobileMenuDrawer || (this.isMobileMenuDrawer && isBaseDrawer)) {
          this.closeDrawer(event);
        }
      } 
    });
    this.drawerAttrObserve();
  }

  checkLevelDrawer(drawer) {
    let isBaseDrawer = true;
    const details = this.closest(drawer).querySelectorAll('details');
    details.forEach((detail) => {
      if (detail.hasAttribute('open') === true) {
        isBaseDrawer = false;
      }
    });

    return isBaseDrawer;
  }

  drawerAttrObserve() {
    const drawerAttrObserver = new MutationObserver((mutations) => {
      mutations.forEach(async mutation => {
        if (mutation.attributeName == "open") {
          const isOpen = this.hasAttribute("open");
          if (isOpen) {
            this.opener?.removeAttribute("disabled");
            this.opener?.setAttribute("aria-expanded", "true");
            this.setAttribute("aria-hidden", "false");
            this.dispatchEvent(new Event("opening"));
            this.classList.add("active");
            void this.offsetHeight;
            this.classList.remove('hidden-xs');
            await this.animationsComplete();
            this.bodyElement.classList.add("o-hidden");
            this.dispatchEvent(new Event("opened"));
            SHTHelper.trapFocus(this);
          } else {
            SHTHelper.removeTrapFocus(this.opener);
            this.setAttribute("aria-hidden", "true");
            this.opener?.setAttribute("aria-expanded", "false");
            this.opener?.removeAttribute("disabled");
            this.dispatchEvent(new Event("closing"));
            void this.offsetHeight;
            this.classList.add("drawer-out");
            setTimeout(() => {
              this.classList.remove("active", "drawer-out");
              this.classList.add("hidden-xs");
              this.dispatchEvent(new Event("closed"));
              this.bodyElement.classList.remove("o-hidden");
            }, 300);
          }
        }
      });
    });

    drawerAttrObserver.observe(this, {
      attributes: true,
    });
  }

  async animationsComplete() {
    const animations = this.getAnimations();
    await Promise.all(animations.map(animation => animation.finished));
  }

  handleInitOverflow() {
    if (this.scrollElement) {
      const isScroll = this.scrollElement.scrollHeight <= this.scrollElement.clientHeight;
      if (isScroll) {
        this.containerOverflowElement?.classList.remove('gradient-overlay');
      }
    }
  }

  openDrawer(opener) {
    SHTHelper.preventStickyHeaderReveal();
    this.handleInitOverflow();
    this.opener = opener;
    this.removeAttribute("hidden");
    this.toggleAttribute("open", true);
  }

  closeDrawer(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleAttribute("open", false);
    this.classList.remove('is-open');
    this.querySelector(".js-drawer-message")?.setActiveMessage(false);
  }
}

class SHTDrawer extends SHTCoreDrawer {}
customElements.define("sht-drwr", SHTDrawer);

class SHTDrawerTrigger extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.triggerBtnElement = this.$(".js-drawer-trigger");
    this.drawerElement = SHTHelper.qs(`sht-drwr#${this.dataset.drawerId}`);

    if (!this.triggerBtnElement || !this.drawerElement) return;

    this.headingElement = this.$(".js-drawer-trigger-heading");
    this.mediaElement = this.$(".js-drawer-trigger-media");
    this.contentElements = this.$$(".js-drawer-trigger-content");
    this.handleBindEvents();
  }

  bindDataToDrawer() {
    let drawerContent = "";
    if (this.headingElement) {
      this.drawerElement.querySelector(".js-drawer-heading").innerHTML = this.headingElement.innerHTML;
    }
    if (this.mediaElement) {
      let clone = this.mediaElement.firstElementChild.cloneNode(true);
      if (this.dataset.ratio == 'auto') {
        clone.querySelector("sht-image-atf").classList.add("drawer-media");
      }
      // original.parentNode.appendChild(clone);
      this.drawerElement.querySelector(".js-drawer-media").innerHTML = clone.innerHTML;
    }

    this.contentElements.forEach(element => {
      drawerContent = drawerContent + element.innerHTML;
    });

    this.drawerElement.querySelector(".js-drawer-content").innerHTML = drawerContent;
  }

  handleBindEvents() {
    this.triggerBtnElement.addEventListener("click", e => {
      setTimeout(() => {
        this.bindDataToDrawer();
        this.drawerElement.openDrawer(e.target);
      }, 100);
    });
  }

  connectedCallback() {
    if (Shopify.designMode) {
      setTimeout(() => {
        this.init();
      }, 1000);
    } else {
      this.init();
    }
  }
}
customElements.define("sht-drwr-trg", SHTDrawerTrigger);

class SHTMegaMenuDrawer extends SHTCoreDrawer {
  constructor() {
    super();
    this.details = this.closest('details');
    this.header = SHTHelper.qs(`sht-header`);
    this.menuType = this.header.dataset.menuDropdownOpenType;
    this.menuWrapper = this.closest('.js-mega-menu-wrapper');
    this.detailsLevel2 = this.querySelectorAll('.menu__item-lv2.js-menu-drawer-link');
    this.level3BackBtn = this.querySelectorAll('.js-menu-header-back-btn');
    this.megaMenuWrapper = this.closest('.js-mega-menu-wrapper');
    this.megaMenuType = this.megaMenuWrapper.dataset.megaMenuType;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if(this.menuType === 'hover') {
      this.details.addEventListener('mouseover', (e) => {
        if(this.megaMenuType !== 'drawer') {
          requestAnimationFrame(() => {
            this.openDrawer(e.target);
          });
        }
      });
    }
    this.details.addEventListener('click', (e) => {
      requestAnimationFrame(() => {
        this.openDrawer(e.target);
      });
    });
    this.detailsLevel2.forEach(detail => {
      detail.addEventListener('click', () => {
        this.handleMenuDrawer(true);
      });
    });
    this.level3BackBtn.forEach(btn => {
      btn.addEventListener('click', (event) => {
        this.handleMenuDrawer(false);
      });
    });
    this.drawerOverlayElement.addEventListener("click", this.handleCloseDrawer.bind(this));
    this.closeBtnElement.forEach((btn) => {
      btn.addEventListener("click", this.handleCloseDrawer.bind(this));
    });
    this.addEventListener("keyup", event => {
      if (event.code.toUpperCase() === "ESCAPE") {
        const isBaseDrawer = this.checkLevelDrawer('sht-mega-menu-drawer');
        if(!this.isMobileMenuDrawer && isBaseDrawer) {
          this.handleCloseDrawer(event);
        }
      } 
    });
  }

  handleMenuDrawer(open) {
    this.level1BackBtn = this.closest('details').querySelectorAll('.js-menu-header-back-btn[data-level="1"]');
    this.menuLevel2Item = this.querySelectorAll('.js-menu-drawer-link.menu__item-lv2');
    this.level1BackBtn.forEach(btn => {
      btn.toggleAttribute('hidden', open);
    });
    this.menuLevel2Item.forEach(item => {
      item.toggleAttribute('hidden', open);
    });
  }
  handleCloseDrawer(event) {
    event.preventDefault();
    event.stopPropagation();
    if(this.closest('sht-menu-header')) {
      const details = this.closest('sht-menu-header').querySelectorAll('details');
      details.forEach(detail => {
        setTimeout(() => {
          detail.toggleAttribute("open", false);
          detail.classList.remove('is-open');
        }, 500);
      });
    }
  }
}
customElements.define("sht-mega-menu-drawer", SHTMegaMenuDrawer);
/* Drawer */

/* Dialog */
class SHTDialogCore extends SHTCustomComponent {
  constructor() {
    super();
    this.dialog = this.$(".dialog");
    this.dialogOverlayElement = this.$(".js-dialog-overlay");
    this.closeBtn = this.$$(".js-dialog-close-btn");
    this.body = this.$(".js-dialog-body");
    this.container = this.$(".js-dialog-container");
    this.closeModalOnOverlayClick = this.dataset.closeModalOnOverlay || "true";
    this.scrollElement = this.$(".js-scroll-element");

    this.opener = null;
    this.bodyElement = document.body;
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.dialogOverlayElement?.addEventListener("click", () => {
      this.closeModal();
    });

    this.closeBtn.forEach(btn => {
      btn.addEventListener("click", event => {
        this.closeModal();
      });
    });

    this.addEventListener("click", event => {
      if (event.target.nodeName === this.tagName && this.closeModalOnOverlayClick === "true") this.closeModal();
    });

    if(this.scrollElement) {
      this.scrollElement.addEventListener('scroll', () => {
        const isScrolledToBottom = this.scrollElement.scrollHeight - Math.floor(this.scrollElement.scrollTop) - 2 < this.scrollElement.clientHeight;
        if (isScrolledToBottom) {
          this.classList.remove('gradient-overlay');
        } else {
          this.classList.add('gradient-overlay');
        }
      })
    }

    this.addEventListener("keyup", evt => evt.code.toUpperCase() === "ESCAPE" && this.closeModal());
    this.dialogAttrObserve();
  }

  dialogAttrObserve() {
    let dialogAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async mutation => {
        if (mutation.attributeName == "hidden") {
          const isOpen = !this.hasAttribute("hidden");
          if (isOpen) {
            this.dispatchEvent(
              new CustomEvent("opening", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );

            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("opened", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            SHTHelper.trapFocus(this);
            this.bodyElement.classList.add("o-hidden");
          } else {
            SHTHelper.removeTrapFocus(this.opener);
            this.dispatchEvent(
              new CustomEvent("closing", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("closed", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            this.bodyElement.classList.remove("o-hidden");
          }
        }
      });
    });

    dialogAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(this.dialog.getAnimations({ subtree: true }).map(animation => animation.finished));
  }

  processBodyContent() {
    this.template = this.$("template");

    if (!this.template) return;
    let content = this.template.content;
    this.body.appendChild(content);
    this.handleInitOverflow();
  }

  handleInitOverflow() {
    if (this.scrollElement) {
      const isScroll = this.scrollElement.scrollHeight <= this.scrollElement.clientHeight;
      if (isScroll) {
        this.classList.remove('gradient-overlay');
      }
    }
  }

  showModal(opener, template = false) {
    SHTHelper.preventStickyHeaderReveal();

    if (template) {
      this.processBodyContent();
    }
    this.opener = opener;
    this.toggleAttribute("hidden", false);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.classList.add("is-active");
        void this.offsetHeight;
        this.classList.remove('hidden-xs');
      });
    });
  }

  closeModal() {
    this.setAttribute("hidden", true);
    void this.offsetHeight;
    this.classList.add("drawer-out");
    setTimeout(() => {
      this.classList.remove("is-active")
      this.classList.replace("drawer-out", "hidden-xs");
    }, 300);
  }
}

/* Color Swatch*/
class SHTColorSwatch extends SHTCustomComponent {
  constructor() {
    super();

    //this.$$ = this.querySelectorAll.bind(this);
    this.json = null;
    this.jsonDataElement = SHTHelper.qs(`#colorSwatchData[type="application/json"]`) || null;

    this.variantSwatchItems = this.$$(".js-variant-swatch-item") || [];
    if (!this.jsonDataElement || this.variantSwatchItems.length == 0) {
      return;
    }
    this.bindEventHandlers();
  }

  onObserverHandler() {
    let observe = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.init();

          observer.unobserve(this);
        }
      });
    });
    observe.observe(this);
  }

  init() {
    this.json = JSON.parse(this.jsonDataElement.textContent);
    this.processJsonData();
    for (let i = 0, n = this.variantSwatchItems.length; i < n; i++) {
      let e = this.variantSwatchItems[i];

      const jsonData = this.json[`${e.dataset.optionValue}`];
      let classSwatchType = "";

      if (e.dataset.swatchSource !== "variant_image") {
        const optionValue = e.dataset.optionValue;
        const swatchOptionValue = e.dataset.swatchOptionValue;

        const applyStyles = (type, color = "", image = "") => {
          classSwatchType = type;
          e.style.backgroundColor = color;
          e.style.backgroundImage = image ? `url("${image}")` : "";
          e.style.backgroundSize = image ? "cover" : "";
          e.style.backgroundRepeat = image ? "no-repeat" : "";
        };

        if (jsonData !== undefined) {
          const isHexColor = SHTHelper.isHexColor(jsonData);
          const isImage = SHTHelper.isImage(jsonData);

          if (isImage) {
            applyStyles("image", "", jsonData);
          } else if (isHexColor) {
            applyStyles("color", jsonData);
          }
        } else if (SHTHelper.isColor(optionValue)) {
          applyStyles("color", optionValue);
        }

        if (swatchOptionValue) {
          const swatchHexColor = SHTHelper.isHexColor(swatchOptionValue);
          const swatchImage = SHTHelper.isImage(swatchOptionValue);

          if (swatchImage) {
            applyStyles("image", "", swatchOptionValue);
          } else if (swatchHexColor) {
            applyStyles("color", swatchOptionValue);
          }
        }

        if (e.style.backgroundImage || e.style.backgroundColor) {
          if (classSwatchType) e.classList.add(`clr-swh__type--${classSwatchType}`);
          e.classList.add("clr-swh__has-value");
          e.querySelector(".js-variant-option-label")?.classList.add("hide-value");
        }
      }
    }
  }

  processJsonData() {
    if (this.json) {
      this.json = Object.assign.apply(
        {},
        this.json.color_swatch_name.map((v, i) => ({
          [v]: this.json.color_swatch_value[i],
        }))
      );
    }
  }

  bindEventHandlers() {
    this.onObserverHandler();
  }
}
class SHTVariantSwatch extends SHTColorSwatch {
  bindEventHandlers() {
    this.onObserverHandler();
    this.variantSwatchItems.forEach(e => {
      e.addEventListener("click", subEvent => {
        this.changeVariantImage(subEvent.currentTarget);
      });
    });
  }
  changeVariantImage(ele) {
    const mainImage = SHTHelper.qs(`#${ele.dataset.productImageId}`);
    const mainImageLink = SHTHelper.qsa(`.${ele.dataset.productLinkClass}`);
    const variantImageTemplate = ele.querySelector("template");
    const shtImage = ele.closest(".mini-card")?.querySelector("sht-image-atf img");
    if (mainImage && variantImageTemplate) {
      this.setButtonVisibility(false);
      const variantImage = variantImageTemplate.content.firstElementChild.cloneNode(true);
      this.updateImage(mainImage, variantImage);
      if (shtImage) this.updateImage(shtImage, variantImage);
      if (mainImageLink) {
        mainImageLink.forEach(link => {
          link.href = variantImage.getAttribute("data_url");
        });
      }
      ele.setAttribute("aria-current", "true");
      ele.classList.add("btn-active");
      ele.focus();
    }
  }
  updateImage(targetImage, sourceImage) {
    targetImage.src = sourceImage.src;
    targetImage.srcset = sourceImage.srcset || sourceImage.src;
  }
  setButtonVisibility(flag) {
    if (this.variantSwatchItems) {
      this.variantSwatchItems.forEach(e => {
        if (flag) {
          e.setAttribute("aria-current", "true");
          e.classList.add("btn-active");
        } else {
          e.removeAttribute("aria-current");
          e.classList.remove("btn-active");
        }
      });
    }
  }
}
customElements.define("sht-variant-swtch", SHTVariantSwatch);

class SHTProductCardVariantButton extends SHTVariantSwatch {}
customElements.define("sht-product-card-variant-button", SHTProductCardVariantButton);

class SHTCollectionCompare extends SHTCustomComponent {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.productsArray = this.getArrayFromLocalStorage() || [];
    this.stickyCompareBtn = SHTHelper.qs('.js-sticky-compare-btn');
    this.stickyCompareBtnsWrapper = SHTHelper.qs('.js-collections-compare-btn');
    this.btnCompares = this.$$('.js-btn-add-to-compare');
    this.productCounter = SHTHelper.qsa('.js-sticky-compare-counter');
    this.clearAllBtn = this.$('.js-btn-clear-all');
    this.dialogCompare = this.$('.js-dialog-compare');
    this.body = this.$(".js-product-compare");

    this.btnShowProducts = this.$('.js-btn-compare');
    this.comparisonDrawer = SHTHelper.qs('.js-comparison-drawer');
    this.closeBtnCompare = SHTHelper.qs('.js-dialog-close-btn-compare');

    this.updateStatesProduct(this.productsArray);
    this.handleEvents();
    this.checkProductFromLocalStorage();
    this.processData();
  }

  handleEvents() {
    this.stickyCompareBtn?.addEventListener('click', () => {
      this.stickyCompareBtnsWrapper.classList.add('hidden-xs');
      this.showModalCompare();
    });

    this.btnCompares.forEach((btn) => {
      btn.addEventListener('click', this.throttle(async () => {
        this.stickyCompareBtnsWrapper.classList.remove('hidden-xs');
        this.productsArray = this.getArrayFromLocalStorage() || [];
        let productID = btn.getAttribute('data-product-id');
        let productUrl = btn.getAttribute('data-product-url');

        this.processDataProductDrawer();

        if (btn.classList.contains('active')) {
          // Remove product from both DOM and array
          this.removeProductWhenAddCompare(productID);
          btn.classList.remove('active');
          this.processData();
        } else {
          // Add product if not already in array and body
          if (this.productsArray.length < 3){

            this.addProductToArray(productID, productUrl);
            btn.classList.add('active');
            await this.processDataProductDrawer();
            await this.processData();
          } else if (this.productsArray.length >= 3) {
            alert('You can only add a maximum of 3 products to compare.');
          }
        }

        this.updateStickyCompare(this.productsArray.length);

      }, 500));
    });

    this.clearAllBtn?.addEventListener("click", () => {
      this.clearAllProducts();
      this.updateStickyCompare(0);
      localStorage.removeItem('sht-compare-product');
      this.body.innerHTML = '';
      this.closeModalCompare();
      setTimeout(() => {
        this.stickyCompareBtnsWrapper.classList.remove('hidden-xs');
      }, 600);
    });

    this.comparisonDrawer?.addEventListener('click', e => {
      if(e.target === e.currentTarget) {
        void this.comparisonDrawer.offsetHeight;
        this.comparisonDrawer.classList.add("drawer-out");
        setTimeout(() => {
          this.comparisonDrawer.classList.remove("is-active");
          this.comparisonDrawer.classList.replace("drawer-out", "hidden-xs");
          document.body.classList.remove("o-hidden");
        }, 300);
      }
    });

    this.closeBtnCompare?.addEventListener('click', () => {
      this.stickyCompareBtnsWrapper.classList.remove('hidden-xs');
      this.closeModalCompare();
    });
  }

  showComparisonDrawer(element) {
    let btnCloseModal = SHTHelper.qsa('.js-comp-drawer-btn');
    let comparisonDrawer = SHTHelper.qs('.js-comparison-drawer');

    btnCloseModal.forEach(btn => {
      btn.addEventListener('click', () => {
        comparisonDrawer.classList.remove("is-active");
        void comparisonDrawer.offsetHeight;
        comparisonDrawer.classList.add("drawer-out");
        setTimeout(() => {
          comparisonDrawer.classList.replace("drawer-out", "hidden-xs");
          document.body.classList.remove("o-hidden");
        }, 300);
        SHTHelper.removeTrapFocus(element);
      });
    });

    if (comparisonDrawer) {
      comparisonDrawer.classList.add("is-active");
      document.body.classList.add("o-hidden");
      void comparisonDrawer.offsetHeight;
      comparisonDrawer.classList.remove('hidden-xs');
      SHTHelper.trapFocus(comparisonDrawer);
    } else {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        window.alert("Product comparison is disabled because the 'Compare Drawer' is hidden. To enable this feature, unhide the 'Compare Drawer.'");
      }
    }
  }

  processDataProductDrawer() {
    const arraysProduct = this.getArrayFromLocalStorage();
    if (!arraysProduct) return;
    this.productElement = null;

    this.mainProductCompare = this.$('.js-main-product-compare');

    const urls = arraysProduct.map(product => `${product.url}?view=show-products-compare`);

    Promise.all(urls.map(url => this.fetchProductCompareHTML(url)))
      .then(productHTMLs => {

        this.mainProductCompare.innerHTML = '';

        productHTMLs.forEach((productHTML, index) => {

          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = productHTML;
          const productContainer = tempContainer.firstElementChild;

          this.mainProductCompare.appendChild(productContainer);
        });

        this.executeScriptElements(this.mainProductCompare);
        if (window.SHTProductMediaItemModel) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
      })
      .catch(error => {
        console.error('Lỗi promise:', error);
      })
      .finally(() => {
      });
  }

  fetchProductCompareHTML(url) {
    return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        const productElement = responseHTML.querySelector(".section-view-product-compare");

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        return productElement.innerHTML;
      });
  }

  switchDataProduct() {

    return new Promise((resolve) => {
      let mainProductCompare = SHTHelper.qs('.js-main-product-compare');

      let productVendorDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-vendor');
      let productDesDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-des');
      let productTypeDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-type');
      let productTagsDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-tags');
      let productPriceDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-price');
      let productVariantsDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-variants');
      let productMediaDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-media');
      let productTitleDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-title');
      let productRatingDrawer = SHTHelper.qs('.js-comparison-drawer .js-comp-drawer-rating');


      if (productVendorDrawer) productVendorDrawer.innerHTML = '';
      if (productDesDrawer) productDesDrawer.innerHTML = '';
      if (productTypeDrawer) productTypeDrawer.innerHTML = '';
      if (productTagsDrawer) productTagsDrawer.innerHTML = '';
      if (productPriceDrawer) productPriceDrawer.innerHTML = '';
      if (productVariantsDrawer) productVariantsDrawer.innerHTML = '';
      if (productTitleDrawer) productTitleDrawer.innerHTML = '';
      if (productMediaDrawer) productMediaDrawer.innerHTML = '';
      if (productRatingDrawer) productRatingDrawer.innerHTML = '';

      if (mainProductCompare) {
        const observer = new MutationObserver(() => {
          let productVendors = SHTHelper.qsa('.js-prd-cp-vendor');
          let productDescriptions = SHTHelper.qsa('.js-prd-cp-des');
          let productTypes = SHTHelper.qsa('.js-prd-cp-type');
          let productTags = SHTHelper.qsa('.js-prd-cp-tags');
          let productPrice = SHTHelper.qsa('.js-prd-cp-price');
          let productVariants = SHTHelper.qsa('.js-prd-cp-variants');
          let productMedias = SHTHelper.qsa('.js-prd-cp-media');
          let productTitles = SHTHelper.qsa('.js-prd-cp-title');
          let productRatings = SHTHelper.qsa('.js-prd-cp-rating');
          const updateDrawers = () => {
            if (productVendorDrawer) this.applyStylesAndAppend(productVendors, productVendorDrawer);
            if (productDesDrawer) this.applyStylesAndAppend(productDescriptions, productDesDrawer);
            if (productTypeDrawer) this.applyStylesAndAppend(productTypes, productTypeDrawer);
            if (productTagsDrawer) this.applyStylesAndAppend(productTags, productTagsDrawer);
            if (productPriceDrawer) this.applyStylesAndAppend(productPrice, productPriceDrawer);
            if (productVariantsDrawer) this.applyStylesAndAppend(productVariants, productVariantsDrawer);
            if (productTitleDrawer) this.applyStylesAndAppend(productTitles, productTitleDrawer);
            if (productRatingDrawer) this.applyStylesAndAppend(productRatings, productRatingDrawer);
            if (productMediaDrawer) {
              productMedias.forEach(media => {
                const mediaClone = media.cloneNode(true);
                const removeButton = document.createElement('button');
                removeButton.classList.add('btn', 'btn-icon-m', 'js-remove-product-drawer-button', 'btn-secondary', 'btn-remove-product');
                removeButton.innerHTML = `
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.22797 6.22702C6.52086 5.93413 6.99574 5.93413 7.28863 6.22703L12.0009 10.9393L16.7132 6.22703C17.0061 5.93413 17.481 5.93413 17.7739 6.22702C18.0668 6.51991 18.0668 6.99479 17.7739 7.28768L13.0616 12L17.7739 16.7123C18.0668 17.0052 18.0668 17.48 17.7739 17.7729C17.481 18.0658 17.0061 18.0658 16.7132 17.7729L12.0009 13.0607L7.28863 17.7729C6.99574 18.0658 6.52086 18.0658 6.22797 17.7729C5.93508 17.48 5.93508 17.0052 6.22797 16.7123L10.9403 12L6.22797 7.28768C5.93508 6.99479 5.93508 6.51992 6.22797 6.22702Z" fill="currentColor"/>
                  </svg>`;

                mediaClone.appendChild(removeButton);
                productMediaDrawer.appendChild(mediaClone);

                removeButton.addEventListener('click', (e) => {
                  const getProductId = e.target.closest('[data-product-id]').getAttribute('data-product-id');
                  const allProductId = SHTHelper.qsa(`div.prd-cp-item[data-product-id="${getProductId}"]`);

                  allProductId.forEach(item => item.remove());
                  this.removeProductIndrawer(getProductId);
                  this.updateLayoutDrawer();

                  const arraysProduct = this.getArrayFromLocalStorage();
                  if (arraysProduct.length == 1) {
                    SHTHelper.qs('.js-comparison-drawer').classList.remove("is-active");
                    document.body.classList.remove("o-hidden");
                  }
                });
              });
            }
          };

          updateDrawers();
          observer.disconnect();
          resolve();
        });

        mainProductCompare.innerHTML = '';
        observer.observe(mainProductCompare, { childList: true, subtree: true });
      }
      this.updateLayoutDrawer();
    });
  }

  updateLayoutDrawer() {
    const arraysProduct = this.getArrayFromLocalStorage();
    let mainComparisonDrawer = SHTHelper.qs('.js-comp-drawer-body');
    if (arraysProduct.length == 2) {
      mainComparisonDrawer?.style.setProperty('--block-size', 6);
    } else {
      mainComparisonDrawer?.style.setProperty('--block-size', 4);
    }
  }

  removeProductIndrawer(productId) {
    let arraysProduct = this.getArrayFromLocalStorage();
    if (arraysProduct) {
      this.removeStateProduct(productId);

      const productIndex = arraysProduct.findIndex(product => product.id === productId);
      if (productIndex !== -1) {
        arraysProduct.splice(productIndex, 1);
      }

      this.updateLocalStorage(arraysProduct);
      this.updateStickyCompare(arraysProduct.length);
    }

    this.processDataProductDrawer();
    if(arraysProduct.length == 0) this.closeModalCompare();

  }

  applyStylesAndAppend(elements, drawer) {
    elements.forEach(element => {
      drawer.innerHTML += element.outerHTML;
    });
  }

  checkProductFromLocalStorage() {
    this.productsArray = this.getArrayFromLocalStorage() || [];
    // if(this.productsArray.length > 0) {
    //   this.showModal();
    // }
  }

  removeProductWhenAddCompare(productID, buttonID) {
    const productContainer = [...this.body.children].find(div => div.dataset.product === productID);

    const productCompareID = buttonID

    if (productContainer) {
      productContainer.remove();

      this.removeStateProduct(productCompareID);

      this.removeProductFromArray(productID);
      this.updateLocalStorage(this.productsArray);
      this.updateStickyCompare(this.productsArray.length);


      if (this.productsArray.length === 0) this.closeModalCompare();
    }
  }

  showModalCompare() {
    if (!this.dialogCompare.classList.contains("is-active")) {
      this.dialogCompare.classList.add("is-active");
      this.dialogCompare.classList.remove("hidden-xs");
      this.dialogCompare.removeAttribute('hidden');
      this.processData();
    }
  }

  fetchProductHTML(url) {
    return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        const productElement = responseHTML.querySelector(".section-product-compare");

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        return productElement.innerHTML;
      });
  }

  processData() {
    let arraysProduct = this.getArrayFromLocalStorage();
    if (!arraysProduct) return Promise.resolve();
  
    const existingProductsSet = new Set(
      Array.from(this.body.children).map(div => div.dataset.product)
    );
  
    const urls = arraysProduct.map(product => `${product.url}?view=product-compare`);
  
    return Promise.all(urls.map(url => this.fetchProductHTML(url).catch(error => {
      console.error(`Failed to fetch product from ${url}:`, error);
      return null;
    })))
    .then(productHTMLs => {
      productHTMLs.forEach((productHTML, index) => {
        if (!productHTML) return;

        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = productHTML;
        const productContainer = tempContainer.firstElementChild;
        const productId = productContainer.dataset.product;
  
        const removeButton = document.createElement('button');
        removeButton.classList.add('btn', 'btn-icon-m', 'js-remove-product-button', 'bg-transparent');
        removeButton.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.22797 6.22702C6.52086 5.93413 6.99574 5.93413 7.28863 6.22703L12.0009 10.9393L16.7132 6.22703C17.0061 5.93413 17.481 5.93413 17.7739 6.22702C18.0668 6.51991 18.0668 6.99479 17.7739 7.28768L13.0616 12L17.7739 16.7123C18.0668 17.0052 18.0668 17.48 17.7739 17.7729C17.481 18.0658 17.0061 18.0658 16.7132 17.7729L12.0009 13.0607L7.28863 17.7729C6.99574 18.0658 6.52086 18.0658 6.22797 17.7729C5.93508 17.48 5.93508 17.0052 6.22797 16.7123L10.9403 12L6.22797 7.28768C5.93508 6.99479 5.93508 6.51992 6.22797 6.22702Z" fill="currentColor"/>
        </svg>`;
  
        productContainer.appendChild(removeButton);
        removeButton.addEventListener('click', () => {
          this.removeProduct(productContainer, removeButton, index);
        });
  
        if (!existingProductsSet.has(productId)) {
          const existingProductDiv = Array.from(this.body.children).find(
            div => div.dataset.product === productId
          );
          if (existingProductDiv) {
            this.body.replaceChild(productContainer, existingProductDiv);
          } else {
            this.body.appendChild(productContainer);
          }
          existingProductsSet.add(productId);
        }
      });
  
      this.executeScriptElements(this.body);
      if (window.SHTProductMediaItemModel) {
        window.SHTProductMediaItemModel.loadShopifyXR();
      }
    })
    .catch(error => {
      console.error('One of the promises failed:', error);
    });
  }

  removeProduct(productContainer, removeButton, index) {
    const productId = removeButton.parentNode.dataset.product;
    productContainer.remove();

    let arraysProduct = this.getArrayFromLocalStorage();
    if (arraysProduct) {
      this.removeStateProduct(productId);

      const productIndex = arraysProduct.findIndex(product => product.id === productId);
      if (productIndex !== -1) {
        arraysProduct.splice(productIndex, 1);
      }

      this.updateLocalStorage(arraysProduct);
      this.updateStickyCompare(arraysProduct.length);
    }

    this.processDataProductDrawer();

    if(arraysProduct.length == 0) this.closeModalCompare();
  }

  addProductToArray(productID, productUrl) {
    let product = { id: productID, url: productUrl };
    if (!this.checkProductValid(productID, this.productsArray)) {
      this.productsArray.push(product);
      this.updateLocalStorage(this.productsArray);
    }
  }

  removeProductFromArray(productID) {
    this.productsArray = this.productsArray.filter(product => product.id !== productID);
    this.updateLocalStorage(this.productsArray);
  }

  closeModalCompare() {
    if (this.dialogCompare.classList.contains("is-active")) {
      void this.dialogCompare.offsetHeight;
      this.dialogCompare.classList.add("drawer-out");
      setTimeout(() => {
        this.dialogCompare.classList.remove("is-active");
        this.dialogCompare.classList.replace("drawer-out", "hidden-xs");
        this.dialogCompare.setAttribute('hidden', true);
      }, 300);
    }
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach(scriptElement => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach(attribute => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }

  checkProductValid(productID, productsArray) {
    return productsArray.some(product => product.id === productID);
  }

  updateLocalStorage(products) {
    localStorage.setItem('sht-compare-product', JSON.stringify(products));
  }

  getArrayFromLocalStorage() {
    let arrayLocalStorage = localStorage.getItem('sht-compare-product');
    return JSON.parse(arrayLocalStorage);
  }

  updateStickyCompare(counter) {
    if (counter >= 1) {
      this.stickyCompareBtn?.classList.remove('d-none-important', 'hide-btn-compare');
      this.stickyCompareBtnsWrapper?.classList.remove('d-none-md');
    } else {
      this.stickyCompareBtn?.classList.add('d-none-important', 'hide-btn-compare');
      this.stickyCompareBtnsWrapper?.classList.add('d-none-md');
    }

    if (counter == 1) {
      this.btnShowProducts?.setAttribute('disabled', 'disabled');
    } else {
      this.btnShowProducts?.removeAttribute('disabled');
    }
    this.productCounter.forEach((btn) => {
      btn.innerText = counter;
    })
  }

  updateStatesProduct(arraysProduct) {
    if (!arraysProduct) return;
    const arrayLength = arraysProduct.length;

    arraysProduct.forEach((product) => {
      this.$$(`.js-btn-add-to-compare[data-product-id="${product.id}"]`).forEach((btn) => {
        btn.classList.add('active');
      });
    });

    this.updateStickyCompare(arrayLength);
  }

  clearAllProducts() {
    this.$$('.js-btn-add-to-compare').forEach(btn => {
      btn.classList.remove('active');
    })
  }

  removeStateProduct(productId) {
    this.$$(`.js-btn-add-to-compare[data-product-id="${productId}"]`).forEach((btn) => {
      btn.classList.remove('active');
    })
  }

  throttle(func, delay) {
    let timeoutId;              // Holds the ID of the timeout (if needed)
    let lastExecutionTime;      // Records the timestamp of the last execution of `func`

    return function (...args) {
      const context = this;

      if (!lastExecutionTime) {
        func.apply(context, args);
        lastExecutionTime = Date.now();
      } else {
        // Clear any existing timeout to set a new delay if needed
        clearTimeout(timeoutId);

        // Schedule `func` execution if the delay hasn't passed since last execution
        timeoutId = setTimeout(function () {
          if ((Date.now() - lastExecutionTime) >= delay) {
            func.apply(context, args);
            lastExecutionTime = Date.now(); // Update last execution time
          }
        }, delay - (Date.now() - lastExecutionTime)); // Remaining time until next allowed execution
      }
    };
  }
}
customElements.define("sht-collections-compare", SHTCollectionCompare);

class SHTHandleViewCompare extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    this.btnShowProducts = SHTHelper.qs('.js-btn-compare');
    this.newDom = SHTHelper.qs('sht-collections-compare');
    this.readMore = SHTHelper.qs('sht-read-more');

    if (this.btnShowProducts) {
      this.btnShowProducts.addEventListener("click", async () => {
        await this.newDom.processDataProductDrawer();
        await this.newDom.switchDataProduct();

        setTimeout(() => {
            this.newDom.showComparisonDrawer(this.btnShowProducts);
            this.readMore?.init();
        }, 500);
      });
    } else {
        console.error("btnShowProducts or newDom is not found.");
    }
}

}
customElements.define("sht-view-compare", SHTHandleViewCompare);

class SHTToggleBtnCompare extends SHTCustomComponent {
  constructor() {
    super();
    this.iconSwitch = this.$('.js-icon-switch');
    this.isChecked = this.iconSwitch.checked;
    if (!this.iconSwitch) return
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (this.iconSwitch) {
      this.iconSwitch.addEventListener('click', () => {
        this.toggleState();
      });

      this.iconSwitch.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleState();
        }
      });
    }
  }

  toggleState() {
    this.isChecked = !this.isChecked;
    this.iconSwitch.toggleAttribute('checked');
    this.iconSwitch.checked = this.isChecked;
    this.isChecked ? this.iconSwitch.classList.add('is-active') : this.iconSwitch.classList.remove('is-active');
    this.iconSwitch.setAttribute('aria-checked', this.isChecked);
    this.iconSwitch.setAttribute('aria-checked', this.isChecked);
  }
}
customElements.define("sht-toggle-btn-compare", SHTToggleBtnCompare);

/* Color Swatch*/

class SHTMainProductVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-prd-variant-swtch", SHTMainProductVariantSwatch);

class SHTMainProductVariantSwatchWSelect extends SHTColorSwatch {}

customElements.define("sht-prd-variant-swtch-w-select", SHTMainProductVariantSwatchWSelect);

class SHTProductQuickViewVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-prd-qck-vw-variant-swtch", SHTProductQuickViewVariantSwatch);

class SHTMainCollectionProductVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-coll-prd-variant-swtch", SHTMainCollectionProductVariantSwatch);

class SHTFeaturedProductVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-featured-prd-variant-swtch", SHTFeaturedProductVariantSwatch);

class SHTMainSearchVariantSwatch extends SHTColorSwatch {}

customElements.define("sht-srch-variant-swtch", SHTMainSearchVariantSwatch);

class SHTCustomSortField extends HTMLElement {
  constructor() {
    super();
    this.radioSortBtns = SHTHelper.qsa(".js-sort-field-item");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radioSortBtns = SHTHelper.qsa(".js-sort-field-item");
    this.radioSortBtns.forEach((radio) => {
      radio.addEventListener("click", (event) => {
        this.handleRadioFieldMobile(event, radio);
      });
    });
  }

  handleRadioFieldMobile(event, radio) {
    this.sortByFieldHidden = SHTHelper.qs(".js-collection-product-sort-by-field-hidden");
    const elementRadio = radio.querySelector(".js-sort-field-radio");
    this.deletedAllCheckbox();
    this.addCheckbox(radio);
    if (this.sortByFieldHidden) {
      this.sortByFieldHidden.value = elementRadio.dataset.value;
      this.sortByFieldHidden.dispatchEvent(
        new Event("input", { bubbles: true })
      );
    }
  }

  addCheckbox(radio) {
    radio.classList.add('checked');
  }

  deletedAllCheckbox() {
    this.radioSortBtns.forEach((radio) => {
      radio.classList.remove('checked');
    });
  }
}

customElements.define('sht-custom-sort-field', SHTCustomSortField);

class SHTShowAllOption extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.dataStepExpand = parseInt(this.dataset.stepExpand);
    this.btn = this.$(".js-expandable-content-btn");

    if (this.dataStepExpand == 0) return;

    this.visibilityShowMore();
    this.hidenFilterItem();
    this.bindEventHandlers();
  }

  visibilityShowMore() {
    if (this.querySelectorAll('.filter-form__item').length > this.dataStepExpand) {
      this.btn.parentElement.classList.remove("d-none");
    }
  }
  hidenFilterItem() {
    this.querySelectorAll('.filter-form__item').forEach((ele, index) => {
      if (index + 1 > this.dataStepExpand) {
        ele.classList.add('d-none-important');
      }
    })
  }

  bindEventHandlers() {
    this.btn.addEventListener("click", e => {
      this.querySelectorAll('.filter-form__item').forEach((ele, index) => {
        ele.classList.remove('d-none-important');
        this.btn.parentElement.classList.add("d-none");
      })
    })
  }
}
customElements.define("sht-show-all-options", SHTShowAllOption);

class SHTLoadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.loadMoreBtn = this.querySelector(".js-load-more");
    this.renderContainer = SHTHelper.qid("collectionProductGrid");
    this.compare = SHTHelper.qs('sht-collections-compare');
    this.spinnerLoading = this.querySelector(".js-spinner-loading");
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.addEventListener("click", this.loadMoreItems);
  }

  loadMoreItems() {
    this.loadMoreBtn.setAttribute("disabled", true);
    this.spinnerLoading.classList.remove('d-none-important');

    let { currentPage, pageSize, nextUrl, totalItems } = this.dataset;
    let nextPage = parseInt(this.dataset.currentPage) + 1;

    fetch(nextUrl.replace(/page=[0-9]+/, "page=" + nextPage))
      .then(response => response.text())
      .then(responseText => {
        const currentItemCount = this.renderContainer.children.length;

        const html = responseText;
        let htmlContent = document.createElement("div");
        htmlContent.innerHTML = html;
        let newContent = htmlContent.querySelector("#collectionProductGrid").innerHTML;
        this.renderContainer.insertAdjacentHTML("beforeend", newContent);

        const newItems = Array.from(this.renderContainer.children).slice(currentItemCount);

        newItems.forEach((item, index) => {
          item.style.setProperty('--animation-order', index);

          requestAnimationFrame(() => {
            item.classList.add('load-more-item--visible');
          });
        });

        this.compare?.init();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.loadMoreBtn.removeAttribute("disabled");
        this.spinnerLoading.classList.add('d-none-important');
        this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;

        let isLastPage = parseInt(totalItems) - nextPage * parseInt(pageSize) < 0;
        if (isLastPage) {
          this.loadMoreBtn.classList.add("d-none-important");
          this.innerHTML = this.dataset.label;
        }
      });
  }
}

customElements.define("sht-load-more", SHTLoadMore);

class SHTReadMore extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.contents = this.$$(".js-comp-drawer-des .js-expandable-content");
    this.btns = this.$$(".js-comp-drawer-des .js-expandable-content-btn");

    this.contents.forEach((content, index) => {
      const btn = this.btns[index];

      if (content.scrollHeight > content.clientHeight) {
        content.setAttribute("data-expanded", "false");
        content.classList.add("expandable-content--expandable");
      } else {
        content.setAttribute("data-expanded", "true");
      }

      btn.addEventListener("click", () => {
        let clientHeight = content.scrollHeight;

        if (content.getAttribute("data-expanded") == "true") {
          content.setAttribute("data-expanded", "false");
          content.style.maxHeight = "120px";
          btn.innerHTML = btn.getAttribute("data-view-more");
        } else {
          content.setAttribute("data-expanded", "true");
          content.style.maxHeight = `${clientHeight}px`;
          btn.innerHTML = btn.getAttribute("data-view-less");
        }
      });
    });
  }
}

customElements.define("sht-read-more", SHTReadMore);

class SHTShareProductButton extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.webShareApiContainer = this.$(`.js-web-share-api-container`);
    this.webShareApiButton = this.$(`.js-web-share-api-btn`);

    this.noneWebShareApiContainer = this.$(`.js-none-web-share-api-container`);
    this.noneWebShareApiButton = this.$(`.js-none-web-share-api-btn`);

    this.copyLinkButton = this.$(`.js-social-share-copy-link`);
    this.init();
  }

  init() {
    if (navigator.share) {
      this.webShareApiContainer.removeAttribute("hidden");
      this.webShareApiButton.addEventListener("click", () => {
        navigator
          .share({
            url: this.dataset.productUrl,
            title: document.title,
          })
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(console.error);
      });
    } else {
      this.noneWebShareApiContainer.removeAttribute("hidden");
      this.copyLinkButton.addEventListener("click", e => {
        this.copyToClipboard(e.currentTarget);
      });
    }
  }

  copyToClipboard(e) {
    navigator.clipboard.writeText(this.dataset.productUrl).then(() => {
      e.querySelector(".js-social-share-copy-link-label").textContent = e.dataset.linkCopiedToClipboard;
    });
  }
}
customElements.define("sht-share-prd-btn", SHTShareProductButton);

class SHTReadMoreLine extends SHTCustomComponent {
  constructor() {
    super();
    this.content = this.$('.js-expandable-content');
    this.button = this.$('.js-expandable-content-btn');
    this.isTruncateEnabled = this.dataset.truncateEnabled;

    this.init();
  }

  init() {
    if (this.isTruncateEnabled == 'true' && this.content.scrollHeight > this.getMaxHeight()) {
      this.content.classList.add('card__excerpt');
      this.button.classList.remove('d-none-important');

      this.button.addEventListener('click', () => {
        this.isExpanded = this.content.getAttribute("data-expanded");

        if (this.isExpanded == 'true') {
          this.content.classList.remove('expanded');
          this.content.setAttribute('data-expanded', 'false');
          this.button.innerText = this.button.getAttribute('data-view-more');
        } else {
          this.content.classList.add('expanded');
          this.content.style.maxHeight = 'none';
          this.content.setAttribute('data-expanded', 'true');
          this.button.innerText = this.button.getAttribute('data-view-less');
        }
      });
    } else {
      if (!this.button.classList.contains('d-none-important')) this.button.classList.add('d-none-important');
    }
  }

  getMaxHeight() {
    return parseInt(getComputedStyle(this).lineHeight) * 3;
  }
}

customElements.define('sht-read-more-line', SHTReadMoreLine);

class SHTMap extends SHTCustomComponent {
  constructor() {
    super();
    this.iframe = this.$(".js-map-iframe");
    this.bindEventHandlers();
  }

  loadIframeContent() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.dispatchEvent(
              new CustomEvent("loadingStart", {
                detail: {
                  ele: this.iframe,
                  parent: this,
                },
              })
            );
            this.execute();
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -100px 0px",
      }
    );
    observer.observe(this);
  }

  bindEventHandlers() {
    this.iframe.addEventListener(
      "load",
      function () {
        this.dispatchEvent(
          new CustomEvent("loadingEnd", {
            detail: {
              ele: this.iframe,
              parent: this,
            },
          })
        );
        this.setAttribute("loaded", true);
      }.bind(this)
    );
  }

  execute() {
    this.setIframeSrc();
  }

  setIframeSrc() {
    let url = `https://maps.google.com/maps?z=${this.dataZoom}&t=${this.dataType}&q=${this.dataLocation.replace(/"/g, "")}&ie=UTF8&&output=embed`;
    this.iframe.src = url;
    this.iframe.removeAttribute("srcdoc");
  }

  static get observedAttributes() {
    return ["data-zoom", "data-type", "data-location"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (Shopify.designMode) {
        this.execute();
      } else {
        this.loadIframeContent();
      }
    }
  }

  get dataZoom() {
    return this.getAttribute("data-zoom");
  }

  get dataType() {
    return this.getAttribute("data-type");
  }

  get dataLocation() {
    return this.getAttribute("data-location");
  }

  set dataZoom(newValue) {
    this.setAttribute("data-zoom", newValue);
  }

  set dataType(newValue) {
    this.setAttribute("data-type", newValue);
  }

  set dataLocation(newValue) {
    this.setAttribute("data-location", newValue);
  }
}
customElements.define("sht-map", SHTMap);

class SHTCarouselItem extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    let observe = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          let target = entry.target;

          if (entry.isIntersecting) {
            if (target.dataset.attributePlaceholder === "1") {
              target.setAttribute("aria-hidden", false);
              target.setAttribute("aria-disabled", false);
            }
            observer.unobserve(target);
          }
        });
      },
      {
        root: this.closest("sht-carousel"),
        // threshold: 0.1,
      }
    );

    observe.observe(this);
  }
  connectedCallback() {
    this.init();
  }
}

customElements.define("sht-carousel-itm", SHTCarouselItem);

var VAR_LOCALIZATION_CACHE = new Map();
class SHTLocalization extends SHTCustomComponent {
  constructor() {
    super();
  }

  async init() {
    if (Shopify.designMode) {
      await this.getSearchResults();
    } else {
      const handleIntersection = async (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        await this.getSearchResults();

        observer.unobserve(this);
      };

      new IntersectionObserver(handleIntersection.bind(this), { threshold: 0.25 }).observe(this);
    }
  }

  async getSearchResults() {
    SHTHelper.loadScript(
      this.dataset.jsFileId,
      this.dataset.jsFile,
      async function () {
        let key = this.dataset.url.replace(/\s/g, "-").toLowerCase();
        let cached = VAR_LOCALIZATION_CACHE.get(key);

        if (!cached) {
          let markup = await this.fetchResults();
          VAR_LOCALIZATION_CACHE.set(key, markup);

          this.innerHTML = markup;
        } else {
          this.innerHTML = cached;
        }
      }.bind(this)
    );
  }

  async fetchResults() {
    let results = fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const languages = html.querySelector(`#${this.dataset.sectionId}`);
        if (languages && languages.innerHTML.trim().length) {
          //this.innerHTML = languages.innerHTML;

          return languages.innerHTML;
        }
        return "";
      })
      .catch(e => {
        console.error(e);
        return "";
      });

    return results;
  }

  connectedCallback() {
    this.init();
  }
}

customElements.define("sht-localization", SHTLocalization);

class SHTMenuHeader extends SHTCustomComponent {
  constructor() {
    super();
    this.closeTimeout = null;
  }

  connectedCallback() {
    this.init();
    this.handleOnLinkClick();
    if (this.isMegaMenu === false && this.isDesktop) {
      this.initSubmenuPositioning();
    }
  }

  initSubmenuPositioning() {
    this.resizeObserver = new ResizeObserver(this.checkSubmenuPositions.bind(this));
    this.resizeObserver.observe(document.body);

    this.checkSubmenuPositions();
  }

  checkSubmenuPositions() {
    const dropdowns = this.$$('.menu-dropdown-lv2');

    dropdowns.forEach(dropdown => {
      const parentItem = dropdown.closest('.menu__item');
      if (!parentItem) return;

      const parentRect = parentItem.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      const spaceRight = viewportWidth - parentRect.right;

      const dropdownWidth = dropdown.offsetWidth;

      const nestedDropdown = dropdown.querySelector('.menu-dropdown-lv3');
      const nestedDropdownWidth = nestedDropdown ? nestedDropdown.offsetWidth : 0;

      const totalRequiredWidth = dropdownWidth + nestedDropdownWidth;

      dropdown.classList.remove('menu-dropdown--right');

      if (spaceRight <= totalRequiredWidth) {
        dropdown.classList.add('menu-dropdown--right');
      }
    });
  }

  init() {
    this.header = SHTHelper.qs(`sht-header`);
    this.triggerBtnElement = SHTHelper.qs(".js-menu-drawer-trigger");
    this.details = this.$("details");
    this.summaries = this.$$("summary");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;
    this.links = this.summary.querySelectorAll('.menu__link__link');
    this.level_one_btn = this.$$(`.js-menu-header-back-btn[data-level="1"]`);
    this.level_two_btn = this.$$(`.js-menu-header-back-btn[data-level="2"]`);
		this.level_third_btn = this.$$(`.js-menu-header-back-btn[data-level="3"]`);
    this.dropdownType = this.header.dataset.menuDropdownOpenType;
    this.overlay = this.$("overlay");
    this.menuOverlay = this.$(".js-menu-overlay");
    this.isMegaMenuShow = false;
    this.isMegaMenu = this.dataset.menuDropdownType === 'Megamenu';
    this.isDesktop = window.matchMedia("(min-width: 1195px)").matches;

    this.summaries.forEach(summary => {
        const details = summary.closest("details");
        summary.addEventListener("click", event => {
            event.preventDefault();
            this.handleSummaryClick(event, summary, details);
        });
        summary.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
    });

    if (this.dropdownType === 'hover') {
      this.addHoverEventListeners();
    }
    if (this.menuOverlay) {
      if (this.menuOverlay.clientHeight < this.menuOverlay.querySelector(".megamenu-container").clientHeight) {
        this.overlay.classList.add("menu-overlay");
      } else {
        this.overlay.classList.remove("menu-overlay");
      }
      this.menuOverlay.addEventListener('scroll', () => {
        if (Math.ceil(this.menuOverlay.scrollTop + this.menuOverlay.clientHeight) >= this.menuOverlay.scrollHeight) {
          this.overlay.classList.remove("menu-overlay");
        } else {
          this.overlay.classList.add("menu-overlay");
        }
      });
    }

    this.bindEventHandlers();
  }

  handleMegamenuContainerOverlay() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.overlay?.classList.remove("menu-overlay");
        }
      });
    }, {
      threshold: 1
    });
    observer.observe(this.menuOverlay?.querySelector('.js-megamenu-container'));
  }

  handleSummaryClick(event, summary, details) {
    if(this.menuOverlay?.querySelector('.js-megamenu-container')) {
      this.handleMegamenuContainerOverlay();
    }
    const megaMenu = details.querySelector('.js-mega-menu-wrapper');
    let megaMenuType = '';
    const isLevelOne = details.dataset.level === "1";
    const isLevelTwo = details.dataset.level === "2";
    event.currentTarget.setAttribute("aria-expanded", !details.open);
    if(megaMenu) {
      megaMenuType = megaMenu.dataset.megaMenuType;
    }
    if (isLevelOne || isLevelTwo) {
      this.summaries.forEach(otherSummary => {
        const otherDetails = otherSummary.closest("details");
        if (otherDetails.dataset.level === "2" && otherDetails !== details) {
          otherDetails.classList.remove("is-open");
          setTimeout(() => { otherDetails.open = false; }, 100);
        }
      });
    }

    if (isLevelOne) {
      this.closeAllMenu();
      if (megaMenuType !== 'drawer') {
        event.stopPropagation();
      }
    }
    if (!details.hasAttribute("open") && !this.menuOpen) {
      this.open();
      details.open = true;
      setTimeout(() => {
        details.classList.add("is-open");
        const dropdown = details.querySelector('.js-header-menu-wrapper');
        if (dropdown) {
          void dropdown.offsetHeight;
          dropdown.classList.remove('animated-out', 'animated');
          document.body.classList.remove('animated-out', 'animated');
          dropdown.classList.add('animated');
          document.body.classList.add('animated');
        }
        if (!this.isMegaMenu && this.isDesktop) {
          this.checkSubmenuPositions();
        }
      }, 0);
      document.body.classList.toggle('is-megamenu-show', this.dataset.menuDropdownType === 'Megamenu');
    } else {
      const dropdown = details.querySelector('.js-header-menu-wrapper');
      if (dropdown) {
        void dropdown.offsetHeight;
        dropdown.classList.remove('animated');
        dropdown.classList.add('animated-out');
        document.body.classList.add('animated-out');
        document.body.classList.remove('animated');
        setTimeout(() => {
          dropdown.classList.remove('animated-out');
          document.body.classList.remove('animated-out', 'animated', 'is-megamenu-show');
          summary.setAttribute("aria-expanded", false);
          details.classList.remove("is-open");
          details.open = false;
        }, 300);
      }
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  addHoverEventListeners() {
    this.summaries.forEach(summary => {
      if (!summary.closest('sht-header')) return;
      const details = summary.closest('details');
      const megaMenu = details.querySelector('.js-mega-menu-wrapper');
      ['mouseenter', 'mouseleave'].forEach(event => {
        details.addEventListener(event, this.onHandleMouseEvent.bind(this));
        if(megaMenu) {
          megaMenu.addEventListener(event, this.onHandleMouseEvent.bind(this));
        }
      });
    });
  }


  bindEventHandlers() {
    // Common event handler function for both level_one_btn and level_two_btn
    const handleClick = (el) => {
      const details = el.currentTarget.closest("details");
      const summary = details.querySelector("summary:first-child");
      summary.setAttribute("aria-expanded", !details.open);
      if (details.hasAttribute("open")) {
        details.classList.toggle("is-open", !details.open);
        setTimeout(() => {
          details.open = false;
        }, 100);
        if (details.dataset.level === "1") {
          this.header.classList.remove("header-menu--open");
          this.menu_body_drawer?.classList.remove("menu--is-open");
        }
        summary.focus();
      }
    };

    // Bind click event handlers to both level_one_btn and level_two_btn
    [...this.level_one_btn, ...this.level_two_btn, ...this.level_third_btn].forEach(e => {
      e.addEventListener("click", handleClick);
    });
  }
  handleOnLinkClick() {
    this.links.forEach(link => {
      link.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
  }
  onHandleMouseEvent(event) {
    const details = this.querySelector('details');
    const megaMenu = details.querySelector('.js-mega-menu-wrapper');
    let megaMenuType = '';
    let detailLevel = event.target.closest('details').dataset.level;
    if(megaMenu) {
      megaMenuType = megaMenu.dataset.megaMenuType;
    }
    if(megaMenuType === 'drawer') {
      const summary = megaMenu.closest('details').querySelector('summary');
      const link = summary.querySelector('.js-menu-link');
      const link_title = summary.querySelector('.js-menu-link-title');
      link.classList.replace('d-block', 'd-none');
      link_title.classList.replace('d-none', 'd-block');
    }
    if (megaMenu && event.relatedTarget && event.type === 'mouseleave' &&
        (details.contains(event.relatedTarget) || megaMenu.contains(event.relatedTarget))) {
      return;
    }

    if(!megaMenu && detailLevel === '2') {
      const detailsLevel2 = event.target.closest('details');
      this.handleDetailsMouseEvent(event, detailsLevel2, megaMenuType, megaMenu);
    }
    this.handleDetailsMouseEvent(event, details, megaMenuType, megaMenu);
    if(this.menuOverlay?.querySelector('.js-megamenu-container')) {
      this.handleMegamenuContainerOverlay();
    }
  }

  handleDetailsMouseEvent(event, details, megaMenuType, megaMenu) {
    if(event.type == 'mouseenter' && megaMenuType !== 'drawer') {
      this.toggleMenu(true, details);
    } else if (event.type == 'mouseleave' && !details.contains(event.relatedTarget) && !megaMenu?.contains(event.relatedTarget) && megaMenuType !== 'drawer') {
      this.toggleMenu(false, details);
    }
  }

  toggleMenu(open, details) {
    this.isMegaMenuShow = open;
    const dropdown = details.querySelector('.js-header-menu-wrapper');
    let summary = details.querySelector("summary");

    if (open) {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
      }
      this.closeAllMenu();
      if (dropdown) void dropdown.offsetHeight;

      details.classList.add('is-open');
      details.open = true;
      summary.setAttribute("aria-expanded", true);

      if (dropdown) {
        dropdown.classList.remove('animated-out');
        document.body.classList.remove('animated-out');
        dropdown.classList.add('animated');
        document.body.classList.add('animated');
      }

      document.body.classList.toggle('is-megamenu-show', this.dataset.menuDropdownType === 'Megamenu');
    } else {
      if (dropdown) {
        void dropdown.offsetHeight;
        dropdown.classList.remove('animated');
        dropdown.classList.add('animated-out');
        document.body.classList.add('animated-out');
        document.body.classList.remove('animated');
        this.closeTimeout = setTimeout(() => {
          dropdown.classList.remove('animated-out');
          document.body.classList.remove('animated-out');
          details.classList.remove('is-open');
          details.open = false;
          summary.setAttribute("aria-expanded", false);
          const megaMenus = document.querySelectorAll('details');
          const isAnyHovered = Array.from(megaMenus).some(menu => {
            const dataType = menu.querySelector('.js-mega-menu-wrapper')?.dataset.megaMenuType;
            return dataType === 'drawer' ? false : menu.matches(':hover');
          });
          if (!isAnyHovered && !this.isMegaMenuShow) {
            document.body.classList.remove('is-megamenu-show');
          }
        }, 300);
      }
    }
  }

  closeAllMenu() {
    let allSummaries = SHTHelper.qsa('sht-menu-header summary');
    let allDetails = Array.from(SHTHelper.qsa('sht-menu-header details')).filter(detail => {
      return !this.contains(detail);
    });
    allSummaries.forEach((summary) => {
      summary.setAttribute("aria-expanded", false);
    });
    allDetails.forEach((details) => {
      const dropdown = details.querySelector('.js-header-menu-wrapper');
      if (dropdown) {
        dropdown.classList.remove('animated');
        dropdown.classList.add('animated-out');
        setTimeout(() => dropdown.classList.remove('animated-out'), 300);
      }
      details.classList.toggle('is-open', false);
      details.open = false;
    });
  }

  onKeyUpEscEvent(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    let openedDetails = event.target.closest("details[open]");
    if (!openedDetails) return;
    const dropdown = openedDetails.querySelector('.js-header-menu-wrapper');
    if (dropdown) {
      dropdown.classList.remove('animated');
      dropdown.classList.add('animated-out');
      setTimeout(() => dropdown.classList.remove('animated-out'), 300);
    }
    document.body.removeEventListener("click", this.onBodyClick);
    let summary = openedDetails.querySelector("summary");
    if (openedDetails.dataset.level == "1") {
      if (!openedDetails.hasAttribute("open")) {
        this.header.classList.add("header-menu--open");
        this.menu_body_drawer?.classList.add("menu--is-open");
      } else {
        this.header.classList.remove("header-menu--open");
        this.menu_body_drawer?.classList.remove("menu--is-open");
      }
    }
    openedDetails.classList.remove("is-open");
    this.menu_body_drawer?.classList.remove("menu--is-open");
    setTimeout(() => {
      openedDetails.removeAttribute("open");
      summary.setAttribute("aria-expanded", false);
    }, 100);
    summary.focus();
  }

  close() {
    document.body.removeEventListener("click", this.handleBodyClick.bind(this));
    document.body.classList.remove('is-megamenu-show');

    if (this.details.dataset.level == "1") {
      if (this.details.hasAttribute("open")) {
        this.header.classList.remove("header-menu--open");
        this.menu_body_drawer?.classList.remove("menu--is-open");
      }
    }

    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      let details = summary.closest("details");
      const dropdown = details.querySelector('.js-header-menu-wrapper');
      if (dropdown) {
        dropdown.classList.remove('animated');
        dropdown.classList.add('animated-out');
        setTimeout(() => dropdown.classList.remove('animated-out'), 300);
      }
      details.classList.remove("is-open");
      setTimeout(() => {
        details.removeAttribute("open");
        summary.setAttribute("aria-expanded", false);
      }, 100);
    }
  }

  open() {
    document.body.addEventListener("click", this.handleBodyClick.bind(this));
  }

  handleBodyClick(event) {
    if(!this.contains(event.target)) this.close();
		// !event.target.closest('sht-menu-header[data-menu-dropdown-type="Megamenu"]') && this.close();
  }
}
customElements.define("sht-menu-header", SHTMenuHeader);


class SHTMenuDrawer extends SHTCoreDrawer {
  constructor() {
    super();
  }
  connectedCallback() {
    this.handleBindEvents();
  }
  handleBindEvents() {
    const button = SHTHelper.qs('sht-menu-drwer-opner');
    button.addEventListener("click", () => {
      this.summaries = this.querySelectorAll("summary");
      this.level_one_btn = this.querySelectorAll(`.js-menu-header-back-btn[data-level="1"]`);
      this.summaries.forEach(summary => {
        const details = summary.closest("details");
        summary.addEventListener("click", event => {
            event.preventDefault();
            this.handleSummaryMobileClick(event, details);
        });
      });
    const handleClick = () => {
      const headerNav = SHTHelper.qsa(".js-header-navigation");
      headerNav.forEach(nav => {
        nav.classList.remove("d-none-important");
      });
    };
    this.level_one_btn.forEach(e => {
      e.addEventListener("click", handleClick);
    });
    });
  }

  handleSummaryMobileClick(event, details) {
    if (details.dataset.level === "1") {
      const headerNav = SHTHelper.qsa(".js-header-navigation");
      const currentHeaderNav = event.target.closest('.js-header-navigation');
      headerNav.forEach(nav => {
        if(nav !== currentHeaderNav) {
          nav.classList.add("d-none-important");
        }
      });
    }
  }
}

customElements.define("sht-menu-drwer", SHTMenuDrawer);

class SHTMenuDrawerOpener extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.triggerBtnElement = this.$(".js-menu-drawer-trigger");
    this.menuDrawerElement = SHTHelper.qs("sht-menu-drwer");
    this.menuDrawerBodyElement = this.menuDrawerElement.querySelector(".js-menu-drawer-body");
    this.menuDrawerContentElements = SHTHelper.qsa(".js-menu-drawer-content");
    this.menuDrawerBodyContent = '';
    
    
    
    this.menuDrawerContentElements.forEach((contentElement) => {
      this.menuDrawerBodyContent += contentElement.innerHTML;
    });
    
    // Event listener to handle drawer opening
    this.triggerBtnElement.addEventListener("click", (e) => {
      this.menuDrawerBodyElement.innerHTML = this.menuDrawerBodyContent;
      this.removeColorSchemeMegamenuMobile();
      setTimeout(() => {
        this.menuDrawerElement.openDrawer(e.target);
      }, 0);
    });
  }
  removeColorSchemeMegamenuMobile() {
    this.megamenuWrappers = SHTHelper.qsa('.js-menu-drawer-body .js-mega-menu-wrapper');
    this.megamenuWrappers.forEach((megamenu) => {
      megamenu.classList.remove(megamenu.dataset.megaMenuColorScheme);
    })
  }
}

customElements.define("sht-menu-drwer-opner", SHTMenuDrawerOpener);


class SHTStickyHeader extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.shtHeaderElement = this.querySelector('.js-header');
    this.prodGridSection = SHTHelper.qs('.js-product-grid-section');
    this.header = SHTHelper.qs(".js-section-header");
    this.stickyProductGrid = SHTHelper.qs("sht-sticky-prodrid");
    this.headerTransparent = SHTHelper.qs(".shopify-section:first-child [enable-transparent-header]");
    this.sticky_state = this.dataset.stickyState;
    this.colorSchemaDefault = this.shtHeaderElement.dataset.color;
    this.colorSchemaSticky = this.shtHeaderElement.dataset.colorSticky;
    this.colorSchemaTransparent = this.shtHeaderElement.dataset.colorTransparent;
    this.originalHeaderPosition = this.header.offsetTop;
    this.boundingBottom = this.shtHeaderElement.offsetHeight + this.originalHeaderPosition;
    this.previousScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.currentScrollTop = 0;
    this.isHeaderHidden = false;
    this.isSticky = false;
    this.isHeaderTransparent = false;
    this.prevent_reveal = false;
    this.headerBounds = {};
    if(this.stickyProductGrid) {
      window.customElements.whenDefined('sht-sticky-prodrid').then(() => {
        this.stickyProductGrid.init();
      });
    }
    this.updateHeaderHeight();
    this.updateTransparentHeaderState();
    this.bindEventHandlers();
    // if (this.sticky_state == "false") return false;
    this.createObserver();
  }

  updateHeaderHeight() {
    SHTHelper.qde.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  connectedCallback() {
    this.init();
  }

  updateTransparentHeaderState() {
    this.headerTransparent = SHTHelper.qs(".shopify-section:first-child [enable-transparent-header]");

    if (this.headerTransparent) {
      this.isHeaderTransparent = true;
      // this.classList.add('header-sticky--transparent');
      this.setTransparentHeader();
    } else {
      this.isHeaderTransparent = false;
      // this.classList.remove('header-sticky--transparent');
      this.removeTransparentHeader();
    }
  }

  bindEventHandlers() {
    if (this.sticky_state == "false") return false;
    this.preventStickyHeaderReveal = () => (this.prevent_reveal = true);
    this.addEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal);
    window.addEventListener("scroll", this.onScrollHandle.bind(this), false);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.header_bounds = entries[0].intersectionRect;

      observer.disconnect();
    });

    observer.observe(this.header);
  }
  setTransparentHeader() {
    if(!this.isHeaderTransparent) return;
    this.shtHeaderElement.classList.remove(this.colorSchemaDefault);
    this.shtHeaderElement.classList.remove(this.colorSchemaSticky);
    this.shtHeaderElement.classList.add(this.colorSchemaTransparent);
    this.header.classList.add('header--transparent');
  }

  removeTransparentHeader() {
    if(this.colorSchemaDefault != this.colorSchemaTransparent) {
      this.shtHeaderElement.classList.remove(this.colorSchemaTransparent);
    }
    this.header.classList.remove('header--transparent');
  }
  setSchemeSticky() {
    this.shtHeaderElement.classList.remove(this.colorSchemaDefault);
    this.shtHeaderElement.classList.add(this.colorSchemaSticky);
  }

  setSchemeDefault() {
    this.shtHeaderElement.classList.remove(this.colorSchemaSticky);
    this.shtHeaderElement.classList.add(this.colorSchemaDefault);
    this.removeTransparentHeader();
  }

  onScrollHandle() {
    this.currentScrollTop = window.pageYOffset || SHTHelper.qde.scrollTop;
    if (this.sticky_state == "always_reveal") {
      if (this.currentScrollTop > this.originalHeaderPosition ) {
        this.isSticky = true;
        this.isHeaderTransparent = false;
        this.removeTransparentHeader();
        this.header.classList.add('header--sticky');
        this.setSchemeSticky();
        this.prodGridSection?.style.setProperty('--sticky-header-height', `${this.shtHeaderElement.offsetHeight}px`);
      } else {
        this.isSticky = false;
        this.header.classList.remove('header--sticky');
        if(this.headerTransparent) {
          this.isHeaderTransparent = true;
          this.setTransparentHeader();
        } else {
          this.setSchemeDefault();
        }
      }
      return;
    }

    if (!this.header_bounds) return;

    if(this.boundingBottom <= this.currentScrollTop) {
      this.hideHeader();
    }

    if (this.currentScrollTop > this.previousScrollTop && !this.isHeaderHidden && this.currentScrollTop > this.originalHeaderPosition) {
      this.hideHeader();
    }

    // If scrolling up, show the header
    if (this.currentScrollTop < this.previousScrollTop && this.isHeaderHidden) {
      this.showHeader();
      this.isHeaderTransparent = false
    }
    if (this.currentScrollTop > this.boundingBottom && !this.isSticky) {
      this.header.classList.add('header--fixed');
      this.setSchemeSticky();
      this.isSticky = true;
      this.isHeaderTransparent = false
      this.removeTransparentHeader();
    }
    if (this.currentScrollTop < this.originalHeaderPosition && this.isSticky || this.currentScrollTop == 0) {
      this.header.classList.remove('header--fixed');
      this.header.classList.remove('header--hidden', 'header--visible');
      if(this.headerTransparent) {
        this.isHeaderTransparent = true;
        this.setTransparentHeader()
      } else {
        this.setSchemeDefault();
      }
      this.isSticky = false;
    }
    this.previousScrollTop = this.currentScrollTop;
  }
  showHeader() {
    this.header.classList.add('header--visible');
    this.header.classList.remove('header--hidden');
    this.setSchemeSticky();
    this.isHeaderHidden = false;
  }
  hideHeader() {
    this.header.classList.add('header--hidden');
    this.header.classList.remove('header--visible');
    this.isHeaderHidden = true;
    this.isHeaderTransparent = false
    this.closeMenu();
  }

  closeMenu() {
    this.menus = this.header.querySelectorAll("sht-menu-header");
    this.menus.forEach(menu => menu.close());
  }

  disconnectedCallback() {
    this.removeEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal);
    window.removeEventListener("scroll", this.onScrollHandle.bind(this));
  }
}
customElements.define("sht-header-sticky", SHTStickyHeader);
class SHTHeader extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.btnSearchs = SHTHelper.qsa('.js-search-open-trigger');
    this.predictiveSearchDrawer = SHTHelper.qs("sht-search-drwr-section");
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.btnSearchs.forEach(btn => {
      btn.addEventListener('click', (e) => this.onBtnSearchClick(e, btn));
    });
    window.addEventListener('resize', () => {
      this.closeAllMenu();
      if (!window.matchMedia("(max-width: 1024px)").matches) {
        const headerNav = SHTHelper.qsa(".js-header-navigation");
        headerNav.forEach(nav => {
          nav.classList.remove("d-none-important");
        });
      }
    });
  }

  closeAllMenu() {
    let allSummaries = this.$$('summary');
    let allDetails = this.$$('details');
    allSummaries.forEach((summary) => {
      summary.setAttribute("aria-expanded", false);
    });
    allDetails.forEach((details) => {
      details.classList.toggle('is-open', false);
      details.open = false;
    });
    document.body.classList.remove(...['o-hidden', 'is-megamenu-show']);
  }

  onBtnSearchClick(event, btn) {
    event.preventDefault();
    if(btn?.dataset.event != 'page') {
      this.predictiveSearchDrawer.openDrawer(event.target);
      setTimeout(() => {
        SHTHelper.trapFocus(this.predictiveSearchDrawer, this.predictiveSearchDrawer.querySelector('.js-predictive-search-input'));
      }, 650);
    }
  }
}
// Register to the Browser from `customElements` API
customElements.define("sht-header", SHTHeader);
class SHTStickyProdGrid extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.stickyHeaderState = SHTHelper.qs('sht-header-sticky')?.dataset.stickyState;
    this.onScrollHandle = this.onScrollHandle.bind(this);
    this.stickyBarPotition = this.offsetTop;
    this.stickyHeight = this.offsetHeight;
    this.prodGridSection = SHTHelper.qs('.js-product-grid-section');
    this.prodGridSection?.style.setProperty('--prductgrid-bar-height', `${this.stickyHeight}px`);
    this.headerHeight = SHTHelper.qs(".js-section-header")?.offsetHeight
    this.prodgridToTop = this.stickyBarPotition - this.headerHeight
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    window.addEventListener("scroll", this.onScrollHandle, false);
  }

  onScrollHandle() {
    const scrollTop = window.pageYOffset || SHTHelper.qde.scrollTop;
    const hasStickyBarClass = this.classList.contains('product-grid-sticky-bar');
    const hasAlwaysRevealClass = this.classList.contains('always_reveal--sticky');

    if (this.stickyHeaderState === 'always_reveal') {
      if (scrollTop > this.prodgridToTop && !hasAlwaysRevealClass) {
        this.classList.add('always_reveal--sticky');
      } else if (scrollTop <= this.prodgridToTop && hasAlwaysRevealClass) {
        this.classList.remove('always_reveal--sticky');
      }
    } else {
      if (scrollTop > this.stickyBarPotition && !hasStickyBarClass) {
        this.classList.add('product-grid-sticky-bar');
      } else if (scrollTop <= this.stickyBarPotition && hasStickyBarClass) {
        this.classList.remove('product-grid-sticky-bar');
      }
    }
  }

}
customElements.define("sht-sticky-prodrid", SHTStickyProdGrid);


class SHTSrollGradientOverlay extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.scrollEle = this.$('.js-scroll-element');
    if(!this.scrollEle) return
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    this.scrollEle.addEventListener('scroll', () => {
      const isScrolledToBottom = this.scrollEle.scrollHeight - Math.floor(this.scrollEle.scrollTop) - 2 < this.scrollEle.clientHeight;
      if (isScrolledToBottom) {
        this.classList.remove('gradient-overlay');
      } else {
        this.classList.add('gradient-overlay');
      }
    })
  }
}
customElements.define("sht-scroll-gradient-overlay", SHTSrollGradientOverlay);

class SHTTabs extends SHTCustomComponent {
  constructor() {
    super();
    this.tabLinks = this.$$(".js-tab-link");
    this.tabPanels = this.$$(".js-tab-panel");
    this.tabContent = this.$('.js-tab-content');
    this.isInitialized = false;

    this.handleMutation = this.handleMutation.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);

    this.init();
  }

  init() {
    if (!this.tabLinks.length || !this.tabPanels.length) return;

    this.initMutationObserver();
    this.bindEventHandlers();
    this.initResizeObserver();

    requestAnimationFrame(() => {
      this.activateInitialTab();
      this.isInitialized = true;
    });
  }

  initResizeObserver() {
    window.addEventListener('resize', this.handleMutation.bind(this));
  }

  initMutationObserver() {
    if (!this.tabContent) return;

    this.observer = new MutationObserver(this.handleMutation);
    this.observer.observe(this.tabContent, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  handleMutation() {
    const activePanel = this.$('.tab__panel--active');
    if (!activePanel || this.classList.contains('drawer-wrapper')) return;

    requestAnimationFrame(() => {
      this.tabContent.style.minHeight = `${activePanel.offsetHeight}px`;
    });
  }

  activateInitialTab() {
    const initialTab = this.$(".js-tab-item:not(.d-none-important) .js-tab-link.true") || this.tabLinks[0];
    if (initialTab) {
      this.activateTab(initialTab);
      const activePanel = this.$('.tab__panel--active');
      activePanel?.classList.add('tab__panel--initial');
    }
  }

  bindEventHandlers() {
    this.tabLinks.forEach(tab => {
      tab.addEventListener("click", this.handleTabClick);
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    this.activateTab(event.target.closest('.js-tab-link'));
  }

  activateTab(targetTab) {
    if (!targetTab) return;

    const tabId = targetTab.getAttribute("href")?.replace("#", "");
    if (!tabId) return;

    if (this.isInitialized) {
      this.tabPanels.forEach(panel => {
        panel.classList.add('tab__panel--transitioning');
      });
    }

    this.tabPanels.forEach(panel => {
      panel.classList.remove("tab__panel--active", "tab__panel--initial");
    });
    this.tabLinks.forEach(link => {
      link.classList.remove("tab__link--active");
    });

    const targetPanel = this.$(`[data-tab-content-id=${tabId}]`);
    if (targetPanel) {
      targetPanel.classList.add("tab__panel--active");
      targetTab.classList.add("tab__link--active");
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('resize', this.handleResize);
    this.tabLinks.forEach(tab => {
      tab.removeEventListener("click", this.handleTabClick);
    });
  }
}

customElements.define("sht-tabs", SHTTabs);

class SHTTabOverflow extends SHTCustomComponent {
  constructor() {
    super();
    this.tabContainer = this.$(".js-tab-container");
    this.tabOverflow = this.$(".js-tab-overflow");
    this.tabLinks = this.$$(".js-tab-link");
    this.tabStyle = this.getAttribute("data-tab-style");
    this.tabAnimation = this.initTabAnimation();
    this.activeTabLink = this.initActiveTab();
    this.bindEventHandlers();
  }

  connectedCallback() {
    this.updateOverFlow();
    this.updateIndicator(this.activeTabLink);
  }

  initTabAnimation() {
    let tabAnimation = this.tabContainer.querySelector(".tab-animated-underline, .tab-animated-solid");
    if (!tabAnimation) {
      tabAnimation = document.createElement("div");
      tabAnimation.className = {
        underline: "tab-animated-underline",
        solid: "tab-animated-solid"
      }[this.tabStyle] || "";
      this.tabContainer.appendChild(tabAnimation);
    }
    return tabAnimation;
  }

  initActiveTab() {
    const activeTab = this.tabContainer.querySelector(".js-tab-link.tab__link--active") || this.tabLinks[0];
    if (activeTab) {
      activeTab.classList.add("tab__link--active");
      activeTab.style.background = this.tabStyle ? "transparent" : "";
    }
    return activeTab;
  }

  bindEventHandlers() {
    this.tabContainer.addEventListener("scroll", () => this.updateOverFlow());
    window.addEventListener("resize", () => {
      this.updateOverFlow();
      this.updateIndicator(this.activeTabLink);
    });

    this.tabContainer.addEventListener("click", (event) => {
      const clickedTab = event.target.closest(".js-tab-link");
      if (clickedTab) {
        this.tabLinks.forEach(tab => {
          tab.classList.remove("tab__link--active");
          tab.style.background = "";
        });
        clickedTab.classList.add("tab__link--active");
        clickedTab.style.background = this.tabStyle ? "transparent" : "";
        this.updateIndicator(clickedTab);
      }
    });
  }

  updateOverFlow() {
    const { scrollWidth, clientWidth, scrollLeft } = this.tabContainer;
    const isScrollable = scrollWidth > clientWidth;
    const maxScrollLeft = scrollWidth - clientWidth - 1;

    if (!isScrollable) {
      this.tabOverflow?.classList.remove("tab-overflow--right", "tab-overflow--left");
      return;
    }
    this.tabOverflow?.classList.toggle("tab-overflow--left", scrollLeft > 0);
    this.tabOverflow?.classList.toggle("tab-overflow--right", scrollLeft < maxScrollLeft);
  }

  updateIndicator(activeTab) {
    if (!activeTab || (this.tabStyle !== "underline" && this.tabStyle !== "solid")) return;
    Object.assign(this.tabAnimation.style, {
      width: `${activeTab.offsetWidth}px`,
      left: `${activeTab.offsetLeft}px`,
      display: "block"
    });
  }
}
customElements.define("sht-tab-overflow", SHTTabOverflow);

class SHTSelectSectionInEditor extends SHTCoreDrawer {
  constructor(elementSelect, key) {
    super();
    this.elementSelect = elementSelect;
    this.key = key;
    this.bindEventSelectHandlers();
  }

  bindEventSelectHandlers() {
    const elementSection = SHTHelper.qs(this.elementSelect);
    if(typeof Shopify === 'undefined' || !Shopify.designMode) return;

    const handleSectionEvent = (event) => {
      const isTargetSection = event.detail.sectionId.includes(this.key);
      elementSection.toggleAttribute('open', isTargetSection && event.type === 'shopify:section:select');
    };

    document.addEventListener('shopify:section:select', handleSectionEvent);
    document.addEventListener('shopify:section:deselect', handleSectionEvent);
  }
}

class SHTSearchDrawerInEditor extends SHTSelectSectionInEditor {
  constructor() {
    super('sht-search-drwr-section', 'search_drawer');
  }
}
customElements.define("sht-search-drwr-section", SHTSearchDrawerInEditor);

class SHTCartDrawer extends SHTSelectSectionInEditor {
  constructor() {
    super('sht-cart-drwr', 'cart_drawer');
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        space_selector: `#cartDrawer`,
      },
    ];
  }
}
customElements.define("sht-cart-drwr", SHTCartDrawer);

document.addEventListener('DOMContentLoaded', () => {
  const searchBtn = SHTHelper.qsa('.js-search-open-trigger');
  const searchSection = SHTHelper.qs('sht-search-drwr-section');
  if(!searchSection) {
  searchBtn.forEach((btn) => {
      if(btn.dataset.event === 'drawer') {
        if(typeof Shopify !== 'undefined' && Shopify.designMode) {
          btn.addEventListener('click', () => {
            setTimeout(() => {
              alert('Search is unavailable due to a conflict in the search settings. Please unhide the ‘Search Drawer’ section or change the search behavior to ‘Search Page’ to resolve this issue. This message is only visible in the theme editor. In the live store, the system will automatically default to the ‘Search Page’.');
            },500);
          });
        } else {
          btn.removeAttribute('onclick');
        }
      }
    });
  }
});

class SHTCollapsibleRegion extends SHTCustomComponent {
  constructor() {
    super();

    this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {};

    this.triggers = this.$$(".js-collapsible-region-trigger");
    this.contents = this.$$(".js-collapsible-region-content");

    this.bodyWidth = document.body.clientWidth;

    this.isCollapsibleOnDesktop = this.properties.isCollapsibleOnDesktop;
    this.isCollapsibleOnMobile = this.properties.isCollapsibleOnMobile;
    this.isExpandOnMobile = this.properties.isExpandOnMobile;

    this.init();
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (!this.isCollapsibleOnDesktop || !this.isCollapsibleOnMobile) {
      window.addEventListener("resize", e => {
        this.bodyWidth = Math.floor(document.body.clientWidth);
        this.init();
      });
    }
    this.triggers.forEach(ele => {
      ele.addEventListener("click", e => {
        this.onTriggerClick(e.currentTarget);
      });
    });
  }

  init() {
    if ((!this.isCollapsibleOnDesktop && this.bodyWidth > 1195) || (!this.isCollapsibleOnMobile && this.bodyWidth <= 1195)) {
      this.removeAriaProps();

    }
    if ((this.isCollapsibleOnDesktop && this.bodyWidth > 1195) || (this.isCollapsibleOnMobile && this.bodyWidth <= 1195)) {
      this.restoreAriaProps();
    }

    if(this.isExpandOnMobile && this.bodyWidth <= 1195) {
      this.expandMenu();
    }
  }

  removeAriaProps() {
    this.triggers.forEach(ele => {
      ele.style.pointerEvents = "none";
      ele.setAttribute("tabindex", -1);
      ele.removeAttribute("aria-controls");
      ele.removeAttribute("aria-expanded");
    });

    this.contents.forEach(ele => {
      ele.removeAttribute("aria-describedby");
      ele.removeAttribute("role");
    });
  }

  restoreAriaProps() {
    this.triggers.forEach(ele => {
      ele.style.pointerEvents = "auto";
      ele.setAttribute("aria-controls", this.properties.ariaControls);
      ele.setAttribute("aria-expanded", "false");
      ele.removeAttribute("tabindex");
    });

    this.contents.forEach(ele => {
      ele.setAttribute("aria-describedby", this.properties.ariaDescribedby);
      ele.setAttribute("role", "region");
      ele.style.maxHeight = "0px";
    });
  }

  expandMenu() {
    this.triggers.forEach(ele => {
      ele.setAttribute("aria-expanded", "true");
      ele.classList.add("open");
    });

    this.contents.forEach(ele => {
      ele.classList.add("open");
      requestAnimationFrame(() => {
        ele.style.maxHeight = `calc(${ele.scrollHeight}px + var(--fix-m) * 2)`;
      });
    });
  }

  onTriggerClick(e) {
    let open = e.getAttribute("aria-expanded") === "true";
    this.toggle(!open, e);
  }

  toggle(open, e) {
    e.setAttribute("aria-expanded", `${open}`);
    let content = this.$(`#${e.getAttribute("aria-controls")}`);
    let children = Array.from(content.children);

    if (open) {
      e.classList.add("open");
      content.classList.add("open");
      requestAnimationFrame(() => {
        content.style.maxHeight = `calc(${content.scrollHeight}px + var(--fix-m) * 2)`;
      });
      children.forEach(child => {
        child.style.transform = "translateY(0)";
      });
    } else {
      e.classList.remove("open");
      content.classList.remove("open");
      content.style.maxHeight = `0px`;
      children.forEach(child => {
        child.style.transform = `translateY(-${content.scrollHeight}px)`;
      });
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}
customElements.define("sht-clps-rgn", SHTCollapsibleRegion);

class SHTAnnouncementBar extends SHTCustomComponent {
  constructor() {
    super();
    this.layout = this.getAttribute('data-section-layout');
    this.container = this.$(".js-anmb-items");
    this.items = this.$$(".js-anmb-item");
  }

  init() {
    this.totalItems = this.items.length;
    this.previousButton = this.$(".js-anmb-control-prev");
    this.nextButton = this.$(".js-anmb-control-next");
    this.props = JSON.parse(this.dataset.props);
    this.delayTime = this.props.duration;
    this.interval = null;
    this.currentItemIndex = 1;
    this.lastScrollTimeout = null;
    this.messages = this.container.children;
    this.isScrolling = false;
    this.bindEventHandlers();
    this.updateSort();
    this.autoPlay();
  }

  connectedCallback() {
    if(this.layout == 'running') return;
    if(this.layout == 'grid-desktop') {
      this.checkTabletView();
      window.addEventListener("resize", this.checkTabletView.bind(this));
    } else {
      this.init();
    }
  }

  checkTabletView() {
    const isTablet = window.matchMedia('(max-width: 458.9px)').matches;
    if (isTablet) {

      if (!this.isInitialized) {
        this.isInitialized = true;
        this.container.classList.add('ox-auto', 'disable-scrollbars', 'scrollable-stop-always', 'scrollable-x');
        this.init();
      }
    } else {
      if (this.isInitialized) {
        this.isInitialized = false;
        this.destroySlider();
      }
    }
  }

  destroySlider() {
    // Clean up all event listeners and reset necessary properties
    this.clearDismissInterval();
    this.container.classList.remove('ox-auto', 'disable-scrollbars', 'scrollable-stop-always', 'scrollable-x');
    this.container.removeAttribute("aria-live");
    this.container.removeEventListener("mouseover", this.onMouseOverHandle.bind(this));
    this.container.removeEventListener("mouseout", this.onMouseOutHandle.bind(this));
    this.previousButton.removeEventListener("click", this.onPrevButtonClickHandler.bind(this));
    this.nextButton.removeEventListener("click", this.onNextButtonClickHandler.bind(this));
    this.container.removeEventListener("scroll", this.onScrollEventHandle.bind(this));
    this.container.removeEventListener("wheel", this.resetAutoPlay.bind(this));
    
    // Reset any DOM manipulations done during initialization (optional)
    // e.g., unsetting classes or inline styles, etc.
    this.isScrolling = false;
  }

  updateSort() {
    if (this.totalItems <= 1) return;
    this.isScrolling = true;
    let scrollLeftB = this.container.scrollLeft;
    let scrollLeft = Math.round(scrollLeftB);
    let offsetWidth = this.container.offsetWidth;
    let scrollWidth = this.container.scrollWidth;

    if (scrollLeft < offsetWidth) {
      this.container.prepend(this.messages[this.totalItems - 1]);
      this.container.scrollLeft = scrollLeft + offsetWidth;
    }
    if (Math.floor(scrollWidth - scrollLeftB) <= offsetWidth) {
      this.container.append(this.messages[0]);
      this.container.scrollLeft = scrollLeft - offsetWidth;
    }
    this.isScrolling = false;
  }

  onScrollEventHandle(e) {
    if (this.lastScrollTimeout) {
      clearTimeout(this.lastScrollTimeout);
    }

    this.lastScrollTimeout = setTimeout(
      function () {
        this.updateSort();
      }.bind(this),
      100
    );
  }

  bindEventHandlers() {
    this.previousButton.addEventListener("click", SHTHelper.debounce(this.onPrevButtonClickHandler.bind(this), 300));
    this.nextButton.addEventListener("click", SHTHelper.debounce(this.onNextButtonClickHandler.bind(this), 300));
    this.onObserverHandler();
    this.container.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100));
    this.container.addEventListener(
      "wheel",
      function (evt) {
        SHTHelper.debounce(this.resetAutoPlay.bind(this), 0);
      }.bind(this),
      {
        passive: true,
      }
    );
  }

  onPrevButtonClickHandler() {
    if (this.isScrolling) return;
    this.isScrolling = true;
    this.resetAutoPlay();
    let index = this.currentItemIndex - 1;
    if (this.currentItemIndex == 1) {
      index = this.totalItems;
    }
    let matchingItem = this.$(`div[data-item-index="${index}"]`);

    this.container.scrollTo({ left: matchingItem.offsetLeft, behavior: "smooth" });
  }

  onNextButtonClickHandler() {
    if (this.isScrolling) return;
    this.isScrolling = true;
    this.resetAutoPlay();
    let index = this.currentItemIndex + 1;
    if (this.currentItemIndex == this.totalItems) {
      index = 1;
    }
    let matchingItem = this.$(`div[data-item-index="${index}"]`);

    this.container.scrollTo({ left: matchingItem.offsetLeft, behavior: "smooth" });
  }

  onMouseOverHandle(evt) {
    this.clearDismissInterval();
  }

  onMouseOutHandle(evt) {
    this.setDismissInterval();
  }

  clearDismissInterval() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setDismissInterval() {
    this.interval = setInterval(
      function () {
        this.onNextButtonClickHandler();
      }.bind(this),
      this.delayTime
    );
  }
  resetAutoPlay() {
    if (!this.props.autoPlay || this.totalItems < 2) {
      return;
    }
    this.clearDismissInterval();
    setTimeout(() => {
      this.setDismissInterval();
    });
  }
  autoPlay() {
    if (!this.props.autoPlay || this.totalItems < 2) {
      this.clearDismissInterval();
      this.container.setAttribute("aria-live", "polite");
      return;
    }
    this.container.addEventListener("mouseover", this.onMouseOverHandle.bind(this));
    this.container.addEventListener("mouseout", this.onMouseOutHandle.bind(this));
    this.container.setAttribute("aria-live", "off");
    this.setDismissInterval();
  }

  onObserverHandler() {
    let observe = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let target = entry.target;
            window.requestAnimationFrame(() => {
              let activeItem = this.$(".anmb-item--active");
              if (activeItem) {
                activeItem.classList.remove("anmb-item--active");
                // activeItem.setAttribute("aria-hidden", "true");
              }
            });
            this.currentItemIndex = parseInt(target.dataset.itemIndex);
            // target.setAttribute("aria-hidden", "false");
            window.requestAnimationFrame(() => target.classList.add("anmb-item--active"));
            let linkItem = target.querySelector(".js-anmb-link-items");
            linkItem && linkItem.removeAttribute("tabindex");
          }
        });
      },
      {
        root: this.container,
        rootMargin: "0px",
        threshold: 0.5,
      }
    );
    this.items.forEach(item => {
      observe.observe(item);
    });
  }
}
customElements.define("sht-ann-bar", SHTAnnouncementBar);
class SHTPopoverNoti extends SHTCustomComponent {
  constructor() {
    super();
    this.iconCancel = this.$(".js-icon-cancel");
    this.notificationNewsletter = SHTHelper.qs('.js-newsletter-notification');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.renderNotificationNewsletter();
    this.bindEventHandlers();
    this.autoHide();
  }

  togglePanel(toggle) {
    if (toggle) {
      this.notificationNewsletter.classList.add('show');
    } else {
      this.notificationNewsletter.classList.remove('show');
    }
    return;
  }

  renderNotificationNewsletter() {
    this.notificationNewsletter.innerHTML = this.innerHTML;
    this.togglePanel(true);
  }

  bindEventHandlers() {
    this.iconCancel.addEventListener('click', () => {
      this.togglePanel(false);
    });
  }

  autoHide() {
    setTimeout(() => {
      this.togglePanel(false);
    }, 3000);
  }
}

customElements.define("sht-noti", SHTPopoverNoti);

class SHTMarqueeSection extends SHTCustomComponent {
  constructor() {
    super();
    this.marqueeWrapper = this.$('.js-marquee-container');
    this.marqueeList = this.$('.js-marquee-list');
    this.marqueeListAll = this.$$('.js-marquee-list');
    this.normalSpeed = parseFloat(this.getAttribute('normal-speed')) / 2 || 1;
    this.slowSpeed = parseFloat(this.getAttribute('slow-speed')) / 2 || 1 / 2;
    this.size = parseInt(this.getAttribute('size'));
    this.direction = this.getAttribute('direction');
    this.loop = parseInt(this.marqueeWrapper.getAttribute("loop-marquee"));
    this.speed = this.normalSpeed;
    this.hoverInteraction = this.getAttribute('hover-interaction');
    this.init();
  }

  onResize() {
    this.resizeObserver = new ResizeObserver(entries => {
      this.marqueeListWidth = this.marqueeList.offsetWidth;
      this.currentPosition = 0;
      this.currentPositionReverse = -this.marqueeListWidth;
      this.minWidthValue = window.innerWidth / (this.loop - 1);
      this.checkWidth();
      this.currentPositionReverse = -this.newWidth;
    });
    this.resizeObserver.observe(this);
  }

  init() {
    this.onResize();
    this.startAnimation();
    this.bindHoverEvents();
  }

  checkWidth() {
    if (this.loop * this.marqueeListWidth < window.innerWidth) {
      this.marqueeListAll.forEach(e => {
        e.style.minWidth = this.minWidthValue + "px"
      });
      this.newWidth = this.minWidthValue;
    } else {
      this.marqueeListAll.forEach(e => {
        e.style.minWidth = ""
      });
      this.newWidth = this.marqueeListWidth;
    }
  }

  bindHoverEvents() {
    this.marqueeWrapper.addEventListener('mouseover', () => {
      this.speed = this.hoverInteraction == 'slow_down' ? this.slowSpeed : 0;
    });

    this.marqueeWrapper.addEventListener('mouseout', () => {
      this.speed = this.normalSpeed;
    });
  }

  startAnimation() {
    this.animate();
  }

  animate() {
    if (this.direction == 'animation-reverse') {
      this.currentPositionReverse += this.speed;
      if (this.currentPositionReverse >= 0) {
        this.currentPositionReverse = -this.newWidth;
      }

      this.marqueeWrapper.style.transform = `translateX(${this.currentPositionReverse}px)`;
    } else {
      this.currentPosition -= this.speed;
      if (this.currentPosition <= -this.newWidth) {
        this.currentPosition = 0;
      }

      this.marqueeWrapper.style.transform = `translateX(${this.currentPosition}px)`;
    }

    requestAnimationFrame(this.animate.bind(this));
  }
}
customElements.define("sht-marquee-section", SHTMarqueeSection);

class SHTLoadMedia extends SHTCustomComponent {
  constructor() {
    super();
    this.sectionID = this.dataset.sectionId;
    this.idVideo = this.dataset.idVideo;
    this.typeVideo = this.dataset.type;
    this.muteVideo = this.dataset.muteVideo;
    this.eleVideo = this.$('.js-video-media-item')?.id;
    this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this);
    this.onPlayerPlay = this.onPlayerPlay.bind(this);
    this.trigger = this.$(".js-load-media-trigger");
    if (this.trigger) {
      this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
    }
  }

  handlePlayVideo() {
    this.loadContent();
    const video = this.querySelector(".js-media-item-video");
    if (video) {
      video.addEventListener("play", () => {
        this.pauseAllVideo(video);
        video.play();
      });
    }
  }

  onYouTubeIframeAPIReady() {
    if (typeof YT !== "undefined" && typeof YT.Player !== "undefined") {
      try {
        this.player = new YT.Player(this.eleVideo, {
          videoId: this.idVideo,
          playerVars: {
            playsinline: 1,
            autoplay: 1,
            mute: this.muteVideo
          },
          events: {
            onReady: this.onPlayerYTReady,
            onStateChange: this.onPlayerStateYTChange,
          },
        });
      } catch (error) {
        console.error("Error when creating the Youtube player:", error);
      }
    } else {
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      tag.onload = () => {
        this.onYouTubeIframeAPIReady();
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onVimeoIframeAPIReady() {
    if (typeof Vimeo !== "undefined" && typeof Vimeo.Player !== "undefined") {
      try {
        const options = {
          id: this.idVideo,
          autoplay: 1
        };

        this.playerVimeo = new Vimeo.Player(this.eleVideo, options);
        if(this.playerVimeo.element !== 'iframe') {
          this.querySelector('.js-vimeo-media').classList.remove('d-none');
        } else {
          this.querySelector('.js-vimeo-media').classList.add('d-none');
        }
        this.playerVimeo.on("play", () => {
          this.pauseAllVideo(this.playerVimeo);
        });
      } catch (error) {
        console.error("Error when creating the Vimeo player:", error);
      }
    } else {
      let tag = document.createElement("script");
      tag.src = "https://player.vimeo.com/api/player.js";
      tag.onload = () => {
        this.onVimeoIframeAPIReady();
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onPlayerYTReady = () => {
    this.pauseAllVideo(this.player);
    this.player.playVideo();
  };

  onPlayerStateYTChange = event => {
    if (event.data == 1) {
      this.onPlayerPlay();
    }
  };

  onPlayerPlay = () => {
    this.pauseAllVideo(this.player);
  };

  loadContent() {
    if (!this.getAttribute("loaded")) {
      if (this.$("template")) {
        let template = this.$("template").content.firstElementChild.cloneNode(true);
        this.appendChild(template);
        this.isLoaded(true);
        this.trigger && this.trigger.remove();
      } else {
        if (this.typeVideo == "youtube") {
          this.onYouTubeIframeAPIReady();
        } else if (this.typeVideo == "vimeo") {
          this.onVimeoIframeAPIReady();
        } else {
          return true;
        }
        this.trigger?.classList.add("d-none-important");
        this.$(".js-media-item").classList.add("d-flex");
      }
      return true;
    }
  }

  pauseAllVideo(currentVideo) {
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
      if (video.player && currentVideo !== video.player) {
        video.player?.pauseVideo();
      }
    });
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
      if (video.playerVimeo !== currentVideo) {
        video.playerVimeo?.pause();
      }
    });
    SHTHelper.qsa(".js-media-item-video").forEach(video => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  isLoaded(loaded) {
    if (loaded) {
      this.setAttribute("loaded", true);
    } else {
      this.removeAttribute("loaded");
    }
  }
}

customElements.define("sht-load-media", SHTLoadMedia);

class TabComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tablinks = Array.from(this.querySelectorAll('.js-tab-header-button'));
    const tabcontents = Array.from(this.querySelectorAll('.js-tab-content'));
    if (!tablinks.length || !tabcontents.length) return;
    const toggleMode = this.getAttribute('data-toggle-mode') || 'click';

    this.initializeDefaultTab(tablinks, tabcontents);

    this.addEventListener(toggleMode, (event) => {
      const target = event.target.closest('.js-tab-header-button');
      if (target) this.toggleTab(target, tablinks, tabcontents);
    });
  }

  initializeDefaultTab(tablinks, tabcontents) {

    const firstTab = tablinks[0];
    const firstContentId = firstTab.getAttribute('data-code');
    
    const firstContent = this.querySelector(`#${firstContentId}`);

    if (firstContent) {
      firstTab.classList.add('active');
      firstContent.classList.add('active');
    }
  }

  toggleTab(selectedTab, tablinks, tabcontents) {
    const selectedContentId = selectedTab.getAttribute('data-code');
    const selectedContent = this.querySelector(`#${selectedContentId}`);

    if (!selectedContent) return;


    tabcontents.forEach(content => content.classList.remove('active'));
    tablinks.forEach(tab => tab.classList.remove('active'));

    selectedContent.classList.add('active');
    selectedTab.classList.add('active');
  }
}

// Define the custom element
customElements.define('tab-component', TabComponent);

class SHTVideoBanner extends SHTCustomComponent {
  constructor() {
    super();
    this.iframe = this.$("iframe");
    this.isPlaying = JSON.parse(this.dataset.videoPlay);
    this.isMute = JSON.parse(this.dataset.videoMute);

    this.btnPlay = this.$('.js-btn-play');
    this.btnMute = this.$('.js-btn-mute');
    this.local_video = this.$("video");

    if(this.btnPlay) {
      this.bindEventHandlers();
    }
  }

  connectedCallback() {
    this.execute();
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.querySelector('.js-btn-mute')?.classList.add('pe-none');
    } else {
      this.querySelector('.js-btn-mute')?.classList.remove('pe-none');
    }
  }

  bindEventHandlers() {
    this.btnPlay.addEventListener('click', () => {
      this.togglePlay();
    });
    this.btnMute.addEventListener('click', () => {
      this.toggleMute()
    });
    this.bindVideoEndEvent();
  }

  bindVideoEndEvent() {
    if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.addEventListener("ended", () => this.onVideoEnded());
    }
  }

  onVideoEnded() {
    this.isPlaying = false;
    this.dataset.videoPlay = this.isPlaying;
  }

  togglePlay() {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.playVideo();
      this.dataset.videoPlay = true;
    } else {
      this.dataset.videoPlay = false;
      this.pauseVideo();
    }
  }

  toggleMute() {
    this.isMute = !this.isMute;
    if (this.isMute) {
      this.muteVideo();
      this.dataset.videoMute = true
    } else {
      this.unMuteVideo();
      this.dataset.videoMute = false
    }
  }

  muteVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', "*");
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage('{"method":"setVolume","value":0}', "*");
    } else if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.muted = this.isMute;
    }
  }
  unMuteVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', "*");
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', "*");
    } else {
      this.local_video.muted = this.isMute;
    }
  }

  pauseVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage('{"method":"pause"}', "*");
    } else if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.pause();
    }
  }

  playVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
    } else if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.play();
    }
  }

  loadVideo() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (this.iframe) {
            this.iframe.setAttribute("src", this.iframe.getAttribute("data-src"));
            this.iframe.addEventListener("load", () => {
              if (this.dataVideoType === "youtube") {
                this.iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
              }
              if (this.dataVideoType === "vimeo") {
                this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
              }
            });
          }
          if (this.dataVideoType === "local_video") {
            this.local_video = this.$("video");
            const video_src = this.local_video.querySelector("source").getAttribute("data-src");
            this.local_video.src = video_src;
          }
          observer.disconnect();
        }
      });
    }, {
      root: null,
      rootMargin: '50px',
      threshold: 0
    });
    observer.observe(this);
  }

  execute() {
    this.loadVideo();
  }

  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }

  set dataVideoType(newValue) {
    this.setAttribute("data-video-type", newValue);
  }

  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }

  set dataVideoId(newValue) {
    this.setAttribute("data-video-id", newValue);
  }

  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.execute();
    }
  }
}
customElements.define("sht-load-video", SHTVideoBanner);

document.addEventListener('shopify:section:load', function(event) {
  const stickyHeader = SHTHelper.qs('.header-sticky');
  stickyHeader?.updateTransparentHeaderState();
});

class SHTSlideShow extends SHTCustomComponent {
  constructor() {
    super();
    this.slideshow = this.$(".js-slideshow");
    this.slideshowItems = this.$(".js-slideshow-items");
    this.totalElm = this.$(".js-slideshow-total");
    this.currentElm = this.$(".js-slideshow-current");
    this.separatorElm = this.$(".js-slideshow-separator");
    this.prevBtn = this.$(".js-slideshow-prev-btn");
    this.nextBtn = this.$(".js-slideshow-next-btn");
    this.startNStopBtn = this.$(".js-slideshow-start-n-stop-btn");
    this.imageItems = this.$$(".js-slideshow-image");
    this.pauseIcon = this.startNStopBtn.querySelector(".js-slideshow-pause-icon");
    this.playIcon = this.startNStopBtn.querySelector(".js-slideshow-play-icon");
    this.properties = JSON.parse(this.dataset.slideshowProperties);

    this.autoplay = this.properties.autoplay || false;
    this.image = null;
    this.template = null;
    this.current = 1;
    this.anchors = [];
    this.lastScrollTimeout = null;
    this.autoplayInterval = null;
    this.images = this.slideshowItems.children;
    this.total = this.images.length;
    this.slideshowItems.scrollLeft = 0;
    this.observer = null;
    this.isPaused = false;
    this.isFirstLoad = true;
    this.slideObserver = null;
  }
  cloneSlideItem() {
    if (this.total == 2) {
      let firstItem = this.slideshowItems.querySelector(`.js-slideshow-item:first-of-type`);
      let lastItem = this.slideshowItems.querySelector(`.js-slideshow-item:last-of-type`);
      if (lastItem) {
        let clonedItem = lastItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.slideshowItems.append(clonedItem);
      }
      if (firstItem) {
        let clonedItem = firstItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.slideshowItems.append(clonedItem);
      }
    }
  }
  execute() {
    if (this.total <= 1) return;

    this.cloneSlideItem();
    this.prepare();
    this.bindEventHandlers();
    this.observeSection();
  }
  connectedCallback() {
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.execute();
    } else {
      window.addEventListener("DOMContentLoaded", this.execute.bind(this), { once: true });
    }
  }
  observeSection() {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.isFirstLoad) {
          this.init();
          this.isFirstLoad = false;
          sectionObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    const slideshowSection = this.slideshow.closest('.shopify-section');
    if (slideshowSection) {
      sectionObserver.observe(slideshowSection);
    }
  }
  initSlideObserver() {
    this.slideObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const slideItem = entry.target.closest('.js-slideshow-item');
          if (entry.intersectionRatio >= 0.8) {
            slideItem.classList.add('slider-slide--active');
            const btnLink = slideItem.querySelectorAll('.js-button-group-link');
            btnLink.forEach(btn => btn.removeAttribute("tabindex"));
          } else {
            slideItem.classList.remove('slider-slide--active');
            const btnLink = slideItem.querySelectorAll('.js-button-group-link');
            btnLink.forEach(btn => btn.setAttribute("tabindex", "-1"));
          }
        });
      },
      {
        root: this.slideshowItems,
        rootMargin: '0px',
        threshold: [0, 0.2, 0.4, 0.6, 0.8, 1]
      }
    );

    this.imageItems.forEach(image => {
      this.slideObserver.observe(image);
    });
  }
  init() {
    if (this.autoplay) {
      this.resumeAutoPlay();
      this.isPaused = true;
    }
    this.updateSort();
    this.initSlideObserver();
  }
  updateSort() {
    if (this.total <= 1) return;

    let scrollLeftB = this.slideshowItems.scrollLeft;
    let scrollLeft = Math.round(scrollLeftB);
    let offsetWidth = this.slideshowItems.offsetWidth;
    let scrollWidth = this.slideshowItems.scrollWidth;
    if (scrollLeft < offsetWidth) {
      this.slideshowItems.prepend(this.images[this.total - 1]);
      this.slideshowItems.scrollLeft = scrollLeft + offsetWidth;
    }
    if (Math.floor(scrollWidth - scrollLeftB) <= offsetWidth) {
      this.slideshowItems.append(this.images[0]);
      this.slideshowItems.scrollLeft = scrollLeft - offsetWidth;
    }
  }
  startAutoPlay() {
    if (this.autoplay) {
      this.autoplayInterval = setInterval(
        function () {
          this.nextSlide();
        }.bind(this),
        this.properties.duration
      );
    }
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.slideshowItems.addEventListener(
      "wheel",
      function (evt) {
        if (Math.abs(evt.deltaX) == 5) {
          this.stopAutoPlay();
        }
      }.bind(this),
      {
        passive: true,
      }
    );
    this.slideshowItems.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100));
    this.nextBtn.addEventListener(
      "click",
      function () {
        this.nextSlide();
        this.stopAutoPlay();
      }.bind(this)
    );
    this.prevBtn.addEventListener(
      "click",
      function () {
        this.prevSlide();
        this.stopAutoPlay();
      }.bind(this)
    );
    this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this));
    this.handleSlideshowActionInAdmin();
  }

  handleSlideshowActionInAdmin() {
    if(typeof Shopify !== 'undefined' && Shopify.designMode) {
      let inSlideshow = true;
      document.addEventListener('shopify:section:load', (event) => {
        if(JSON.parse(event.target.dataset.shopifyEditorSection).type === 'slideshow') {
          let slideshowItem = this.querySelectorAll('.js-slideshow-item');
          slideshowItem.forEach((item) => {
            item.classList.add('section-miw-100');
          });
        }
      });
      document.addEventListener('shopify:section:select', (event) => {
        if(event.target.id.includes('slideshow')) {
          let slideshowItem = this.querySelectorAll('.js-slideshow-item');
          slideshowItem.forEach((item) => {
            item.classList.remove('section-miw-100');
          });
        }
      });

      document.addEventListener('shopify:block:select', (event) => {
        if(event.target.classList.contains('slider-slide')) {
          inSlideshow = true;
          const slideshowItems = event.target.closest('.js-slideshow-items');
          slideshowItems.scrollTo({
            left: event.target.offsetLeft
          });
          this.stopAutoPlay();
        }
      });

      document.addEventListener('shopify:block:deselect', (event) => {
        if(event.target.classList.contains('slider-slide')) {
          inSlideshow = false;
          setTimeout(() => {
            if(!inSlideshow && JSON.parse(this.dataset.slideshowProperties).autoplay) {
              this.resumeAutoPlay();
            }
          }, 500);
        }
      });
    }
  }
  onStartNStopEventHandle(e) {
    e.preventDefault();
    if (this.autoplay) {
      this.stopAutoPlay();
    } else {
      this.resumeAutoPlay();
    }
  }
  stopAutoPlay() {
    clearInterval(this.autoplayInterval);

    this.pauseIcon.classList.add("d-none");
    this.playIcon.classList.remove("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
    this.slideshowItems.setAttribute("aria-live", "polite");
    this.autoplay = false;
  }
  resumeAutoPlay() {
    this.autoplay = true;

    this.pauseIcon.classList.remove("d-none");
    this.playIcon.classList.add("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]);
    this.slideshowItems.setAttribute("aria-live", "off");
    this.startAutoPlay();
  }
  onScrollEventHandle(e) {
    e.preventDefault();
    if (this.lastScrollTimeout) {
      clearTimeout(this.lastScrollTimeout);
    }
    this.lastScrollTimeout = setTimeout(
      function () {
        this.updateSort();
      }.bind(this),
      100
    );
    this.updateCurrent();
  }
  prepare() {
    this.totalElm.textContent = this.total;
    this.currentElm.textContent = this.current;
    this.separatorElm.textContent = this.properties.separatorText;
    if (this.autoplay) {
      this.startNStopBtn.toggleAttribute("hidden", false);
      this.startNStopBtn.querySelector(".js-slideshow-pause-icon").classList.remove("d-none");
      this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
      this.slideshowItems.setAttribute("aria-live", "off");
    }
  }
  updateCurrent() {
    let currentItem = this.$(".js-slideshow-image--current");
    if (currentItem) {
      this.current = currentItem.dataset.slideshowIndex;
    }
    this.currentElm.textContent = this.current;
  }
  prevSlide() {
    const slideWidth = this.slideshow.offsetWidth;
    const currentScroll = this.slideshowItems.scrollLeft;
    const targetScroll = Math.floor(currentScroll / slideWidth) * slideWidth - slideWidth;
    this.slideshowItems.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }
  nextSlide() {
    const slideWidth = this.slideshow.offsetWidth;
    const currentScroll = this.slideshowItems.scrollLeft;
    const targetScroll = Math.ceil(currentScroll / slideWidth) * slideWidth + slideWidth;
    this.slideshowItems.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }
}
customElements.define("sht-slideshow", SHTSlideShow);

class SHTSlideshowLazyLoadingImage extends SHTCustomComponent {
  constructor() {
    super();
    this.image = this.$(".js-image-lazy");
    this.imageMobile = this.$(".js-image-lazy-mobile");
    this.container = this.closest(".js-slideshow-items");
    this.currentItemClass = "js-slideshow-image--current";
    this.slideItem = this.closest(".js-slideshow-item");
    this.sectionId = this.dataset.sectionId;
    this.section = SHTHelper.qs(`#shopify-section-${this.sectionId}`);
  }

  observeImage(primaryImage, secondaryImage) {
    let imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          let target = entry.target;
          let parentNode = this.parentNode;

          if (entry.isIntersecting && !this.getAttribute("loaded")) {
            primaryImage && primaryImage.removeAttribute("loading");
            secondaryImage && secondaryImage.removeAttribute("loading");
            this.setAttribute("loaded", true);
            parentNode.classList.add(this.currentItemClass);
          } else if (entry.intersectionRatio == 0) {
            parentNode.classList.remove(this.currentItemClass);
          } else {
            if (this.getAttribute("loaded")) {
              parentNode.classList.add(this.currentItemClass);
            }
          }
        });
      },
      {
        root: this.container,
        rootMargin: `100px -2px 100px -2px`,
        threshold: 0,
      }
    );
    primaryImage && imageObserver.observe(primaryImage);
  }

  loadImage() {
    let resizeObserver = new ResizeObserver(entries => {
      if (!window.matchMedia("(max-width: 767px)").matches) {
        this.image && this.observeImage(this.image, this.imageMobile);
      } else {
        if (this.imageMobile) {
          this.observeImage(this.imageMobile, this.image);
        } else {
          this.image && this.observeImage(this.image, this.imageMobile);
        }
      }
    });

    resizeObserver.observe(document.body);

    if (!window.matchMedia("(max-width: 767px)").matches) {
      this.image && this.observeImage(this.image, this.imageMobile);
    } else {
      if (this.imageMobile) {
        this.observeImage(this.imageMobile, this.image);
      } else {
        this.image && this.observeImage(this.image, this.imageMobile);
      }
    }
  }

  execute() {
    this.loadImage();
  }

  connectedCallback() {
    this.execute();
  }
}

customElements.define("sht-slideshow-load-img", SHTSlideshowLazyLoadingImage);

class SHTVideo extends SHTCustomComponent {
  constructor() {
    super();
    this.mediaContent = this.$('.js-media-trigger');
    this.button = this.$('.js-load-media-trigger');
  }

  execute() {
    this.bindEventHandlers();
  }

  connectedCallback() {
    this.execute();
  }

  bindEventHandlers() {
    this.addEventListener('click', () => {
      this.button.click();
      this.mediaContent.classList.add('d-none-important');
      this.classList.remove('sht-mask');
    });
  }
}

customElements.define("sht-video", SHTVideo);

class SHTHotsPot extends SHTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.cacheElements();
    this.bindEventHandlers();
    this.addResizeObserver();
  }

  cacheElements() {
    this.triggers = this.$$(".js-carousel-trigger");
    this.hotspotItems = this.$$(".js-hotspot-item");
    this.hotspotContents = this.$$(".js-hotspot-content");
    this.closeBtn = this.$$(".js-hotspot-close-btn");
    this.carouselWebElement = SHTHelper.qs(`#${this.dataset.carouselTarget}`);
    this.dialogElement = SHTHelper.qs(`#${this.dataset.dialogId}`);
  }

  bindEventHandlers() {
    document.addEventListener("click", event => {
      const isHotspotContent = event.target.closest(".js-hotspot-content");
      const isHotspotButton = event.target.closest(".js-carousel-trigger");

      if (!isHotspotContent && !isHotspotButton) {
        this.hideAllContent();
        this.setTriggersActiveState(false);
      }
    });

    this.triggers.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.stopPropagation();

        const isActive = btn.classList.contains("active");

        this.hideAllContent();
        this.setTriggersActiveState(false);

        if (!isActive) {
          this.prepare(event);
        }
      });
    });
  }

  addResizeObserver() {
    let resizeObserver = new ResizeObserver(entries => {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        this.hideAllContent();
      } else {
        if (!this.dialogElement.hasAttribute("hidden")) {
          this.dialogElement.closeModal();
          this.setTriggersActiveState(false);
        }
      }
    });
    resizeObserver.observe(document.body);
  }

  prepare(event) {
    const hotspotContentElement = event.target.parentElement.querySelector(".js-hotspot-content");
    if (window.matchMedia("(max-width: 1024px)").matches) {
      this.dialogElement.handleProcessBodyContent(hotspotContentElement);
      this.dialogElement.showModal();
      const scrollElement = this.dialogElement.querySelector(".js-scroll-element");

      if (scrollElement) {
        const isScroll = scrollElement.scrollHeight <= scrollElement.clientHeight;
        if (isScroll) {
          this.dialogElement.querySelector(".js-hotspot-content").classList.remove('gradient-overlay');
        }
      }

      this.setTriggersActiveState(false);
      this.setCurrentTriggerActive(event.target);

    } else {
      this.toggleContent(event);
    }
  }

  toggleContent(event) {
    const hotspotContentElement = event.target.parentElement.querySelector(".js-hotspot-content");
    const buttonEle = event.target;

    this.hideAllContent();

    this.setTriggersActiveState(false);
    this.setCurrentTriggerActive(event.target);

    hotspotContentElement.classList.add("active");
    buttonEle.classList.add("active");

    this.handleScrollOverlay(hotspotContentElement);
  }

  handleScrollOverlay(hotspotContentElement) {
    const scrollElement = hotspotContentElement.querySelector(".js-scroll-element");
    if (scrollElement) {
      const isScroll = scrollElement.scrollHeight <= scrollElement.clientHeight;
      if (isScroll) {
        hotspotContentElement.classList.remove('gradient-overlay');
      }
    }
  }

  hideAllContent() {
    this.hotspotContents.forEach(ele => {
      ele.classList.remove("active");
    });

    this.triggers.forEach(ele => {
      ele.classList.remove("active");
    });
  }

  setTriggersActiveState(isActive) {
    this.triggers.forEach((trigger) => {
      trigger.classList.toggle("hotspot-item--active", isActive);
      trigger.setAttribute("aria-current", isActive ? "true" : null);
    });
  }

  setCurrentTriggerActive(buttonElement) {
    buttonElement.setAttribute("aria-current", "true");
    buttonElement.classList.add("hotspot-item--active");
  }
}
customElements.define("sht-text-hotspot", SHTHotsPot);

class SHTDialogHotspot extends SHTDialogCore {
  constructor() {
    super();
  }

  handleProcessBodyContent(hotspotContentElement) {
    if (hotspotContentElement) {
      const container = document.createElement('div');
      container.appendChild(hotspotContentElement.cloneNode(true));
      this.body.innerHTML = container.innerHTML;
    }
  }
}
customElements.define("sht-dialog-hotspot", SHTDialogHotspot);

class SHTProductSlideShow extends SHTCustomComponent {
  constructor() {
    super();
    this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`);
    this.thumb_carousel = SHTHelper.qs(`sht-slideshow-carousel[data-section="${this.dataset.section}"]`);
    this.hide_variant = this.dataset.hideVariantImage;
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.$$(".js-slideshow-btn-thumb").forEach((e, i) => {
      if (i === 0) {
        e.closest(".js-product-slideshow-thumb").classList.add("is-active-item");
      }
      e.addEventListener("click", this.setActiveMedia.bind(this, e));
    });
  }

  setActiveMedia(e) {
    let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);
    let activeThumb = e.closest("sht-slideshow-carousel-itm");

    if (!window.matchMedia("(max-width: 1025px)").matches) {
      this.$$(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");

        this.hide_variant == "true" && element.classList.add("d-none");
      });

      this.$$(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("d-block");
      this.hide_variant == "true" && activeMedia.classList.remove("d-none");

      activeThumb.classList.add("is-active-item");

      this.playActiveVideo(activeMedia);
      this.playActiveModel(activeMedia);
    } else {
      this.pauseAllVideo();
      this.$$(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });
      activeThumb.classList.add("is-active-item");

      this.carousel.querySelector(".js-carousel-items").scrollTo({
        left: activeMedia.offsetLeft,
        behavior: "smooth",
      });
    }
  }

  pauseAllModel() {
    SHTHelper.qsa("sht-prd-media-itm-model").forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  pauseAllVideo() {
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
      video.player && video.player?.pauseVideo();
    });
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
      if (video.playerVimeo && typeof video.playerVimeo.pause === "function") {
        video.playerVimeo.pause();
      }
    });
    SHTHelper.qsa(".js-media-item-video").forEach(video => {
      if (typeof video.pause === "function") {
        video.pause();
      }
    });
  }

  playActiveVideo(activeItem) {
    this.pauseAllVideo();
    let deferredExternalVideo = activeItem.querySelector(".js-product-media-deferred-video");

    if (deferredExternalVideo) deferredExternalVideo.loadContent();
  }

  playActiveModel(activeItem) {
    //this.pauseAllModel();
    let deferredExternalModel = activeItem.querySelector(".js-product-media-deferred-model");
    if (deferredExternalModel) deferredExternalModel.loadContent();
  }
}
customElements.define("sht-prd-slideshow", SHTProductSlideShow);

class SHTSlideShowCarousel extends SHTCustomComponent {
  constructor() {
    super();

    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");

    this.slideshow = SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`);
    this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`);
    this.carouselLayout = this.getAttribute("data-layout");
    this.window_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    this.transform();

    window.addEventListener("resize", e => {
      let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (this.window_width != windowWidth) {
        this.transform(e);
        this.window_width = windowWidth;
      }
    });
    // this.init();
    // this.bindEventHandlers();
  }

  transform(e) {
    if (!window.matchMedia("(min-width: 1025px)").matches || this.carouselLayout == "slideshow-below") {
      setTimeout(() => {
        this.horizontalInit();
        this.horizontalBindEventHandlers();
        if (typeof e != "undefined") {
          this.horizontalSetActiveMedia();
        }
      }, 200);
    } else {
      setTimeout(() => {
        this.init();
        this.bindEventHandlers();
        if (typeof e != "undefined") {
          this.setActiveMedia();
        }
      }, 200);
    }
  }
  /* horizontal */
  horizontalInit() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);

    if (this.itemsToShow.length < 2) {
      this.horizontalTogglePagination(false);
      return;
    }
    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));

    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.horizontalUpdateCarousel();
  }
  horizontalUpdateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.horizontalIsItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement?.removeAttribute("disabled");
    }
    if (this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.horizontalTogglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.horizontalTogglePagination(false);
    }
  }
  horizontalIsItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleItem && element.offsetLeft >= this.container.scrollLeft;
  }
  horizontalOnButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 1025px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  horizontalBindEventHandlers() {
    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this));
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this));
    }
    this.container.addEventListener("scroll", SHTHelper.debounce(this.horizontalUpdateCarousel.bind(this), 100));
  }
  horizontalTogglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  horizontalSetActiveMedia() {
    let activeThumb = this.$("sht-slideshow-carousel-itm.is-active-item");
    // let slideshow = SHTHelper.qs(
    //   `sht-prd-slideshow[data-section="${this.dataset.section}"]`
    // );
    // let carousel = SHTHelper.qs(
    //   `sht-carousel[data-section-id="${this.dataset.section}"]`
    // );
    if (activeThumb) {
      this.container.scrollTo({
        left: activeThumb.offsetLeft,
        behavior: "auto",
      });

      let activeMedia = this.slideshow.$(`sht-carousel-itm[data-media-id="${activeThumb.dataset.mediaTargetId}"]`);

      this.carousel.querySelector(".js-carousel-items").scrollTo({
        left: activeMedia.offsetLeft,
        behavior: "auto",
      });
    }
  }
  /* horizontal */
  /* Vertical */
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }

    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-top")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-bottom"));
    this.itemOffset = this.itemsToShow[1].offsetTop - this.itemsToShow[0].offsetTop;
    this.itemsPerPage = Math.floor((this.container.clientHeight - this.itemsToShow[0].offsetTop) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.updateCarousel();
  }
  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollTop / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollTop === 0) {
      this.prevBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement?.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }
  }
  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  isItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientHeight + this.container.scrollTop - offset;
    return element.offsetTop + element.clientHeight - 1 <= Math.ceil(lastVisibleItem) && element.offsetTop >= this.container.scrollTop;
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 1025px)");

    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollTop == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollTop - gutter + step * this.itemOffset : this.container.scrollTop + gutter - step * this.itemOffset;

    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        top: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }

  setActiveMedia() {
    let activeThumb = this.$("sht-slideshow-carousel-itm.is-active-item");

    if (activeThumb) {
      this.container.scrollTo({
        top: activeThumb.offsetTop,
        behavior: "auto",
      });

      let activeMedia = this.slideshow.$(`sht-carousel-itm[data-media-id="${activeThumb.dataset.mediaTargetId}"]`);

      this.slideshow.$$(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");
        this.slideshow.hide_variant == "true" && element.classList.add("d-none");
      });

      activeMedia.classList.add("d-block");
      this.slideshow.hide_variant == "true" && activeMedia.classList.remove("d-none");
    }
  }
}
customElements.define("sht-slideshow-carousel", SHTSlideShowCarousel);

class SHTZoomMedia extends SHTCustomComponent {
  constructor() {
    super();
    this.zoomView = this.querySelector('.js-zoom-view');
    this.mediaImage = this.querySelector('.js-media-image');
    this.wrapper = this.querySelector('.js-zoom-wrapper');
    this.galleryIcon = this.querySelector('.js-gallery-icon');
    this.scaleFactor = 1.5;
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if(this.classList.contains('open-zoom') && window.matchMedia("(min-width: 1195px)").matches) {
      this.addEventListener('mouseenter', this.onMouseEnterEvent.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeaveEvent.bind(this));
      this.addEventListener('mousemove', this.onMouseMoveEvent.bind(this));
    }
  }

  onMouseEnterEvent(event) {
    const rect = this.mediaImage.getBoundingClientRect();
    this.wrapper.classList.remove('d-none');
    this.zoomView.style.width = `${rect.width}px`;
    this.zoomView.style.height = `${rect.height}px`;
  }

  onMouseLeaveEvent(event) {
    this.wrapper.classList.add('d-none');
  }

  onMouseMoveEvent(event) {
    const rect = this.mediaImage.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;
    const percentOffsetX = offsetX / rect.width;
    const percentOffsetY = offsetY / rect.height;
    const imgWidth = rect.width * this.scaleFactor;
    const imgHeight = rect.height * this.scaleFactor;
    const zoomWidth = this.wrapper.offsetWidth;
    const zoomHeight = this.wrapper.offsetHeight;
    const centerContainerX = zoomWidth / 2;
    const centerContainerY = zoomHeight / 2;
    const targetImgX = imgWidth * percentOffsetX;
    const targetImgY = imgHeight * percentOffsetY;
    const translateX = centerContainerX - targetImgX;
    const translateY = centerContainerY - targetImgY;
    const maxTranslateX = zoomWidth - imgWidth;
    const maxTranslateY = zoomHeight - imgHeight;
    const clampedTranslateX = Math.max(Math.min(translateX, 0), maxTranslateX);
    const clampedTranslateY = Math.max(Math.min(translateY, 0), maxTranslateY);

    this.zoomView.style.transform = `translate(${clampedTranslateX}px, ${clampedTranslateY}px) scale(${this.scaleFactor})`;

    let zoomX = event.offsetX + 10;
    let zoomY = event.offsetY + 10;
    if(rect.width - zoomX < this.wrapper.offsetWidth) {
      zoomX = zoomX - this.wrapper.offsetWidth - 20;
      if (zoomX < 0) zoomX = event.offsetX + 10;
    }
    if(rect.height - zoomY < this.wrapper.offsetHeight) {
      zoomY = zoomY - this.wrapper.offsetHeight - 20;
      if (zoomY < 0) zoomY = event.offsetY + 10;
    }
    if(this.contains(event.target) && !this.galleryIcon?.contains(event.target)) {
      this.wrapper.classList.remove('d-none');
      this.zoomView.style.width = `${rect.width}px`;
      this.zoomView.style.height = `${rect.height}px`;
    } else {
      this.wrapper.classList.add('d-none');
    }
    this.wrapper.style.left = `${zoomX}px`;
    this.wrapper.style.top = `${zoomY}px`;
  }
}
customElements.define("sht-zoom-media", SHTZoomMedia);
class SHTProductSlideShowItem extends SHTCustomComponent {
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);
    this.openGalleryButton = this.$(".js-product-media-open-gallery-btn");
    if (this.openGalleryButton) {
      this.openGalleryButton.addEventListener("click", e => {
        this.openDialogGallery(e);
      });
    }
    this.slideshow = this.closest("sht-prd-slideshow");
    this.parent = this.closest("sht-carousel-itm");

    this.prepare();
  }

  openDialogGallery(e) {
    let dialog = SHTHelper.qs(`#${e.currentTarget.dataset.galleryDialogId}`);
    if (dialog) {
      dialog.showModal(e.currentTarget, true);
      this.slideshow.pauseAllVideo();
    }
  }

  prepare() {
    if (!window.matchMedia("(max-width: 459px)").matches) {
      if (!this.parent.classList.contains("d-block")) {
        this.slideshow.hide_variant == "true" && this.parent.classList.add("d-none");
      }
    } else {
      this.slideshow.hide_variant == "true" && this.parent.classList.remove("d-none");
    }
    let resizeObserver = new ResizeObserver(entries => {
      if (!window.matchMedia("(max-width: 459px)").matches) {
        if (!this.parent.classList.contains("d-block")) {
          this.slideshow.hide_variant == "true" && this.parent.classList.add("d-none");
        }
      } else {
        this.slideshow.hide_variant == "true" && this.parent.classList.remove("d-none");
      }
    });
    resizeObserver.observe(document.body);
  }
}
customElements.define("sht-prd-slideshow-itm", SHTProductSlideShowItem);

class SHTLoadDynamicCheckoutButtonDynamicCheckoutButton extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);

    this.template = this.$("template");
    this.onLoadDynamicCheckoutButton = this.onHandleLoadDynamicCheckoutButton.bind(this);
    this.bindEventHandlers();
    this.isMouseenter = false;
    this.json = JSON.parse(SHTHelper.qs(`#shopify-features[type="application/json"]`).textContent);
    if (Shopify.designMode) {
      this.loadDynamicCheckoutButton();
    } else {
      window.addEventListener("scroll", this.onLoadDynamicCheckoutButton, false);

      window.addEventListener(
        "load",
        function (event) {
          let timeout = setTimeout(
            function () {
              if (!this.isMouseenter) {
                this.loadDynamicCheckoutButton();
                clearTimeout(timeout);
              }
              this.isMouseenter = true;
            }.bind(this),
            3000
          );
        }.bind(this)
      );

      [("mouseenter", "touchstart", "mouseover")].forEach(
        function (e) {
          SHTHelper.qs("body").addEventListener(e, this.onLoadDynamicCheckoutButton);
        }.bind(this)
      );
    }
  }

  onHandleLoadDynamicCheckoutButton(event) {
    if (!this.isMouseenter) {
      this.loadDynamicCheckoutButton();
    }
    event.currentTarget.removeEventListener(event.type, this.onLoadDynamicCheckoutButton);
    this.isMouseenter = true;
  }

  loadDynamicCheckoutButton() {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio === 1 && !this.getAttribute("loaded")) {
            let tmp = this.template.content.firstElementChild?.cloneNode(true);
            let script = document.createElement("script");
            script.src = this.json.smart_payment_buttons_url;
            script.setAttribute("data-source-attribute", "shopify.dynamic_checkout.product.init");
            if (tmp) this.parentNode?.insertBefore(tmp, this.nextSibling);
            if (script) this.parentNode?.insertBefore(script, this.nextSibling);
            this.setAttribute("loaded", true);
            observer.unobserve(this);
          }
        });
      },
      {
        root: null,
        rootMargin: "50px 0px",
        threshold: 0,
      }
    );
    observer.observe(this);
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {}
}
customElements.define("sht-load-dyn-co-btn", SHTLoadDynamicCheckoutButtonDynamicCheckoutButton);

class SHTQuantityInput extends SHTCustomComponent {
  constructor() {
    super();
    this.input = this.$(`.js-quantity-input`);
    this.changeEvent = new Event("change", { bubbles: true });
    this.allBtns = this.$$(".js-quantity-btn");
    this.productQuantity = parseInt(this.dataset.productQuantity);
    this.container = this.closest('.js-quantity-wrapper');
    this.message = this.container?.querySelector('.js-max-quantity-message');
    this.step = parseInt(this.input.step);
    this.currentCartItem = this.closest('.js-product-container')?.querySelector('.js-volume-cart-item');
    this.currentCartItemValue = parseInt(this.currentCartItem?.value);
    this.volumePricing = this.closest('.js-product-container')?.querySelector('quantity-pricing');
    this.quantityMessage = this.container?.querySelector('.js-quantity-pricing-message');
    this.minQuantityMessage = this.container?.querySelector('.js-min-quantity-pricing-message');
    this.maxQuantityMessage = this.container?.querySelector('.js-max-quantity-pricing-message');
    this.stepQuantityMessage = this.container?.querySelector('.js-step-quantity-pricing-message');
  }

  connectedCallback() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (this.closest('.js-cart-item')) {
      this.currentCartItemValue = 0;
      this.volumePricing = this.closest('.js-cart-item')?.querySelector('quantity-pricing');
    }
    this.allBtns.forEach(button => button.addEventListener("click", this.onButtonClickHandler.bind(this)));
    this.input.addEventListener("input", this.handleInputChange.bind(this));
    this.input.addEventListener("change", this.updatePriceItem.bind(this));
    this.updatePriceItem();
  }

  handleInputChange(event) {
    event.preventDefault();
    let value = parseInt(this.input.value) || 0;
    if (value <= this.productQuantity || Number.isNaN(value) || value == 0) {
      this.showMessage(true);
    } else {
      this.showMessage(false);
    }
  }

  onButtonClickHandler(event) {
    event.preventDefault();
    let previousValue = parseInt(this.input.value);
    let value;
    if (event.currentTarget.dataset.name === "plus") {
      value = parseInt(this.input.value) + this.step;
    } else {
      value = parseInt(this.input.value) - this.step;
    }
    if (value <= parseInt(this.productQuantity)) {
      event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();
      this.showMessage(true);
      this.toggleAnimation('animated');
    } else {
      this.showMessage(false);
      this.toggleAnimation('error-animated');
    }
    if (previousValue !== parseInt(this.input.value)) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  toggleAnimation(animationClass) {
    const oppositeClass = animationClass === 'animated' ? 'error-animated' : 'animated';
    this.input.classList.remove(oppositeClass);
    if (this.input.classList.contains(animationClass)) this.input.classList.remove(animationClass);
    void this.input.offsetWidth; // Trigger reflow
    this.input.classList.add(animationClass);
  }

  validateQuantity(value) {
    const minValue = parseInt(this.input.min);
    const maxValue = parseInt(this.input.max);
    const stepValue = parseInt(this.input.step);

    const toggleMessage = (message, show) => {
      message?.classList.toggle('d-none-important', !show);
    };

    const showMessages = (show, min, max, step) => {
      toggleMessage(this.quantityMessage, show);
      toggleMessage(this.minQuantityMessage, min);
      toggleMessage(this.maxQuantityMessage, max);
      toggleMessage(this.stepQuantityMessage, step);
    };

    if (value < minValue) {
      showMessages(true, true, false, false);
    } else if (value > maxValue) {
      showMessages(true, false, true, false);
    } else if (value % stepValue !== 0) {
      showMessages(true, false, false, true);
    } else {
      showMessages(false, false, false, false);
    }
  }

  updatePriceItem() {
    if (this.input) this.inputValue = parseInt(this.input.value);
    let minPricingMoney = null;
    this.currentValue = this.currentCartItemValue + this.inputValue;
    this.volumePricing?.querySelectorAll('li').forEach(item => {
      const quantity = parseInt(item.querySelector('.js-pricing-item-quantity').textContent);
      const priceText = item.querySelector('.js-pricing-item-price')?.textContent;
      if (this.currentValue >= quantity) {
        minPricingMoney = priceText;
      }
    });
    let priceDisplay;
    if (this.closest('.js-product-container')) {
      priceDisplay = this.closest('.js-product-container')?.querySelector('.price-item');
    } else {
      priceDisplay = this.closest('.js-cart-item')?.querySelector('.price-item');
    }
    if (minPricingMoney !== null && priceDisplay && priceDisplay.textContent !== minPricingMoney) {
      priceDisplay.textContent = minPricingMoney;
    }
  }

  showMessage(show) {
    if (!this.message) return;
    if (show) {
      if (!this.message.classList.contains('d-none-important')) this.message.classList.add('d-none-important');
      if (this.input.value > 0) this.validateQuantity(this.input.value);
    } else {
      const messages = [
        this.quantityMessage,
        this.minQuantityMessage,
        this.maxQuantityMessage,
        this.stepQuantityMessage
      ];
      
      messages.forEach(message => {
        if (message && !message.classList.contains('d-none-important')) {
          message.classList.add('d-none-important');
        }
      });
      this.message.classList.remove('d-none-important');
    }
  }
}
customElements.define("sht-qty-inp", SHTQuantityInput);

class SHTGiftCardRecipientForm extends SHTCustomComponent {
  constructor() {
    super();
    this.i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want`);
    this.i_want_input.disabled = false;
    this.hidden_i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want-hidden`);
    this.hidden_i_want_input.disabled = true;
    this.email_input = this.querySelector(`.js-gift-card-recipient-form-email`);
    this.name_input = this.querySelector(`.js-gift-card-recipient-form-name`);
    this.message_input = this.querySelector(`.js-gift-card-recipient-form-message`);
    this.send_on_input = this.querySelector(`.js-gift-card-recipient-form-send_on`);
    this.email_error = this.querySelector(`.js-gift-card-recipient-form-email-error`);
    this.toggle_recipient_form_lbl = this.querySelector(`.js-gift-card-recipient-label`);
    this.toggle_recipient_form_fields = this.querySelector(`.js-gift-card-recipient-fields`);
  }

  connectedCallback() {
    this.handleBindEventsListener();
  }

  onChangeHandler() {
    if (!this.i_want_input.checked) {
      this.clearInputFields();
      this.clearErrorMessage();
    }
  }

  handleBindEventsListener() {
    this.addEventListener("change", this.onChangeHandler.bind(this));
    this.handleRecipientField();
  }

  handleRecipientField() {
    this.i_want_input.addEventListener('click', () => {
      if(this.i_want_input.checked) {
        this.toggle_recipient_form_fields.classList.remove('d-none');
      } else {
        this.toggle_recipient_form_fields.classList.add('d-none');
      }
    });
  }

  clearErrorMessage() {
    this.querySelectorAll(".js-gift-card-recipient-form-error").forEach(field => {
      field.classList.add("hidden");
      let textField = field.querySelector(".error-message");
      if (textField) textField.innerText = "";
    });

    [this.email_input, this.name_input, this.message_input, this.send_on_input].forEach(inputElement => {
      inputElement.setAttribute("aria-invalid", false);
      inputElement.removeAttribute("aria-describedby");
      inputElement.removeAttribute("tabindex");
    });
  }

  clearInputFields() {
    this.email_input.value = "";
    this.name_input.value = "";
    this.message_input.value = "";
    this.send_on_input.value = "";
  }

  handleErrorMessage(error, message) {
    Object.entries(error).forEach(([key, value]) => {
      let errorMessageContainer = this.querySelector(`.js-gift-card-recipient-form-${key}-error`);
      let errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
      let input = this.querySelector(`.js-gift-card-recipient-form-${key}`);
      errorMessageContainer.querySelector(".error-message").innerText = value;
      errorMessageContainer.classList.remove("hidden");
      input.setAttribute("aria-invalid", true);
      input.setAttribute("aria-describedby", errorMessageId);
      input.focus();
    });
  }

  resetRecipientForm() {
    if (this.i_want_input.checked) {
      this.i_want_input.checked = false;
      this.clearInputFields();
      this.clearErrorMessage();
    }
  }
}

customElements.define("sht-gift-card-recipient-form", SHTGiftCardRecipientForm);
class SHTProductRecommendations extends SHTCustomComponent {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("sht-prd-recom");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.executeScriptElements(this);
          }
        })
        .catch(e => {
          console.error(e);
        })
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(this);
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach(scriptElement => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach(attribute => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }
}
customElements.define("sht-prd-recom", SHTProductRecommendations);

class SHTProgressLinear extends SHTCustomComponent {
  constructor() {
    super();
    this.progress = this.$(".js-progress");
    this.animationDone = false;
  }

  connectedCallback(){
    this.initObserver();
  }

  initObserver() {
    this.progressValue = this.progress.getAttribute("data-progress");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animationDone) {
            requestAnimationFrame(() => {
              this.progress.style.width = `${this.progressValue}%`;
            });
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(this.progress);
  }
}
customElements.define("sht-progress-linear", SHTProgressLinear);

class SHTProgressCircular extends SHTCustomComponent {
  constructor() {
    super();
    this.progress = this.$(".js-progress");
    this.animationDone = false;
  }

  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    this.progressValue = this.progress.getAttribute("data-progress");

    this.circularProgress = this.$('.js-circular-progress');
    const radius = 30;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (this.progressValue / 100) * circumference;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animationDone) {
            requestAnimationFrame(() => {
              this.circularProgress.style.strokeDashoffset = offset;
            });
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(this);
  }
}
customElements.define("sht-progress-circular", SHTProgressCircular);

class SHTVariantSelector extends SHTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.container = this.closest('.js-product-container');
    this.price_selector = '.js-product-price';
    this.inventory_tracking_selector = '.js-inventory-tracking';
    this.variant_picker_selector = '.js-variant-picker';
    this.quantity_container_selector = '.js-product-quantity-container';
    this.quantity_input_selector = '.js-product-quantity';
    this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`;
    this.sku_selector = '.js-product-sku';
    this.selected_variants = null;
    this.selected_variants_option = null;
    this.variant_data = null;
    this.quickView = this.closest('.js-quick-view-block');
    this.elms = {
      radio_elms: this.$$(".js-variant-radio-item"),
      radio_container_elms: this.$$(".js-variant-radio-container"),
      form: this.container.querySelector('.js-product-form'),
      price: this.container.querySelector(this.price_selector),
      installment_form: SHTHelper.qs(`#productFormInstallment-${this.dataset.section}`),
      product_form: this.container.querySelector('.js-sht-product-form'),
      inventory_tracking: this.container.querySelector(this.inventory_tracking_selector ),
      variant_picker: this.container.querySelector(this.variant_picker_selector),
      quantity_container: this.container.querySelector(this.quantity_container_selector),
      quantity_input: this.container.querySelector(this.quantity_input_selector),
      slideshow: SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`),
      thumb_carousel: SHTHelper.qs(`sht-slideshow-carousel[data-section="${this.dataset.section}"]`),
      product_sticky_info: SHTHelper.qs(`#productStickyInfo-${this.dataset.section}`),
      carousel: SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`),
      variant_options: this.$$(".js-variant-option-value"),
      sku: this.container.querySelector(this.sku_selector)
    };

    this.setSelectedVariants();
    this.setCurrentVariant();
    this.updateProductStickyInfo();
    this.updateSelectedVariants();
    this.bindEventHandlers();
    this.setUnavailableOptions();
  }

  bindEventHandlers() {
    this.addEventListener("change", this.onVariantChangeHandle.bind(this));
  }

  onVariantChangeHandle() {
    this.setSelectedVariants();
    this.setCurrentVariant();
    this.toggleAddButton(true, "", false, false);
    this.toggleAddButtonSticky(true, "", false, false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (this.select_type == "dropdown") {
      this.updateVariantStatuses();
    }
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true, false);
      this.toggleAddButtonSticky(true, "", true, false);
      this.setUnavailable();
      if (this.select_type == "dropdown") {
        this.renderVariantSelectOption();
      } else {
        this.updateSelectedVariants();
      }
      this.setUnavailableOptions(false);
    } else {
      let quickBuyBlock = this.closest('.js-quick-buy-block');
      let bundleProduct = this.closest('.js-bundle-product');
      if (!quickBuyBlock && !this.quickView && !bundleProduct) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.setActiveMedia();
      this.setUnavailableOptions();
    }
  }

  updateVariantStatuses() {
    const selectedValue = this.querySelector(":checked")?.value;
    const selected_option_one_variants = this.variant_data.filter(variant => selectedValue === variant.option1);
    const input_wrappers = [...this.querySelectorAll(".js-selectbox-wrapper")];

    input_wrappers.forEach((option, index) => {
      if (index === 0) return;

      const option_inputs = [...option.querySelectorAll("option")];
      const previous_option_selected = input_wrappers[index - 1].querySelector(":checked").value;
      const available_option_inputs_value = selected_option_one_variants.filter(variant => variant.available && variant[`option${index}`] === previous_option_selected).map(variantOption => variantOption[`option${index + 1}`]);
      const radioInputs = [...option.querySelectorAll(`input[type="radio"]`)];
      
      this.setSelectOptionAvailability(option_inputs, available_option_inputs_value);
      if (radioInputs.length > 0) {
        this.setColorSwatchSelectOptionAvailability(radioInputs, available_option_inputs_value);
      }
    });
  }

  renderVariantSelectOption() {
    this.selected_variants_option = this.selected_variants_option.join(',');
    let variantURL = `${this.dataset.url}?option_values=${this.selected_variants_option}&section_id=${this.dataset.section}`;
    fetch(variantURL)
      .then(response => response.text())
      .then(responseText => {
        let markup = new DOMParser().parseFromString(responseText, "text/html");
        const selectSource = markup.querySelectorAll('sht-select .js-variant-select-item');
        const selectDestination = this.querySelectorAll('sht-select .js-variant-select-item');
        selectSource.forEach((itemSource, indexSource) => {
          selectDestination.forEach((itemDestination, indexDestination) => {
            if (itemDestination && indexSource === indexDestination) {
              itemDestination.innerHTML = itemSource?.innerHTML;
            }
          });
        });
        this.updateSelectedVariants();
      });
  }

  setSelectOptionAvailability(option_inputs, available_option_inputs_value) {
    option_inputs.forEach(input => {
      if (available_option_inputs_value.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      }
    });
  }

  setColorSwatchSelectOptionAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      let parent = this.querySelector(`div.js-variant-option-value[data-value="${input.getAttribute("data-variant-value").replace(/"/g, '\\"')}"]`);
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        parent && parent.classList.remove("product-option--unavailable");
      } else {
        parent && parent.classList.add("product-option--unavailable");
      }
    });
  }

  updateOptionState(available) {
    this.$$(".product-option--sold-out").forEach(e => {
      e.classList.remove("product-option--sold-out");
    });
    if (!available) {
      this.selected_variants.forEach(e => {
        let selected = this.$(`.js-variant-item[data-variant-value="${e.replace(/"/g, '\\"')}"]`);
        if (selected) {
          selected.closest(".js-variant-option-value")?.classList.add("product-option--sold-out");
        }
      });
    }
  }

  updateSelectedVariants() {
    this.selected_variants.forEach((variant, index) => {
      const variantValue = `${variant}-${index}`.replace(/"/g, '\\"');
      const selectedElement = this.$(`.js-variant-item[data-variant-value="${variantValue}"]`);
      if (selectedElement) {
        const variantName = selectedElement.getAttribute("data-variant-name") || selectedElement.getAttribute("name");
        const variantValue = selectedElement.dataset.optionVariantValue;
        if (variantName) {
          const targetElement = this.$(`.js-variant-radio-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetElement) {
            targetElement.innerHTML = variant;
          }
          const targetSelectElement = this.$(`.js-variant-select-option-name[data-option-name="${variantName.replace(/"/g, '\\"')}"]`);
          if (targetSelectElement) {
            if (variantValue) {
              targetSelectElement.innerHTML = variantValue;
            } else {
              targetSelectElement.innerHTML = variant;
            }
          }
        }
      }
    });
  }

  updateProductStickyInfo() {
    if (this.elms.product_sticky_info) {
      this.elms.product_sticky_info.querySelector(".js-product-sticky-info-variant").innerHTML = this.currentVariant?.title;
      if (this.elms.price) {
        this.elms.product_sticky_info.querySelector(".js-product-sticky-info-price").innerHTML = this.elms.price.innerHTML;
      }
      if (this.currentVariant?.featured_media) {
        let mediaId = this.currentVariant.featured_media.id;
        this.elms.product_sticky_info.querySelector(".js-product-sticky-info-media").innerHTML = this.elms.slideshow?.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"] .js-media-wrapper .media`)?.innerHTML || '';
      }

      this.elms.product_sticky_info.querySelector(".js-quantity-input").value = 1;

      this.elms.product_sticky_info.querySelector(`[name="id"]`).value = this.currentVariant?.id;
    }
  }

  removeErrorMessage() {
    if (this.elms.product_form && this.elms.product_form instanceof SHTGiftCardRecipientForm) {
      this.elms.product_form.handleErrorMessage();
    }
  }

  updatePickupAvailability() {
    let dataSectionID = this.getAttribute("data-section");
    const pickUpAvailabilityElements = SHTHelper.qsa("sht-pickup-avail[data-section]");

    pickUpAvailabilityElements.forEach((pickUpAvailability) => {
      const sectionId = pickUpAvailability.dataset.section;
      if (sectionId !== dataSectionID) return;

      if (this.currentVariant) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.classList.remove("d-block");
        pickUpAvailability.classList.add("d-none");
        pickUpAvailability.innerHTML = "";
      }
    });
  }

  renderProductInfo() {
    let variantURL = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    fetch(variantURL)
      .then(response => response.text())
      .then(responseText => {
        let markup = new DOMParser().parseFromString(responseText, "text/html");

        //Update Inventory Tracking
        let inventoryTrackingDestination = this.elms.inventory_tracking;
        let inventoryTrackingSource = markup.querySelector(this.inventory_tracking_selector);

        if (inventoryTrackingDestination) {
          inventoryTrackingDestination.innerHTML = "";
          if (inventoryTrackingSource) {
            inventoryTrackingDestination.innerHTML = inventoryTrackingSource.innerHTML;
          }
        }

        //Update Price
        let priceDestination = this.elms.price;
        let priceSource = markup.querySelector(this.price_selector);

        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
        }
        if (this.elms.price) {
          this.elms.price.classList.remove("d-none-important");
        }

        //Update SKU
        let skuDestination = this.elms.sku;
        let skuSource = markup.querySelector(this.sku_selector);

        if (skuDestination) {
          skuDestination.innerHTML = skuSource?.innerHTML || "";
        }

        //Update Quantity Input
        let quantityContainerDestination = this.elms.quantity_container.querySelector('.js-max-quantity-message');
        let quantityContainerSource = markup.querySelector(this.quantity_container_selector);
        quantityContainerSource = quantityContainerSource?.querySelector('.js-max-quantity-message');
        let quantityInputDestination = this.elms.quantity_input;
        let quantityInputSource = markup.querySelector(this.quantity_input_selector);
        if (quantityContainerDestination) {
          quantityContainerDestination.classList.add('d-none-important');
          quantityContainerDestination.innerHTML = quantityContainerSource?.innerHTML || "";
        }
        if (quantityInputDestination) {
          quantityInputDestination.innerHTML = quantityInputSource?.innerHTML || "";
        }

        //Update Product Quick Info
        this.updateProductStickyInfo();
        
        const selectSource = markup.querySelectorAll('sht-select .js-variant-select-item');
        const selectDestination = this.querySelectorAll('sht-select .js-variant-select-item');
        selectSource.forEach((itemSource, indexSource) => {
          selectDestination.forEach((itemDestination, indexDestination) => {
            if (itemDestination && indexSource === indexDestination) {
              itemDestination.innerHTML = itemSource?.innerHTML;
            }
          });
        });
        this.updateSelectedVariants();

        //Update SlideShow
        if (this.elms.slideshow?.hide_variant == "false") {
          let slideshowDestination = this.elms.slideshow;
          let slideshowSource = markup.querySelector(this.slideshow_selector);
          if (slideshowDestination && slideshowSource) {
            slideshowDestination.innerHTML = slideshowSource.innerHTML;
          }
          this.elms.slideshow.bindEventHandlers();
        }

        let preOrderStatus = this.container.querySelector('.js-product-form-submit-btn')?.dataset.preOrder;
        const preOrderStatusSource = markup.querySelector('.js-product-form-submit-btn')?.dataset.preOrder;
        if (preOrderStatusSource) {
          preOrderStatus = preOrderStatusSource;
        }
        
        this.toggleAddButton(!this.currentVariant.available, SHTLanguage.product.PRODUCT_SOLD_OUT, true, preOrderStatus);
        this.toggleAddButtonSticky(!this.currentVariant.available, SHTLanguage.product.PRODUCT_SOLD_OUT, true, preOrderStatus);
      });
  }

  updateVariantInput() {
    const productForms = [this.elms.form, this.elms.installment_form];
    const stockStatus = SHTHelper.qs('.js-inventory-tracking');
    if (stockStatus) stockStatus.classList.remove('d-none');
    productForms.forEach(productForm => {
      if (productForm) {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.pushState({}, "", `?variant=${this.currentVariant.id}`);
  }

  setActiveMedia() {
    if (this.currentVariant.featured_media) {
      let mediaId = this.currentVariant.featured_media.id;

      let activeMedia = this.elms.slideshow?.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"]`);

      let activeThumb = this.elms.slideshow?.querySelector(`sht-slideshow-carousel-itm[data-media-target-id="${this.dataset.section}-${mediaId}"]`);

      if (!window.matchMedia("(max-width: 1024px)").matches) {
        this.elms.slideshow?.querySelectorAll(".js-product-slideshow-item").forEach(element => {
          element.classList.remove("d-block");
          this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
        });

        this.elms.slideshow?.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
          element.classList.remove("is-active-item");
        });

        activeMedia?.classList.add("d-block");

        if (this.elms.slideshow?.hide_variant == "true") {
          activeMedia.classList.remove("d-none");
        }

        if (this.elms.thumb_carousel?.getAttribute("data-layout") == "carousel") {
          this.elms.carousel.querySelector(".js-carousel-items").scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "smooth",
          });
        }

        if (activeThumb) {
          this.elms.slideshow?.querySelectorAll("sht-slideshow-carousel-itm").forEach(activeThumb => {
            activeThumb.classList.remove("is-active-item");
          });

          activeThumb.classList.add("is-active-item");
          if (this.elms.thumb_carousel?.getAttribute("data-layout") == "carousel-vertical") {
            this.elms.thumb_carousel.querySelector(".js-carousel-items").scrollTo({
              top: activeThumb.offsetTop,
              behavior: "auto",
            });
          } else {
            this.elms.thumb_carousel?.querySelector(".js-carousel-items").scrollTo({
              left: activeThumb.offsetLeft,
              behavior: "auto",
            });
          }
        }
      } else {
        this.elms.carousel?.querySelector(".js-carousel-items").scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });

        if (activeThumb) {
          this.elms.slideshow?.querySelectorAll("sht-slideshow-carousel-itm").forEach(activeThumb => {
            activeThumb.classList.remove("is-active-item");
          });

          activeThumb.classList.add("is-active-item");
          this.elms.thumb_carousel?.querySelector(".js-carousel-items").scrollTo({
            left: activeThumb.offsetLeft,
            behavior: "auto",
          });
        }
      }

      this.elms.slideshow?.pauseAllVideo();
    }
  }

  pauseAllVideo() {
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
      video.player?.pauseVideo();
    });
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
      video.playerVimeo?.pause();
    });
    SHTHelper.qsa(".js-media-item-video").forEach(video => {
      video.pause();
    });
  }

  setUnavailable() {
    let form = this.elms.form;
    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    if (!addBtn) return;
    let addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");
    const stockStatus = SHTHelper.qs('.js-inventory-tracking');
    if (stockStatus) stockStatus.classList.add('d-none');
    if (addBtnText) addBtnText.textContent = SHTLanguage.product.PRODUCT_UNAVAILABLE;
    if (this.elms.price) this.elms.price.classList.add("d-none-important");
  }

  getVariantData() {
    this.variant_data = this.variant_data || JSON.parse(this.$('[type="application/json"]').textContent);

    this.variant_data.map(e => {
      e.my_options = [];
      e.options.forEach((elm, index) => {
        e.my_options.push(`${elm}-${index}`);
      });
    });

    return this.variant_data;
  }

  setCurrentVariant() {
    this.currentVariant = this.getVariantData().find(variant => 
      variant.options.every((option, index) => this.selected_variants[index] === option)
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true, preOrderStatus = false) {
    let form = this.elms.form;

    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");

    if (!addBtn) return;

    if (disable) {
      // addBtn.setAttribute("disabled", "disabled");
      addBtn.classList.add('custom-btn-preoder');

      if (text) addBtnText.textContent = text;
    } else {
      addBtn.classList.remove('custom-btn-preoder');

      addBtn.removeAttribute("disabled");
      if (preOrderStatus == "true") {
        addBtnText.textContent = SHTLanguage.product.PRODUCT_PRE_ORDER;
      } else {
        addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
      }
    }

    if (!modifyClass) return;
  }

  toggleAddButtonSticky(disable = true, text, modifyClass = true, preOrderStatus = false) {
    let form = SHTHelper.qs(`#productStickyForm-${this.dataset.section}`);

    if (!form) return;
    let addBtn = form.querySelector(`.js-product-form-submit-btn`);
    let addBtnText = addBtn.querySelector(`.js-product-form-submit-btn-text`);

    if (!addBtn) return;

    if (disable) {
      // addBtn.setAttribute("disabled", "disabled");
      addBtn.classList.add('custom-btn-preoder');

      if (text) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      addBtn.classList.remove('custom-btn-preoder');

      if (preOrderStatus == "true") {
        addBtnText.textContent = SHTLanguage.product.PRODUCT_PRE_ORDER;
      } else {
        addBtnText.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART;
      }
    }

    if (!modifyClass) return;
  }

  toggleUnavailableOptions(unavailable = false) {
    this.elms.variant_options.forEach(element => {
      element.classList.toggle("product-option--unavailable", unavailable);
    });
  }

  setUnavailableOptions(checkAvailable = true) {
    if (this.select_type === "dropdown") return;
    
    this.toggleUnavailableOptions(false);
    this.variant_data = this.variant_data || this.getVariantData();
    const selectedId = this.elms.form?.querySelector('input[name="id"]')?.value;
    this.selected_variant_id = Number(selectedId);
    this.current_variant = this.variant_data.find(v => v.id === this.selected_variant_id);
    let available, currentOptions;
    if (!checkAvailable) {
      available = false;
      currentOptions = this.selected_variants_option;
    } else {
      available = this.current_variant.available;
      currentOptions = this.current_variant.my_options;
    }
  
    const maxOptions = currentOptions?.length || 0;
  
    // Collect potentially available variants
    let matchVariants = this.collectMatchVariants(maxOptions, currentOptions, available);
  
    // Extract valid options from matched variants
    const validOptions = this.processValidOptions(matchVariants, currentOptions, available);
  
    // Update UI
    this.updateOptionAvailability(validOptions);
  }
  
  collectMatchVariants(maxOptions, currentOptions, isCurrentAvailable) {
    let variants = [];
  
    if (maxOptions > 2) {
      for (let i = 0; i < maxOptions; i++) {
        for (let j = i + 1; j < maxOptions; j++) {
          variants.push(...this.variant_data.filter(v =>
            v.my_options[i] === currentOptions[i] &&
            v.my_options[j] === currentOptions[j] &&
            v.available
          ));
        }
      }
    } else if (maxOptions > 1) {
      for (let i = 0; i < maxOptions; i++) {
        variants.push(...this.variant_data.filter(v =>
          v.my_options[i] === currentOptions[i] &&
          v.available
        ));
      }
    } else {
      variants = this.variant_data.filter(v => v.available);
    }
  
    // Include current variant if unavailable to process its options
    if (!isCurrentAvailable) variants.push(this.current_variant);
    return variants;
  }
  
  processValidOptions(variants, currentOptions, isCurrentAvailable) {
    const validOptions = new Set();
    
    variants.forEach(variant => {
      variant.my_options?.forEach(option => validOptions.add(option));
    });
  
    // Remove current variant's options if unavailable
    if (!isCurrentAvailable) {
      currentOptions?.forEach(option => validOptions.delete(option));
    }
  
    return validOptions;
  }
  
  updateOptionAvailability(validOptions) {
    this.toggleUnavailableOptions(true);
    
    validOptions.forEach(value => {
      const escapedValue = value.replace(/"/g, '\\"');
      const optionEl = this.$(`[data-value="${escapedValue}"]`);
      if (optionEl) optionEl.classList.remove("product-option--unavailable");
    });
  }
}


class SHTVariantRadios extends SHTVariantSelector {
  constructor() {
    super();
    this.select_type = "button";
  }

  setSelectedVariants() {
    let selectors = Array.from(this.$$(".js-variant-radio-container"));
    this.selected_variants = selectors.map(selector => {
      return Array.from(selector?.querySelectorAll(".js-variant-radio-item")).find(radio => radio.checked).value;
    });

    this.selected_variants_option = selectors.map(selector => {
      return Array.from(selector?.querySelectorAll(".js-variant-radio-item")).find(radio => radio.checked).dataset.variantValue;
    });
  }
}

customElements.define("sht-variant-radios", SHTVariantRadios);

class SHTVariantSelects extends SHTVariantSelector {
  constructor() {
    super();
    this.select_type = "dropdown";
  }

  setSelectedVariants() {
    this.selected_variants = Array.from(this.$$(".js-variant-select-item"), select => select.value);
    this.selected_variants_option = Array.from(this.$$(".js-variant-select-item"), select => {
      const selectOption = select.querySelectorAll(".js-variant-item")[select.selectedIndex];
      return selectOption?.dataset.variantOption || "";
    });
  }
}
customElements.define("sht-variant-selects", SHTVariantSelects);

class SHTVariantSwatchSelect extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.radios = this.$$(".js-variant-radio-item");
    this.select_id = this.dataset.selectId;
    this.select_element = document.querySelector(`#${this.select_id}`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radios.forEach(radio => {
      radio.addEventListener("click", e => {
        e.preventDefault();
        Array.from(this.radios, input => {
          input.checked = false;
        });

        setTimeout(() => {
          e.target.checked = true;
        });
        if (this.select_element) {
          let option = this.select_element.querySelector(`option[value="${e.target.dataset.optionValue.replace(/"/g, '\\"')}"]`);
          option.selected = true;
          this.select_element.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        }
      });
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("sht-variant-swatch-select", SHTVariantSwatchSelect); 

class SHTProductForm extends SHTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      quantity_input_container: this.closest('.js-product-container')?.querySelector(".js-product-quantity"),
      submit_btn_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-submit-btn"),
      error_wrapper_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-wrapper"),
      error_message_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-error-message"),
      spinner_sticky: SHTHelper.qs("sht-prd-frm-sticky .js-product-form-spinner"),
      sticky_header: SHTHelper.qs("sht-sticky-header"),
      header: SHTHelper.qs("sht-header"),
      announcement_bar: SHTHelper.qs("sht-ann-bar"),
      header_cart_status: SHTHelper.qs("#headerCartStatus"),
      main_product_form: this.$(".js-main-product-form"),
    };
    this.cartNotiType = document.body.getAttribute("data-cart-noti-type");
    this.cartType = document.body.getAttribute("data-cart-type");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.quickViewDialog = SHTHelper.qs("sht-dialog-quickview");
    this.quickBuyDialog = SHTHelper.qs("sht-dialog-quick-buy");
    this.quickAddForm = this.getAttribute("data-quick-add-form") === "true";

    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm");
    this.mainCartForm = SHTHelper.qs("sht-cart-frm");
    this.cardRecipientForm = SHTHelper.qs("sht-gift-card-recipient-form");
    this.interactionPopup = SHTHelper.qs("sht-interaction-popup");
    this.giftCardForm = SHTHelper.qs(".js-gift-card-recipient-fields");
    if (this.elms.form) {
      this.elms.form.querySelector("[name=id]").disabled = false;
      this.bindEventHandlers();
    }
  }


  connectedCallback() {
    this.init();
  }

  bindEventHandlers() {
    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(e) {
    const btn_custom_click = this.$(".custom-btn-preoder");
    if (btn_custom_click) {
      window.open("http://m.me/theluckystar.vn", "_blank");
    }

    e.preventDefault();

    if (this.elms.submit_btn.classList.contains("loading")) return;

    if(!this.quickAddForm) {
      this.hideErrorMessage();
    }

    this.toggleSubmitButtons(false);

    this.elms.spinner?.classList.remove("hidden");
    if (this.elms.spinner_sticky) {
      this.elms.spinner_sticky.classList.remove("hidden");
    }
    if (this.elms.header_cart_status) {
      this.elms.header_cart_status.classList.remove("header-cart-status--animate");
    }

    let sections = [];
    if (this.cartNotification) {
      sections = this.cartNotification.getSectionsToRender();
    }
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }
    if (this.mainCartForm) {
      sections = [...sections, ...this.mainCartForm.getSectionsToRender(false)];
    }

    let formData = new FormData(this.elms.form);
    let elementToFocus = typeof e.submitter != "undefined" ? this.elms.submit_btn : this.elms.submit_btn_sticky;
    const customizationCodeType = this.closest('.js-product-container')?.querySelectorAll('.js-customization-code-type');
    if (customizationCodeType) {
      customizationCodeType.forEach(item => {
        const inputElement = item.querySelector('.js-customization-code-input');
        const label = item.querySelector('.js-customization-code-label').textContent;
        const value = item.dataset.customizationCodeType === 'text' ? inputElement.value : inputElement.checked ? inputElement.dataset.selectedValue : null;
        if (value) formData.append(`properties[${label}]`, value);
      });
    }
    if (sections.length) {
      formData.append(
        "sections",
        sections.map(section => section.id)
      );
    }

    formData.append("sections_url", window.location.pathname);
    SHTHelper.fetchConfigHTTP.body = formData;

    fetch(`${routes.cart_add_url}`, SHTHelper.fetchConfigHTTP)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleQuickAddErrorMessage(e.target, true);
          this.handleErrorMessage(response.description, response?.message);
          return;
        }

        if (!response.id) {
          response.id = formData.get("id");
        }

        if (this.elms.sticky_header) {
          if (this.elms.sticky_header.dataset.isEnabled) {
            this.elms.sticky_header.reveal();
          }
        }

        switch (this.cartNotiType) {
          case "popover_notification":
            this.handlePopoverNotification(response, elementToFocus);
            break;
          case "cart_noti":
            this.handleCartNotification(response, elementToFocus);
            break;
          case "do_nothing":
            this.handleDoNothingNotification(response, elementToFocus);
            break;
        }

        if (this.interactionPopup) this.interactionPopup.handleShowPopupAddToCart();

        if (this.elms.quantity_input_container && this.elms.quantity_input_container.dataset.show == "add-to-cart") {
          this.elms.quantity_input_container.classList.remove("d-none");
          this.elms.quantity_input_container.querySelector("input").value = 1;
        }

        if (this.cardRecipientForm) {
          this.cardRecipientForm.resetRecipientForm();
          this.giftCardForm.classList.add("d-none");
        }

      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.toggleSubmitButtons(true);


        if (this.elms.submit_btn_sticky) {
          this.elms.submit_btn_sticky.classList.remove("loading");
          this.elms.submit_btn_sticky.removeAttribute("aria-disabled");
          this.elms.submit_btn_sticky.removeAttribute("disabled");
        }

        this.elms.spinner?.classList.add("hidden");
        if (this.elms.spinner_sticky) {
          this.elms.spinner_sticky.classList.add("hidden");
        }
      });
  }

  handleQuickAddErrorMessage(opener, showError) {
    const cardContainer = opener.closest(".js-product-card-block");
    const errorMessage = cardContainer?.querySelector(".js-quick-buy-error-message");
    if (showError) {
      errorMessage?.classList.remove('d-none-important');
    } else {
      if (!errorMessage?.classList.contains('d-none-important')) errorMessage?.classList.add('d-none-important');
    }
  }

  toggleSubmitButtons(enable = true) {
    const action = enable ? 'remove' : 'add';
    const ariaDisabled = enable ? false : true;

    this.elms.submit_btn.classList[action]("loading");
    this.elms.submit_btn.setAttribute("aria-disabled", ariaDisabled);
    if (enable) {
      this.elms.submit_btn.removeAttribute("disabled");
    } else {
      this.elms.submit_btn.setAttribute("disabled", true);
    }
  }

  handlePopoverNotification(response, elementToFocus) {
    if (this.quickViewDialog && !this.quickViewDialog.hasAttribute("hidden")) {
      this.quickViewDialog.closeModal();
      elementToFocus = this.quickViewDialog.opener;
    }
    if (this.quickBuyDialog && !this.quickBuyDialog.hasAttribute("hidden")) {
      this.quickBuyDialog.closeModal();
      elementToFocus = this.quickBuyDialog.opener;
    }

    const productQuantity = this.quickAddForm ? 1 : this.elms.quantity_input_container.querySelector("input").value;
    this.cartNotification?.renderContents(response, true, elementToFocus, productQuantity);
    this.cartDrawerForm?.renderContents(response);
  }

  handleCartNotification(response, elementToFocus) {
    if (this.cartType === "drawer") {
      this.cartNotification?.renderContents(response, false);
      this.cartDrawerForm?.renderContents(response);
      this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage();
      if (!this.closeDialogAndOpenDrawer(this.quickViewDialog) && !this.closeDialogAndOpenDrawer(this.quickBuyDialog)) {
        this.cartDrawer?.openDrawer(elementToFocus);
      }
    } else if (this.cartType === "page") {
      this.cartNotification?.renderContents(response, false);
      window.location.assign(window.routes.cart_url);
    }
  }

  handleDoNothingNotification(response, elementToFocus) {
    this.cartNotification?.renderContents(response, false, elementToFocus);
    this.cartDrawerForm?.renderContents(response);
    if (this.quickViewDialog && !this.quickViewDialog.hasAttribute("hidden")) {
      this.quickViewDialog.closeModal();
    }
    if (this.quickBuyDialog && !this.quickBuyDialog.hasAttribute("hidden")) {
      this.quickBuyDialog.closeModal();
    }
  }

  closeDialogAndOpenDrawer(dialog) {
    if (dialog && !dialog.hasAttribute('hidden')) {
      dialog.closeModal();
      dialog.animationsComplete().then(() => this.cartDrawer.openDrawer(dialog.opener));
      return true;
    }
    return false;
  }

  hideErrorMessage() {
    this.elms.error_wrapper.toggleAttribute("hidden", true);
    if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
      this.elms.error_wrapper_sticky.toggleAttribute("hidden", true);
    }
  }
  handleErrorMessage(errorMessage = false, message = "") {
    if (errorMessage) {
      const quantityMessage = SHTHelper.qsa(".js-max-quantity-message");
      quantityMessage.forEach(e => e.classList.add("d-none-important"));
      if (typeof errorMessage == "string") {
        if (this.elms.error_wrapper && this.elms.error_message) {
          this.elms.error_wrapper?.toggleAttribute("hidden", !errorMessage);
          this.elms.error_message.textContent = errorMessage;
        }
        if (this.elms.main_product_form) {
          if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
            this.elms.error_wrapper_sticky.toggleAttribute("hidden", !errorMessage);
            this.elms.error_message_sticky.textContent = errorMessage;
          }
        }
      }

      if (this.cardRecipientForm && typeof errorMessage == "object") {
        this.cardRecipientForm.handleErrorMessage(errorMessage, message);
      }
    }
  }

  checkCartDrawerState() {
    const updateCartDrawerState = () => {
      if (this.cartDrawer || Shopify.designMode === true) {
        this.cartDrawer.setAttribute("data-state", "visible");
      } else {
        this.cartDrawer.setAttribute("data-state", "hidden");
      }
    };
    document.addEventListener('DOMContentLoaded', updateCartDrawerState);
  }
}
customElements.define("sht-prd-frm", SHTProductForm);

class SHTProductMediaItemDeferredVideo extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.sectionID = this.dataset.sectionId;
    this.itemDeferredVideoImageElem = this.$(".js-product-media-item-deferred-video-image");
    this.idVideo = this.dataset.idVideo;
    this.eleVideo = `shtVideo-${this.sectionID}-${this.idVideo}`;
    this.typeVideo = this.$(".js-media-item")?.dataset.type;
    this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this);
    this.onPlayerPlay = this.onPlayerPlay.bind(this);
    if (this.itemDeferredVideoImageElem) {
      this.itemDeferredVideoImageElem.addEventListener("click", this.handlePlayVideo.bind(this));
    }
  }

  handlePlayVideo() {
    this.loadContent();
    const video = this.querySelector(".js-media-item-video");
    if (video) {
      video.addEventListener("play", () => {
        this.pauseAllVideo(video);
        video.play();
      });
    }
  }

  onYouTubeIframeAPIReady(isVideoInZoomModal) {
    this.youtubeId = this.eleVideo;
    if (isVideoInZoomModal == true) {
      this.youtubeId = `${this.eleVideo}-videoInZoomModal`;
    }

    if (typeof YT !== "undefined" && typeof YT.Player !== "undefined" && !this.player) {
      try {
        this.player = new YT.Player(this.youtubeId, {
          videoId: this.idVideo,
          playerVars: {
            playsinline: 1,
          },
          events: {
            onReady: this.onPlayerYTReady,
            onStateChange: this.onPlayerStateYTChange,
          },
        });
      } catch (error) {
        console.error("Error when creating YouTube player:", error);
      }
    } else {
      if (this.player) return;
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      tag.id = "sht-iframe-api";
      tag.onload = () => {
        this.onYouTubeIframeAPIReady(isVideoInZoomModal);
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onVimeoIframeAPIReady(isVideoInZoomModal) {
    this.vimeoId = this.eleVideo;
    if (isVideoInZoomModal == true) {
      this.vimeoId = `${this.eleVideo}-videoInZoomModal`;
    }
    if (typeof Vimeo !== "undefined" && typeof Vimeo.Player !== "undefined") {
      try {
        const options = {
          id: this.idVideo,
          autoplay: 1,
        };

        this.playerVimeo = new Vimeo.Player(this.vimeoId, options);
        this.playerVimeo.on("play", () => {
          this.pauseAllVideo(this.playerVimeo);
        });
      } catch (error) {
        console.error("Error when creating Vimeo player:", error);
      }
    } else {
      let tag = document.createElement("script");
      tag.src = "https://player.vimeo.com/api/player.js";
      tag.onload = () => {
        this.onVimeoIframeAPIReady(isVideoInZoomModal);
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onPlayerYTReady = () => {
    // this.pauseAllVideo(this.player);
    this.player.playVideo();
  };

  onPlayerStateYTChange = event => {
    if (event.data == 1) {
      this.onPlayerPlay();
    }
  };

  onPlayerPlay = () => {
    this.pauseAllVideo(this.player);
  };

  loadContent(isVideoInZoomModal) {
    if (!this.getAttribute("loaded")) {
      if (this.$("template")) {
        let template = this.$("template").content.firstElementChild.cloneNode(true);
        this.appendChild(template);
        this.isLoaded(true);
        this.itemDeferredVideoImageElem && this.itemDeferredVideoImageElem.remove();
      } else {
        this.itemDeferredVideoImageElem?.classList.add("d-none");
        this.$(".js-media-item").classList.add("d-flex");

        if (this.typeVideo == "youtube") {
          this.onYouTubeIframeAPIReady(isVideoInZoomModal);
        } else {
          this.onVimeoIframeAPIReady(isVideoInZoomModal);
        }
      }
      return true;
    }
  }

  pauseAllVideo(currentVideo) {
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
      if (video.player && currentVideo !== video.player) {
        video.player?.pauseVideo();
      }
    });
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
      if (video.playerVimeo !== currentVideo) {
        video.playerVimeo?.pause();
      }
    });
    SHTHelper.qsa(".js-media-item-video").forEach(video => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  isLoaded(loaded) {
    if (loaded) {
      this.setAttribute("loaded", true);
    } else {
      this.removeAttribute("loaded");
    }
  }
}

customElements.define("sht-prd-media-itm-deferred-video", SHTProductMediaItemDeferredVideo);

class SHTProductMediaItemModel extends SHTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.btnIcon3d = this.parentElement.querySelector(".js-btn-icon-3d");
    this.itemModelImageElem = this.$(".js-product-media-item-model-image");
    const elementsToTriggerLoad = [this.itemModelImageElem, this.btnIcon3d];
    elementsToTriggerLoad?.forEach(element => {
      element?.addEventListener("click", () => {
        this.pauseAllMedia();
        this.loadContent();
      }
    )});
  }

  pauseAllMedia() {
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
      video.player?.pauseVideo();
    });
    SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
      video.playerVimeo?.pause();
    });
    SHTHelper.qsa(".js-media-item-video").forEach(video => {
      video.pause();
    });
    SHTHelper.qsa("sht-prd-media-itm-model").forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  loadModelViewerUICss() {
    if (!SHTHelper.qs("#model-viewer-ui")) {
      let productModelCssFile = document.createElement("link");
      productModelCssFile.setAttribute("href", `https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css`);
      // productModelCssFile.setAttribute("data-css-id", "model-viewer-ui");
      productModelCssFile.setAttribute("rel", "stylesheet");
      productModelCssFile.setAttribute("media", "all");
      productModelCssFile.setAttribute("id", "model-viewer-ui");
      document.getElementsByTagName("head")[0].appendChild(productModelCssFile);
    }
  }

  loadContent() {
    this.btnIcon3d?.classList.add("d-none-important");
    if (this.getAttribute("loaded")) return;

    let content = document.createElement("div");
    content.appendChild(this.$("template").content.firstElementChild.cloneNode(true));

    this.setAttribute("loaded", true);

    this.itemModelImageElem && this.itemModelImageElem.remove();
    this.appendChild(content.querySelector("model-viewer")).focus();
    this.loadModelViewerUICss();
    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(this.$("model-viewer"));
  }
}

customElements.define("sht-prd-media-itm-model", SHTProductMediaItemModel);

window.SHTProductMediaItemModel = {
  isMouseenter: false,
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR());
      return;
    }

    SHTHelper.qsa('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

if (Shopify.designMode) {
  SHTHelper.qsa("[data-shopify-xr-hidden]").forEach(element => element.classList.add("hidden"));
  if (window.SHTProductMediaItemModel) window.SHTProductMediaItemModel.loadShopifyXR();
} else {
  if (window.SHTProductMediaItemModel) {
    window.addEventListener(
      "scroll",
      function (event) {
        if (!window.SHTProductMediaItemModel.isMouseenter) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
        window.SHTProductMediaItemModel.isMouseenter = true;
      },
      false
    );
    ["mouseenter", "touchstart", "mouseover"].forEach(function (e) {
      SHTHelper.qs("body").addEventListener(e, function (event) {
        if (!window.SHTProductMediaItemModel.isMouseenter) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
        window.SHTProductMediaItemModel.isMouseenter = true;
      });
    });
  }
}

if (!customElements.get("sht-pickup-avail")) {
  customElements.define(
    "sht-pickup-avail",
    class SHTPickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.$ = this.querySelector.bind(this);

        this.errorHtml = this.$("template").content.firstElementChild.cloneNode(true);
        this.onClickRefreshListHandleEvent = this.onClickRefreshListHandleEvent.bind(this);

        this.sectionId = this.dataset.sectionId;

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = routes.root_url;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        let url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(url)
          .then(response => response.text())
          .then(text => {
            let sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            let button = this.$("button");
            if (button) button.removeEventListener("click", this.onClickRefreshListHandleEvent);
            this.renderError();
          });
      }

      onClickRefreshListHandleEvent(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.$("button").addEventListener("click", this.onClickRefreshListHandleEvent);
      }

      renderPreview(sectionInnerHTML) {
        let drawer = sectionInnerHTML.querySelector("#drawerPickupAvailability");

        if (drawer) {
          drawer.id = `drawerPickupAvailability-${this.sectionId}`;
        }

        let preview = sectionInnerHTML.querySelector("sht-pickup-avail-prwv");

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          this.classList.remove("d-block");
          this.classList.add("d-none");
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute("available", "");
        this.classList.add("d-block");
        this.classList.remove("d-none");

        if (this.dataset.showExpectedPickupTime == "true") {
          drawer.classList.add("pickup_availability--show-pickup-time");
        }

        document.body.appendChild(drawer);

        let button = this.$("button");
        button &&
          button.addEventListener("click", e => {
            drawer.openDrawer(e.target);
          });
      }
    }
  );
}


class SHTDialog extends SHTDialogCore {
  constructor() {
    super();
  }
}
customElements.define("sht-dialog", SHTDialog);

class SHTDialogEditAddress extends SHTDialogCore {
  constructor() {
    super();
    setTimeout(() => {
      this.closest('.js-account-addresses').style.transform = 'none';
    }, 500);
  }
}
customElements.define("sht-dialog-edit-address", SHTDialogEditAddress);


if (!customElements.get("sht-gallery")) {
  class SHTGallery extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = SHTHelper.qs(`sht-dialog#${this.dataset.galleryDialogId}`);
      this.slides = this.$$(".js-gallery-slide");
      this.$$(".js-gallery-btn-thumb").forEach(e => {
        e.addEventListener("click", this.setActiveMedia.bind(this, e));
      });
      this.thumbCarousel = this.$("sht-horiz-carousel");
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          if (window.SHTProductMediaItemModel) {
            window.SHTProductMediaItemModel.loadShopifyXR();
          }
          this.$$(".js-gallery-thumb").forEach(el => {
            if (el.dataset.mediaTargetId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.add("is-active-gallery-thumb");
              this.scrollToThumb(el.dataset.mediaTargetId);
              throw "done";
            }
          });
        } catch (e) {}
      });

      this.dialog.addEventListener("closing", e => {
        this.$$(".js-gallery-thumb").forEach(el => {
          el.classList.remove("is-active-gallery-thumb");
        });
      });
    }

    scrollToThumb(thumbId) {
      let carouselItem = this.thumbCarousel.querySelector(`[data-media-target-id="${thumbId}"]`);

      if (carouselItem) {
        this.thumbCarousel.querySelector(".js-carousel-items").scrollTo({
          left: carouselItem.offsetLeft,
          behavior: "auto",
        });
      }
    }

    setActiveMedia(e) {
      let preActiveMedia = this.$("sht-gallery-slide.is-active-gallery-slide");
      if (preActiveMedia) {
        let zoomElement = preActiveMedia.querySelector("sht-zoom");
        zoomElement && zoomElement.reset();
      }

      let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);

      let activeZoom = activeMedia.querySelector("sht-zoom");

      let activeThumb = e.closest("sht-horiz-carousel-itm");

      this.$$(".js-gallery-slide").forEach(element => {
        element.classList.remove("is-active-gallery-slide", "d-flex");
        element.classList.add("d-none");
      });

      this.$$(".js-gallery-thumb").forEach(element => {
        element.classList.remove("is-active-gallery-thumb");
      });

      activeMedia.classList.add("is-active-gallery-slide", "d-flex");
      activeMedia.classList.remove("d-none");
      activeThumb.classList.add("is-active-gallery-thumb");

      this.playActiveVideo(activeMedia);

      this.playActiveModel(activeMedia);

      if (activeZoom) {
        activeZoom.init();
      }
    }

    pauseAllVideo() {
      SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
        video.player?.pauseVideo();
      });
      SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
        video.playerVimeo?.pause();
      });
      SHTHelper.qsa(".js-media-item-video").forEach(video => {
        video.pause();
      });
    }

    playActiveVideo(activeItem) {
      this.pauseAllVideo();
      let deferredExternalVideo = activeItem.querySelector(".js-product-media-deferred-video");

      if (deferredExternalVideo) deferredExternalVideo.loadContent(true);
    }

    playActiveModel(activeItem) {
      let deferredExternalModel = activeItem.querySelector(".js-product-media-deferred-model");
      if (deferredExternalModel) {
        deferredExternalModel.loadContent();
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }
  customElements.define("sht-gallery", SHTGallery);
}

class SHTHorizontalCarousel extends SHTCustomComponent {
  constructor() {
    super();
    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.init();
    this.bindEventHandlers();
  }
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);
    if (this.itemsToShow.length < 2) {
      this.horizontalTogglePagination(false);
      return;
    } else {
      this.horizontalTogglePagination(true);
    }

    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));

    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }

  horizontalTogglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }

  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage + `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }

  }

  isItemVisible(element, offset = 0) {
    const lastVisibleItem = this.container.clientWidth + this.container.scrollLeft - offset + 1;
    return element.offsetLeft + element.clientWidth <= lastVisibleItem && element.offsetLeft >= this.container.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (this.container.scrollLeft == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    const resizeObserver = new ResizeObserver(entries => this.init());
    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }
    this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
  }
}
customElements.define("sht-horiz-carousel", SHTHorizontalCarousel);

if (!customElements.get("sht-gallery-slides")) {
  class SHTGallerySlides extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.gallery = this.closest("sht-gallery");
      this.dialog = SHTHelper.qs(`sht-dialog#${this.gallery.dataset.galleryDialogId}`);
      this.slides = this.$$(".js-gallery-slide");
      this.totalSlides = this.slides.length;
      this.prevBtnElement = this.$(".js-slide-prev-btn");
      this.nextBtnElement = this.$(".js-slide-next-btn");
      this.currentSlideElement = this.$(".js-slide-current");
      this.totalElement = this.$(".js-slide-total");
      this.paginationElement = this.$(".js-slide-pagination");
      this.currentIndex = 1;
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          this.slides.forEach(el => {
            el.classList.add("d-none");
            el.classList.remove("is-active-gallery-slide", "d-flex");
            if (el.dataset.mediaId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.remove("d-none");
              el.classList.add("is-active-gallery-slide", "d-flex");
              let zoomElement = el.querySelector("sht-zoom");
              zoomElement && zoomElement.init();
              this.currentIndex = el.dataset.itemIndex;
              throw "done";
            }
          });
        } catch (e) {}
      });
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}

  }

  customElements.define("sht-gallery-slides", SHTGallerySlides);
}

if (!customElements.get("sht-zoom")) {
  class SHTZoom extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.image = this.$(".js-zoom-item");

      this.container = SHTHelper.qs(`#${this.dataset.containerId}`);
      this.image_natural_dimension = {};
      this.container_dimension = {};
      this.rendered_aspect_ratio = {};
      this.image_dimension = {};
      this.is_able_to_zoom = true;

      this.bindEventHandlers();
    }

    init() {
      // this.getImageNaturalDimension();
      this.getImageDimension();
      this.getContainerDimension();
      let tmpSrc = this.image.src;
      let tmpSrcset = this.image.srcset;
      this.image.scr = tmpSrc;
      this.image.srcset = tmpSrcset;
      //this.calculateRenderedAspectRatio();

      // let isAbleToZoom = this.ableToZoom();
      // if (!isAbleToZoom) {
      //   this.image.style.cursor = "default";
      //   this.is_able_to_zoom = false;
      // }
      // this.bindEventHandlers();
    }

    ableToZoom() {
      if (this.rendered_aspect_ratio.container <= this.rendered_aspect_ratio.image || (this.image_natural_dimension.width <= this.container_dimension.width && this.image_natural_dimension.height <= this.container_dimension.height)) return false;

      return true;
    }

    bindEventHandlers() {
      this.image.addEventListener("click", e => {
        e.preventDefault();
        // let offsetX = 0;
        // let offsetY = 0;
        // e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
        // e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);

        let isZoomed = this.image.hasAttribute("zoomed");

        if (!isZoomed) {
          this.zoomIn();
        } else {
          this.zoomOut();
        }
      });
    }

    zoomIn() {
      const mediaQuery = window.matchMedia("(max-width: 459px)");
      this.image.style.height = "auto";
      this.image.style.objectFit = "unset";
      this.image.setAttribute("zoomed", true);
      this.image.style.cursor = "zoom-out";
      if (mediaQuery.matches) {
        this.image.style.width = "150%";
        this.image.style.maxWidth = "unset";
      } else {
        this.image.style.width = "100%";
      }

      if (this.image.offsetHeight <= this.container_dimension.height) {
        this.classList.add("d-flex", "fd-column", "center-xs");
      }
      this.container.classList.add("o-scroll");
      this.container.scrollTo({
        top: this.container.scrollHeight / 2 - this.container.offsetHeight / 2,
        behavior: "auto",
      });

      if (mediaQuery.matches) {
        this.container.scrollTo({
          left: this.container.scrollWidth / 2 - this.container.offsetWidth / 2,
          behavior: "auto",
        });
      }
    }

    zoomOut() {
      this.image.style.width = "100%";
      this.image.style.height = "100%";
      this.image.style.objectFit = "contain";
      this.image.removeAttribute("zoomed");
      this.image.style.cursor = "zoom-in";

      this.classList.remove("d-flex", "fd-column", "center-xs");
      this.container.classList.remove("o-scroll");
      this.image.style.maxWidth = null;
    }

    reset() {
      this.zoomOut();
    }

    calculateRenderedAspectRatio() {
      this.rendered_aspect_ratio = {
        image: this.image_natural_dimension.width / this.image_natural_dimension.height,
        container: this.container_dimension.width / this.container_dimension.height,
      };
    }

    getImageNaturalDimension() {
      this.image_natural_dimension = {
        width: parseInt(this.image.getAttribute("width")),
        height: parseInt(this.image.getAttribute("height")),
      };
    }

    getImageDimension() {
      this.image_dimension = {
        width: this.image.offsetWidth,
        height: this.image.offsetHeight,
      };
    }

    getContainerDimension() {
      this.container_dimension = {
        width: this.container.offsetWidth,
        height: this.container.offsetHeight,
      };
    }
  }
  customElements.define("sht-zoom", SHTZoom);
}

if (!customElements.get("sht-gallery-slide")) {
  class SHTGallerySlide extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = SHTHelper.qs(`sht-dialog#${this.dataset.galleryDialogId}`);
      this.mediaId = this.dataset.mediaId;
      this.zoomElement = this.$("sht-zoom");
    }

    init() {
      this.dialog.addEventListener("closing", e => {
        this.classList.add("d-none");
        this.classList.remove("is-active-gallery-slide", "d-flex");
        this.zoomElement && this.zoomElement.reset();
        this.pauseAllVideo();
      });
    }

    pauseAllVideo() {
      SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
        video.player?.pauseVideo();
      });
      SHTHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
        video.playerVimeo?.pause();
      });
      SHTHelper.qsa(".js-media-item-video").forEach(video => {
        video.pause();
      });
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }

  customElements.define("sht-gallery-slide", SHTGallerySlide);
}

class SHTDrawerPickup extends SHTCoreDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.mainDrawer = this.$('.js-drawer-wrapper');
    this.mainProduct = SHTHelper.qs('.js-main-product');
    if (this.mainProduct && this.mainProduct.dataset.color) {
      this.mainDrawer.classList.add(this.mainProduct.dataset.color);
    }
  }
}
customElements.define("sht-drwr-pickup", SHTDrawerPickup);
class SHTProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.cookieName = "sht-recently-viewed";
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const productId = this.dataset.productId;
    const productUrl = this.dataset.productUrl;

    if (!Shopify.designMode) {
      const items = JSON.parse(window.localStorage.getItem(this.cookieName) || "[]");
      const newItem = { id: productId, url: productUrl };
      const existingIndex = items.findIndex(item => item.id === productId);
      if (existingIndex !== -1) {
        items.splice(existingIndex, 1);
      }
      items.unshift(newItem);
      window.localStorage.setItem(this.cookieName, JSON.stringify(items.slice(0, 10)));
    }
  }
}
customElements.define("sht-product-recently-viewed", SHTProductRecentlyViewed);

class SHTRecentlyViewed extends SHTCarousel {
  static fetchedProducts = null;
  static fetchPromise = null;

  constructor() {
    super();
    this.cookieName = "sht-recently-viewed";
    this.limitProduct = parseInt(this.dataset.limit);
    this.productsArray = this.getArrayFromLocalStorage().slice(0, this.limitProduct);
    this.totalItems = parseInt(this.productsArray.length);

    this.settings = {
      rowMobile: parseInt(this.dataset.itemPerRowMobile),
      rowDesktop: parseInt(this.dataset.itemPerRowDesktop),
      widthMobile: this.dataset.widthMobile,
      widthDesktop: this.dataset.widthDesktop,
      enableVendor: this.toBoolean(this.dataset.enableVendor),
      enableBadge: this.toBoolean(this.dataset.enableBadge),
      enableQuickView: this.toBoolean(this.dataset.enableQuickView),
      enableVariantSwatches: this.toBoolean(this.dataset.enableVariantSwatches),
      enablePrice: this.toBoolean(this.dataset.enablePrice),
      enableMobile: this.toBoolean(this.dataset.enableMobile),
      enableDesktop: this.toBoolean(this.dataset.enable),
      optionQuickBuy: this.dataset.optionQuickBuy,
      enableRating: this.toBoolean(this.dataset.enableRating),
    };

    this.recentlyViewedSections = SHTHelper.qsa(".js-recently-viewed-section");
    this.body = this.$(".js-product-recently-viewed");
    this.sliderScrollBar = this.$(".js-slider-scrollbar");
  }

  connectedCallback() {
    super.connectedCallback();
    this.checkRecentlyViewedState();
    this.processData();
  }

  toBoolean(value) {
    return value === "true";
  }

  async fetchProductHTML(url) {
    try {
      const response = await fetch(url);
      const responseText = await response.text();
      const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
      const productElement = responseHTML.querySelector(".section-recently-viewed");

      if (window.Shopify?.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      return productElement?.innerHTML || null;
    } catch (error) {
      console.error(`Failed to fetch product from ${url}:`, error);
      return null;
    }
  }

  async fetchAllProducts() {
    if (!this.productsArray.length) return [];

    const urls = this.productsArray.map(product => `${product.url}?view=show-recently-viewed`);
    return Promise.all(urls.map(url => this.fetchProductHTML(url)));
  }

  toggleFeatures(container) {
    const features = {
      ".js-rv-vendor": this.settings.enableVendor,
      ".js-rv-badge": this.settings.enableBadge,
      ".js-rv-view": this.settings.enableQuickView,
      ".js-rv-variant": this.settings.enableVariantSwatches,
      ".js-rv-price": this.settings.enablePrice,
      ".js-rv-rating": this.settings.enableRating,
    };

    Object.entries(features).forEach(([selector, isEnabled]) => {
      const element = container.querySelector(selector);
      if (element) {
        element.classList.toggle("d-none-important", !isEnabled);
      }
    });
  }

  renderProducts(productHTMLs) {
    if (!productHTMLs.length) return;

    productHTMLs.forEach((productHTML, index) => {
      if (!productHTML) return;

      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = productHTML;
      const productContainer = tempContainer.firstElementChild;

      this.toggleFeatures(productContainer);
      if (this.settings.optionQuickBuy == "not_use") productContainer.$(".js-rv-buy")?.classList.add("d-none-important");
      productContainer.$(".js-rv-buy")?.setAttribute("data-quick-buy", this.settings.optionQuickBuy);
      productContainer.setAttribute("aria-label", `Slide ${index + 1} of ${productHTMLs.length}`);
      productContainer.dataset.itemIndex = index + 1;
      productContainer.style.setProperty("--w-xs", this.settings.widthMobile);
      productContainer.style.setProperty("--w-md", this.settings.widthDesktop);
      productContainer.classList.toggle("carousel__item-xs", this.settings.enableMobile);
      productContainer.classList.toggle("carousel__item-md", this.settings.enableDesktop);

      this.body.appendChild(productContainer);
    });

    this.executeScriptElements(this.body);
    this.handleCarousel();

    if (window.SHTProductMediaItemModel) {
      window.SHTProductMediaItemModel.loadShopifyXR();
    }
  }

  getArrayFromLocalStorage() {
    return JSON.parse(localStorage.getItem(this.cookieName)) || [];
  }

  removeDataFromLocalStorage() {
    localStorage.removeItem(this.cookieName);
  }

  async processData() {
    const arraysProduct = this.getArrayFromLocalStorage().slice(0, this.limitProduct);
    if (!arraysProduct.length) return;

    try {
      if (!SHTRecentlyViewed.fetchPromise) {
        SHTRecentlyViewed.fetchPromise = this.fetchAllProducts();
      }
      SHTRecentlyViewed.fetchedProducts = await SHTRecentlyViewed.fetchPromise;
      this.renderProducts(SHTRecentlyViewed.fetchedProducts);
    } catch (error) {
      console.error("Error processing recently viewed products:", error);
    }
  }

  handleCarousel() {
    this.carousels = this.body.querySelectorAll(".js-carousel-item");
    const size = this.totalItems;

    this.scrollbarTrack?.style.setProperty("--width-thumb-desktop", `${(this.settings.rowDesktop * 100) / size}%`);
    this.scrollbarTrack?.style.setProperty("--width-thumb-tablet", `${(2 * 100) / size}%`);
    this.scrollbarTrack?.style.setProperty("--width-thumb-mobile", `${(1 * 100) / size}%`);

    this.toggleScrollBar(this.settings.enableDesktop, this.settings.rowDesktop, size, "d-flex-md", "d-none-md");
    this.toggleScrollBar(this.settings.enableMobile, this.settings.rowMobile, size, "d-flex", "d-none");
  }

  toggleScrollBar(isEnabled, rowCount, size, showClass, hideClass) {
    this.sliderScrollBar?.classList.toggle(showClass, isEnabled && rowCount < size);
    this.sliderScrollBar?.classList.toggle(hideClass, !(isEnabled && rowCount < size));
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach(scriptElement => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach(attribute => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }

  checkRecentlyViewedState() {
    if (Shopify.designMode === true) this.removeDataFromLocalStorage();
    this.recentlyViewedSections.forEach(section => {
      section.classList.toggle("d-none-important", Shopify.designMode === true || this.totalItems < 1);
    });
  }
}
customElements.define("sht-recently-viewed", SHTRecentlyViewed);

class SHTFreeShippingBar extends SHTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.total_price = this.dataset.totalPrice;
    this.threshold = 0;
    this.original_free_shipping_price = this.dataset.freeShippingOriginalPrice;
    this.free_shipping_price = this.dataset.freeShippingPrice;
    this.free_shipping_progress = this.$(`.js-free-shipping-progress`);
    this.free_shipping_progress_content = this.$(`.js-free-shipping-progress-content`);
    this.free_shipping_progress_message = this.$(`.js-free-shipping-message`);

    this.init();
  }

  calculateCurrencyRate() {
    this.threshold = Math.round(this.free_shipping_price * (Shopify.currency.rate || 1));
  }

  init() {
    this.calculateCurrencyRate();
    this.free_shipping_progress.max = this.threshold;
    this.free_shipping_progress.value = this.total_price;
    this.free_shipping_progress_content.innerHTML = SHTHelper.formatMoney(this.threshold, window.theme_variables.settings.money_with_currency_format);

    let remain = this.threshold - this.total_price;
    if (remain <= 0) {
      this.free_shipping_progress_message.innerHTML = SHTLanguage.free_shipping_bar.FULFILLED;
    } else {
      this.free_shipping_progress_message.innerHTML = SHTLanguage.free_shipping_bar.UNFULFILLED.replaceAll("[amount]", SHTHelper.formatMoney(remain, window.theme_variables.settings.money_with_currency_format));
    }
  }
}
customElements.define("sht-free-shipping-bar", SHTFreeShippingBar);

class SHTCartNotificationPanel extends SHTCustomComponent {
  constructor() {
    super();
    this.elms = {
      notification_wrapper: this.$(`.js-cart-notification-panel-wrapper`),
      close_buttons: this.$$(".js-cart-notification-panel-close-btn"),
      notification_product_quantity: this.$(`.js-cart-notification-product-quantity`),
      notification_progress: this.$(`.js-cart-notification-progress`),
      notification_message: this.$(`.js-cart-notification-message`),
    };
    this.dismiss_timeout = null;
    this.element_to_focus = null;
    this.previousFocusedElement = null;
    for (let i = 0, n = this.elms.close_buttons.length; i < n; i++) {
      this.elms.close_buttons[i].addEventListener("click", this.close.bind(this));
    }
  }

  /**
   * bind event handler to web component elements
   */

  open() {
    this.dispatchEvent(new Event("opened"));
    this.togglePanel(true);
    setTimeout(() => {
      SHTHelper.trapFocus(this);
    });
  }

  close() {
    this.clearDismissTimeout();
    this.togglePanel(false);
    this.dispatchEvent(new Event("closed"));

    if (this.element_to_focus) {
      SHTHelper.removeTrapFocus(this.element_to_focus);
      this.element_to_focus = null;
    } else {
      SHTHelper.removeTrapFocus();
    }
  }

  clearDismissTimeout() {
    clearTimeout(this.dismiss_timeout);
  }

  renderQuantityContents(isOpenNoti = true, productQuantity, elementToFocus = null) {
    this.element_to_focus = elementToFocus;
    if (productQuantity > 0) {
      this.elms.notification_product_quantity.innerHTML = productQuantity;
      if (productQuantity == 1) {
        this.elms.notification_message.textContent = SHTLanguage.cart_noti.MESSAGE_ONE_ITEM;
      } else {
        this.elms.notification_message.textContent = SHTLanguage.cart_noti.MESSAGE_MULTIPLE_ITEMS;
      }
      this.setDismissTimeout();
      this.elms.notification_progress.classList.remove("progress");
      setTimeout(() => {
        this.elms.notification_progress.classList.add("progress");
      }, 10);

      if (isOpenNoti) this.open();
    }
  }

  renderContents(response, isOpenNoti = true, elementToFocus = null, productQuantity) {
    this.productId = response.id;
    this.element_to_focus = elementToFocus;
    this.elms.notification_product_quantity.innerHTML = productQuantity;
    if (productQuantity == 1) {
      this.elms.notification_message.textContent = SHTLanguage.cart_noti.MESSAGE_ONE_ITEM;
    } else {
      this.elms.notification_message.textContent = SHTLanguage.cart_noti.MESSAGE_MULTIPLE_ITEMS;
    }
    if (isOpenNoti) {
      this.setDismissTimeout();
    }
    this.elms.notification_progress.classList.remove("progress");
    setTimeout(() => {
      this.elms.notification_progress.classList.add("progress");
    }, 10);

    let sections = this.getSectionsToRender();
    for (let i = 0, n = sections.length; i < n; i++) {
      let element = SHTHelper.qs(sections[i].space_selector);
      if (element) {
        if (sections[i].space_selector == "#headerCartStatus") {
          element.classList.add("header-cart-status--animate");
        }

        element.innerHTML = this.getSectionInnerHTML(response.sections[sections[i].id], sections[i].selector);
      }
    }
    if (isOpenNoti) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "header-cart-status",
        section: "header-cart-status",
        space_selector: `#headerCartStatus`,
      }
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  togglePanel(toggle) {
    if (toggle) {
      this.classList.add('show');
      this.removeAttribute('hidden');
    } else {
      this.classList.remove('show');
    }
    return;
  }

  setDismissTimeout() {
    clearTimeout(this.dismiss_timeout);
    this.previousFocusedElement = document.activeElement;
    this.dismiss_timeout = setTimeout(() => {
      this.close();
      if (this.previousFocusedElement) SHTHelper.trapFocus(this.previousFocusedElement);
    }, 3000);
  }
}

customElements.define("sht-cart-noti", SHTCartNotificationPanel);

class SHTQuantityInputQuickBuy extends SHTQuantityInput {
  constructor() {
    super();
    this.deleteBtn = this.container?.querySelector('.js-delete-variant-btn');
    this.dialog = this.closest('sht-dialog-quick-buy');
    this.previousValue = parseInt(this.input.value);
    this.productAddedQuantity = 0;
    this.container = this.closest('.js-quantity-wrapper');
    this.sellingPlanErrorMessage = this.container?.querySelector('.js-selling-plan-error-message');
    this.sellingPlan = this.dataset.sellingPlan;
    this.cartDrawerNumber = SHTHelper.qs('.js-cart-drawer-count-number');
    this.cartCountNumber = SHTHelper.qs(".js-cart-count-number");
    this.volumePricing = this.closest('.js-variant-bulk-item')?.querySelector('quantity-pricing');
  }

  connectedCallback() {
    super.connectedCallback();
    this.updateQuickBuyState();
    this.input.addEventListener("input", () => {
      this.updateQuickBuyState();
      this.showSellingPlanMessage(this.sellingPlan);
    });
    this.input.addEventListener("blur", this.ensureNonNegativeInput.bind(this));
  }

  updatePriceItem() {
    if (this.input) this.inputValue = parseInt(this.input.value);
    let minPricingMoney = null;
    this.currentValue = this.inputValue;
    this.volumePricing?.querySelectorAll('li').forEach(item => {
      const quantity = parseInt(item.querySelector('.js-pricing-item-quantity')?.textContent);
      const priceText = item.querySelector('.js-pricing-item-price')?.textContent;
      if (this.currentValue >= quantity) {
        minPricingMoney = priceText;
      }
    });
    const priceDisplay = this.closest('.js-variant-bulk-item')?.querySelector('.price-item');
    if (minPricingMoney !== null && priceDisplay && priceDisplay.textContent !== minPricingMoney) {
      priceDisplay.textContent = minPricingMoney;
    }
  }

  onButtonClickHandler(event) {
    this.cartDrawerNumber.innerHTML = this.cartCountNumber.innerHTML;
    super.onButtonClickHandler(event);
    this.updateQuickBuyState();
    this.showSellingPlanMessage(this.sellingPlan);
    const changeEvent = new CustomEvent("on:cart-input:change", {
      bubbles: true,
      composed: true,
      detail: {
        element: event.currentTarget,
        value: this.input.value,
        previousValue: this.previousValue
      }
    });
    this.dispatchEvent(changeEvent);
  }

  updateQuickBuyState() {
    if (this.input.value && this.input.value <= 0) {
      this.input.value = 0;
    }
    this.productAddedQuantity = parseInt(this.input.value) - this.previousValue;
    this.deleteBtn?.classList.toggle('d-none-important', !this.input.value || this.input.value <= 0);
  }

  showSellingPlanMessage(show) {
    if (!this.sellingPlanErrorMessage) return;
    if (show == 'false') {
      if (!this.sellingPlanErrorMessage.classList.contains('d-none-important')) this.sellingPlanErrorMessage.classList.add('d-none-important');
    } else {
      this.sellingPlanErrorMessage.classList.remove('d-none-important');
    }
  }

  ensureNonNegativeInput() {
    if (!this.input.value) {
      this.input.value = 0;
      this.updateQuickBuyState();
    }
  }
}

customElements.define('sht-qty-inp-quick-buy', SHTQuantityInputQuickBuy);

class SHTCartDrawerCartNote extends SHTCustomComponent {
  constructor() {
    super();
    this.addEventListener(
      "change",
      SHTHelper.debounce(event => {
        const body = JSON.stringify({
          note: event.target.value,
        });
        fetch(`${window.routes.cart_update_url}`, {
          ...SHTHelper.fetchConfigJSON,
          ...{
            body,
          },
        });
      }, 300)
    );
  }
}
customElements.define("sht-cart-drwr-note", SHTCartDrawerCartNote);

class SHTCartDrawerQuantityInput extends SHTCustomComponent {
  constructor() {
    super();
    this.input = this.$(`.js-cart-drawer-quantity-input`);
    this.changeEvent = new Event("change", {
      bubbles: true,
    });
    this.productQuantity = parseInt(this.dataset.productQuantity);
    this.cartNumber = SHTHelper.qs(".js-cart-drawer-count");
    this.cartDrawerNumber = SHTHelper.qs(".js-cart-drawer-count-number");
    this.renderCartNumbers();
    this.button = this.$$(".js-cart-drawer-quantity-btn");
    this.container = this.closest('.js-cart-drawer-quantity');
    this.message = this.container?.querySelector('.js-max-quantity-message');
    this.volumePricing = this.container?.querySelector('quantity-pricing');
    this.quantityMessage = this.container?.querySelector('.js-quantity-pricing-message');
    this.minQuantityMessage = this.container?.querySelector('.js-min-quantity-pricing-message');
    this.maxQuantityMessage = this.container?.querySelector('.js-max-quantity-pricing-message');
    this.stepQuantityMessage = this.container?.querySelector('.js-step-quantity-pricing-message');
    for (let i = 0, n = this.button.length; i < n; i++) {
      this.button[i].addEventListener("click", this.onButtonClickHandler.bind(this));
    }
    this.input.addEventListener("input", this.handleInputChange.bind(this));
    this.input.addEventListener("change", this.updatePriceItem.bind(this));
    this.updatePriceItem();
  }

  handleInputChange(event) {
    event.preventDefault();
    let value = parseInt(this.input.value) || 0;
    if (value <= this.productQuantity || Number.isNaN(value) || value == 0) {
      this.showMessage(true);
    } else {
      this.showMessage(false);
    }
  }

  onButtonClickHandler(event) {
    event.preventDefault();
    let previousValue = parseInt(this.input.value);
    let value;
    if (event.currentTarget.dataset.name === "plus") {
      value = parseInt(this.input.value) + 1;
    } else {
      value = parseInt(this.input.value) - 1;
    }
    if (value <= parseInt(this.productQuantity)) {
      event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();
      this.showMessage(true);
      this.toggleAnimation('animated');
    } else {
      this.showMessage(false);
      this.toggleAnimation('error-animated');
    }
    if (previousValue !== parseInt(this.input.value)) {
      this.input.dispatchEvent(this.changeEvent);
    }
    this.renderCartNumbers();
    this.handleQuickOrderListForm();
  }

  validateQuantity(value) {
    const minValue = parseInt(this.input.min);
    const maxValue = parseInt(this.input.max);
    const stepValue = parseInt(this.input.step);

    const toggleMessage = (message, show) => {
      message?.classList.toggle('d-none-important', !show);
    };

    const showMessages = (show, min, max, step) => {
      toggleMessage(this.quantityMessage, show);
      toggleMessage(this.minQuantityMessage, min);
      toggleMessage(this.maxQuantityMessage, max);
      toggleMessage(this.stepQuantityMessage, step);
    };

    if (value < minValue) {
      showMessages(true, true, false, false);
    } else if (value > maxValue) {
      showMessages(true, false, true, false);
    } else if (value % stepValue !== 0) {
      showMessages(true, false, false, true);
    } else {
      showMessages(false, false, false, false);
    }
  }

  toggleAnimation(animationClass) {
    const oppositeClass = animationClass === 'animated' ? 'error-animated' : 'animated';
    this.input.classList.remove(oppositeClass);
    if (this.input.classList.contains(animationClass)) this.input.classList.remove(animationClass);
    void this.input.offsetWidth; // Trigger reflow
    this.input.classList.add(animationClass);
  }

  showMessage(show) {
    if (!this.message) return;
    if (show) {
      if (!this.message.classList.contains('d-none-important')) this.message.classList.add('d-none-important');
      if (this.input.value > 0) this.validateQuantity(this.input.value);
    } else {
      const messages = [
        this.quantityMessage,
        this.minQuantityMessage,
        this.maxQuantityMessage,
        this.stepQuantityMessage
      ];
      
      messages.forEach(message => {
        if (message && !message.classList.contains('d-none-important')) {
          message.classList.add('d-none-important');
        }
      });
      this.message.classList.remove('d-none-important');
    }
  }

  updatePriceItem() {
    let minPricingMoney = null;
    let currentValue = parseInt(this.input.value);
    this.volumePricing?.querySelectorAll('li').forEach(item => {
      const quantity = parseInt(item.querySelector('.js-pricing-item-quantity').textContent);
      const priceText = item.querySelector('.js-pricing-item-price')?.textContent;
      if (currentValue >= quantity) {
        minPricingMoney = priceText;
      }
    });
    const priceDisplay = this.closest('.js-cart-drawer-item')?.querySelector('.price-item');
    if (minPricingMoney !== null && priceDisplay && priceDisplay.textContent !== minPricingMoney) {
      priceDisplay.textContent = minPricingMoney;
    }
  }

  handleQuickOrderListForm() {
    const container = this.closest('.js-cart-drawer-quantity');
    const variantId = container?.dataset.variantId;
    const quickOrderListVariant = SHTHelper.qsa('.js-order-list-item');
    quickOrderListVariant.forEach(item => {
      if (item.dataset.variantId == variantId) {
        const input = item.querySelector('.js-quantity-input');
        input.value = this.input.value;

        const changeEvent = new Event("change", { bubbles: true });
        input.dispatchEvent(changeEvent);
      }
    });
  }

  renderCartNumbers() {
    if (this.cartNumber && this.cartDrawerNumber) {
      let totalItems = 0;
      const inputs = SHTHelper.qsa(".js-cart-drawer-quantity-input");
      inputs.forEach(input => {
        totalItems += parseInt(input.value, 10);
      });
      this.cartNumber.innerHTML = totalItems;
      this.cartDrawerNumber.innerHTML = totalItems;
    }
  }
}

customElements.define("sht-cart-drwr-qty-inp", SHTCartDrawerQuantityInput);

class SHTCartDrawerRemoveButton extends SHTCustomComponent {
  constructor() {
    super();
    this.addEventListener("click", event => {
      event.preventDefault();
      this.closest("sht-cart-drwr-frm").updateQuantity(this.dataset.index, 0);
      this.handleQuickOrderListForm();
    });
  }

  handleQuickOrderListForm() {
    const container = this.closest('.js-cart-drawer-quantity');
    const variantId = container?.dataset.variantId;
    const quickOrderListVariant = SHTHelper.qsa('.js-order-list-item');
    quickOrderListVariant.forEach(item => {
      if (item.dataset.variantId == variantId) {
        const input = item.querySelector('.js-quantity-input');
        const removeBtn = item.querySelector('sht-remove-btn');
        input.value = 0;
        removeBtn.classList.add('d-none-important');

        const changeEvent = new Event("change", { bubbles: true });
        input.dispatchEvent(changeEvent);
      }
    });
  }
}
customElements.define("sht-cart-drwr-rmv-btn", SHTCartDrawerRemoveButton);

class SHTCartDrawerForm extends SHTCustomComponent {
  constructor() {
    super();
    this.totalItems = Array.from(this.$$(".js-cart-drawer-quantity-input")).reduce((total, ele) => total + parseInt(ele.value), 0);
    this.drawerCartElement = SHTHelper.qs("sht-cart-drwr");
    this.wrapperElement = this.drawerCartElement.querySelector(".js-cart-drawer-wrapper");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.cartDrawerNumber = SHTHelper.qs('.js-cart-drawer-count-number');
    this.linkToCart = SHTHelper.qs('.js-link-to-cart');
    this.quantityPricingBtn = this.$$('.js-quantity-pricing-btn');
    this.addEventListener(
      "change",
      SHTHelper.debounce(event => {
        this.onChange(event);
      }, 300)
    );
    this.onClickQuantityPricingBtn();
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.dataset.name);
  }

  onClickQuantityPricingBtn() {
    this.quantityPricingBtn?.forEach(btn => {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          btn.classList.toggle('active');
        });
      } else {
        btn.parentElement.addEventListener('mouseleave', () => {
          btn.classList.remove('active');
        });
        btn.parentElement.addEventListener('mouseenter', () => {
          btn.classList.add('active');
        });
      }

      document.addEventListener('click', (event) => {
        if (!btn.parentElement.contains(event.target)) {
          btn.classList.remove('active');
        }
      });
    });
  }

  renderContents(parsedState) {
    this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty");
    this.getSectionsToRender().forEach(section => {
      section.selectors?.forEach(e => {
        let tmpElement = SHTHelper.qid(section.id);

        if (tmpElement && parsedState.sections[section.section]) {
          let shouldBeReplacedElm = tmpElement.querySelector(e) || tmpElement;
          shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
        }
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [".js-cart-drawer-wrapper"],
      },
      {
        id: "mainCart",
        section: "main-cart",
        selectors: ["#mainCartContainer"],
      }
    ];
  }
  updateQuantity(line, quantity, name) {
    let sections = this.getSectionsToRender();
    let parsedState = {};
    if (this.cartNotification) {
      sections = [...sections, ...this.cartNotification.getSectionsToRender()];
    }

    let body = JSON.stringify({
      line,
      quantity,
      sections: sections.map(section => section.section),
      sections_url: window.location.pathname,
    });
    this.updateButtonState(true);
    fetch(`${window.routes.cart_change_url}`, {
      ...SHTHelper.fetchConfigJSON,
      ...{
        body,
      },
    })
      .then(response => {
        return response.text();
      })
      .then(state => {
        parsedState = JSON.parse(state);
        this.closest(".js-cart-drawer-wrapper").classList.toggle("is-empty", parsedState.item_count === 0);
        if (parsedState.item_count == 0) {
          let cartEmpty = SHTHelper.qs(".js-drawer-empty");
          let cartDrawer = SHTHelper.qs(".js-cart-drawer-wrapper");
          let cartCountNumber = SHTHelper.qs(".js-cart-count-number");
          cartDrawer.innerHTML = cartEmpty.innerHTML;
          cartCountNumber.innerHTML = 0;
          this.cartDrawerNumber.innerHTML = 0;
        }
        else {
          this.getSectionsToRender().forEach(section => {
            section.selectors.forEach(e => {
              let tepItem = SHTHelper.qid(section.id);
              if (tepItem) {
                let shouldBeReplacedElm = tepItem.querySelector(e) || tepItem;
                
                if (section.id === "cartDrawer" && quantity > 0) {
                  const updateSelectors = [".js-cart-drawer-free-shipping", ".js-cart-drawer-price", ".js-cart-drawer-footer"];
                  updateSelectors.forEach(selector => {
                    let targetElement = shouldBeReplacedElm.querySelector(selector);
                    if (targetElement) {
                      targetElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], selector);
                    }
                  });
                } else {
                  shouldBeReplacedElm.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], e);
                }
              }
            });
          });
          let lineItem = SHTHelper.qid(`cartDrawerItem-${line}`);
          if (lineItem) {
            let quantityBtn = lineItem.querySelector(`.js-cart-drawer-quantity-btn-${name}`);
            quantityBtn && quantityBtn.focus();
          }
          /* Update header status */
          if (this.cartNotification) {
            this.cartNotification.getSectionsToRender().forEach(section => {
              if (section.id == "header-cart-status") {
                SHTHelper.qs(section.space_selector).innerHTML = this.cartNotification.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }
            });
          }
          /* Update header status */
        }
      })
      .catch(e => {
        this.$(".js-cart-drawer-errors").textContent = SHTLanguage.cart.ERROR;
      })
      .finally(() => {
        this.updateButtonState(false);
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  updateButtonState(disabled) {
    let btn = this.$$(".js-cart-drawer-btn");
    let btnSubmit = this.drawerCartElement.querySelector(".js-cart-drawer-submit-btn");
    if (disabled) {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].setAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.setAttribute("disabled", "disabled");
    } else {
      for (let i = 0, n = btn.length; i < n; i++) {
        btn[i].removeAttribute("disabled", "disabled");
      }
      btnSubmit && btnSubmit.removeAttribute("disabled");
    }
  }
}
customElements.define("sht-cart-drwr-frm", SHTCartDrawerForm);

// Define a custom element for a quick shop dialog
class SHTDialogQuickShop extends SHTDialogCore {
  constructor() {
    super();
    this.viewFullBtn = this.querySelector(".js-view-full-btn");
    this.body = this.querySelector(".js-dialog-body");
    if (!this.constructor.cache) {
      this.constructor.cache = new Map();
    }
  }

  showModal(opener, flag) {
    SHTHelper.preventStickyHeaderReveal();
    this.opener = opener;
    this.processData(opener, flag);
    this.toggleAttribute("hidden", false);
    void this.offsetHeight;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.classList.toggle("is-active", true);
        this.opener?.removeAttribute("disabled");
        this.classList.remove('hidden-xs');
      });
    });
  }

  processData(opener, flag) {
    const productURL = opener.getAttribute("data-product-url");
    this.productElement = null;

    const cachedResponse = this.constructor.cache.get(productURL);
    if (cachedResponse) {
      this.updateProductElements(cachedResponse);
      return;
    }

    fetch(productURL)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.statusText}`);
        }
        return response.text();
      })
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        const cachedData = this.extractProductData(responseHTML);
        this.constructor.cache.set(productURL, cachedData);
        this.updateProductElements(cachedData);
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      })
      .finally(() => {
        SHTHelper.trapFocus(this);
      });
  }

  extractProductData(responseHTML) {
    const productElement = responseHTML.querySelector(".section-product-quick-view .js-quick-view-container");
    const viewFullBtnElement = responseHTML.querySelector(".section-product-quick-view .js-quick-view-footer");
    const colorScheme = responseHTML.querySelector('.section-product-quick-view .js-main-product')?.getAttribute("data-color");

    return { productElement, viewFullBtnElement, colorScheme };
  }

  updateProductElements({ productElement, viewFullBtnElement, colorScheme }) {
    this.body.innerHTML = productElement?.innerHTML || "";
    this.dynamicCheckoutBtn = this.querySelector("sht-load-dyn-co-btn");
    // this.productVariation = this.querySelector(".js-product-variation");

    if (colorScheme) {
      this.classList.add(colorScheme);
    }

    if (this.viewFullBtn) {
      this.viewFullBtn.innerHTML = viewFullBtnElement?.innerHTML || "";
    }

    // if (this.productVariation) {
    //   console.log(this.productVariation);
    // }

    if (window.Shopify?.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    if (window.SHTProductMediaItemModel) {
      window.SHTProductMediaItemModel.loadShopifyXR();
    }

    if (this.dynamicCheckoutBtn) {
      this.dynamicCheckoutBtn.loadDynamicCheckoutButton();
    }
  }

  closeModal() {
    void this.offsetHeight;
    this.classList.add("drawer-out");
    setTimeout(() => {
      this.toggleVisibility(false);
      this.classList.replace("drawer-out", "hidden-xs");
      this.viewFullBtn.innerHTML = "";
      this.body.innerHTML = "";
    }, 300);
  }

  toggleVisibility(isVisible) {
    this.toggleAttribute("hidden", !isVisible);
    this.classList.toggle("is-active", isVisible);
  }
}

customElements.define("sht-dialog-quickview", SHTDialogQuickShop);

class SHTMessageAddToCartSuccess extends SHTCustomComponent {
  constructor() {
    super();
  }

  setActiveMessage(active = true) {
    if (active) {
      this.classList.add("d-flex");
    } else {
      this.classList.remove("d-flex");
    }
  }
}
customElements.define("sht-message-success", SHTMessageAddToCartSuccess);

class SHTRecentlyViewedDrawer extends SHTCustomComponent {
  constructor() {
    super();
    this.cookieName = "sht-recently-viewed";
    this.limitProduct = parseInt(this.dataset.limit);
    this.productsArray = this.getArrayFromLocalStorage().slice(0, this.limitProduct);
    this.totalItems = parseInt(this.productsArray.length);

    this.enableVendor = this.dataset.enableVendor === "true";
    this.enablePrice = this.dataset.enablePrice === "true";
    this.enableRating = this.dataset.enableRating === "true";
    // this.enableStarRatingColor = this.dataset.enableStarRatingColor;

    this.body = this.$(".js-drawer-recently-viewed");
    this.recentlyViewedDrawer = SHTHelper.qs(".js-recently-viewed-drawer");
    this.recentlyViewedEmpty = this.$(".js-rv-empty");
  }

  connectedCallback() {
    this.checkRecentlyViewedState();
    this.processData();
  }

  processData() {
    let arraysProduct = this.getArrayFromLocalStorage().slice(0, this.limitProduct);

    const urls = arraysProduct.map((product) => `${product.url}?view=show-drawer-recently-viewed`);

    return Promise.all(urls.map((url) => this.fetchProductHTML(url)))
      .then((productHTMLs) => {
        productHTMLs.forEach((productHTML, index) => {
          if (!productHTML) return;

          const tempContainer = document.createElement("div");
          tempContainer.innerHTML = productHTML;
          const productContainer = tempContainer.firstElementChild;

          if (!this.enableVendor) productContainer.querySelector(".js-rv-vendor").classList.add("d-none-important");
          if (!this.enablePrice) productContainer.querySelector(".js-rv-price").classList.add("d-none-important");
          // TODO for rating
          if (!this.enableRating) productContainer.querySelector('.js-rv-rating').classList.add('d-none-important');
          // if (this.enableStarRatingColor) productContainer.querySelector('.js-rv-rating').style.color = this.enableStarRatingColor;

          this.body.appendChild(productContainer);
        });

        this.executeScriptElements(this.body);

        if (window.SHTProductMediaItemModel) {
          window.SHTProductMediaItemModel.loadShopifyXR();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  getArrayFromLocalStorage() {
    let arrayLocalStorage = localStorage.getItem(this.cookieName);
    return JSON.parse(arrayLocalStorage) || [];
  }

  removeDataFromLocalStorage() {
    localStorage.removeItem(this.cookieName);
  }

  async fetchProductHTML(url) {
    try {
      const response = await fetch(url);
      const responseText = await response.text();
      const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
      const productElement = responseHTML.querySelector(".section-drawer-recently-viewed");

      if (window.Shopify?.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      return productElement?.innerHTML || null;
    } catch (error) {
      console.error(`Failed to fetch product from ${url}:`, error);
      return null;
    }
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach(scriptElement => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach(attribute => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }

  checkRecentlyViewedState() {
    if (Shopify.designMode === true) this.removeDataFromLocalStorage();
    this.recentlyViewedDrawer.classList.toggle("d-none-important", (Shopify.designMode === true && this.totalItems > 0));
    this.recentlyViewedEmpty.classList.toggle("d-none-important", this.totalItems > 0);
  }
}
customElements.define("sht-recently-viewed-drawer", SHTRecentlyViewedDrawer);

class SHTDialogQuickBuy extends SHTDialogCore {
  constructor() {
    super();
    this.cartNotiType = SHTHelper.qs("body").getAttribute("data-cart-noti-type");
    this.cartType = SHTHelper.qs("body").getAttribute("data-cart-type");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.quickBuyDialog = SHTHelper.qs("sht-dialog-quick-buy");
    this.cache = new Map();
    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.checkBulk = false;
    this.interactionPopup = SHTHelper.qs("sht-interaction-popup");
  }

  handleSellingPlanErrorMessage(opener, showError) {
    const cardContainer = opener.closest(".js-product-card-block");
    const errorMessage = cardContainer?.querySelector(".js-selling-plan-error-message");
    if (showError === 'true') {
      errorMessage?.classList.remove('d-none-important');
    } else {
      if (!errorMessage?.classList.contains('d-none-important')) errorMessage?.classList.add('d-none-important');
    }
  }

  checkSellingPlan(opener, flag) {
    const sellingPlan = opener.dataset.sellingPlan;
    this.handleSellingPlanErrorMessage(opener, sellingPlan);
  }

  async showModal(opener, flag) {
    const sellingPlan = opener.dataset.sellingPlan;
    this.handleSellingPlanErrorMessage(opener, sellingPlan);
    if (sellingPlan !== 'true') {
      SHTHelper.preventStickyHeaderReveal();
      this.opener = opener;
      await this.processData(opener);
      this.toggleAttribute("hidden", false);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
        this.classList.add("is-active");
        void this.offsetHeight;
          this.classList.remove('hidden-xs');
        });
      });
    }
  }

  async processData(opener) {
    this.productElement = null;
    const dataType = opener.dataset.quickBuy;
    const productUrl = opener.getAttribute("data-product-url");

    if (this.cache.has(productUrl)) {
      this.renderQuickBuyContent(this.cache.get(productUrl), dataType);
      return;
    }

    try {
      const response = await fetch(productUrl);
      const responseText = await response.text();
      const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
      const productContent = responseHTML.querySelector(".js-quick-buy-content-wrapper");

      this.cache.set(productUrl, productContent);

      this.renderQuickBuyContent(productContent, dataType);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  }

  renderQuickBuyContent(productContent, dataType) {
    if (!productContent) return;

    this.querySelector(".js-quick-buy-dialog-content").innerHTML = productContent.innerHTML;

    const standardContainer = this.querySelectorAll(".js-quick-buy-standard-container");
    const bulkContainer = this.querySelectorAll(".js-quick-buy-bulk-container");
    const overlay = this.querySelector("sht-scroll-gradient-overlay");

    if (dataType === "standard") {
      bulkContainer.forEach(e => e.classList.add("d-none"));
      standardContainer.forEach(e => e.classList.remove("d-none"));
      overlay.classList.remove("gradient-overlay");
    } else if (dataType === "bulk") {
      this.checkBulk = true;
      standardContainer.forEach(e => e.classList.add("d-none"));
      bulkContainer.forEach(e => e.classList.remove("d-none"));
      if (!overlay.classList.contains("gradient-overlay")) overlay.classList.add("gradient-overlay");
    }
  }

  closeModal() {
    this.setAttribute("hidden", true);
    if(this.checkBulk) this.handleCartNotification();
    void this.offsetHeight;
    this.classList.add("drawer-out");
    setTimeout(() => {
      this.classList.remove("is-active");
      this.classList.replace("drawer-out", "hidden-xs");
      this.querySelector('.js-quick-buy-dialog-content').innerHTML = "";
    }, 300);
  }

  handleCartNotification() {
    const totalProductBulk = Number(this.querySelector('.js-total-product-bulk')?.value);

    switch (this.cartNotiType) {
      case "popover_notification":
        if (this.cartNotification) {
          if(this.quickBuyDialog && !this.quickBuyDialog.hasAttribute('hidden')) {
            this.quickBuyDialog.closeModal();
          }
          this.cartNotification.renderQuantityContents(true, totalProductBulk, this.quickBuyDialog.opener);
        }
        break;
      case "cart_noti":
        if (this.cartType === "drawer") {
          this.closeDialogAndOpenDrawer(this.quickBuyDialog);
          if (this.cartDrawer) {
            this.cartDrawer.querySelector(".js-drawer-message")?.setActiveMessage();
          }
          break;
        }
        if(this.cartType == "page") {
          window.location.assign(window.routes.cart_url);
          break;
        }
      case "do_nothing":
        break;
    }

    if (this.interactionPopup) this.interactionPopup.handleShowPopupAddToCart();
  }

  closeDialogAndOpenDrawer(dialog) {
    if (dialog) {
      // dialog.closeModal();
      dialog.animationsComplete().then(() => this.cartDrawer.openDrawer(dialog.opener));
    }
  }
}
customElements.define("sht-dialog-quick-buy", SHTDialogQuickBuy);

class SHTQuickOrderList extends SHTCustomComponent {
  constructor() {
    super();
    this.quickForm = this.$('sht-quick-shop-frm');
    this.cartNotiType = SHTHelper.qs("body").getAttribute("data-cart-noti-type");
    this.cartType = SHTHelper.qs("body").getAttribute("data-cart-type");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.quantityContainer = this.$$('.js-quantity-wrapper');
    this.deleteBtn = this.$$('.js-delete-variant-btn');
    this.allInputs = this.$$('.js-quantity-input');
    this.totalProductBulk = this.$('.js-variant-selector-quantity')?.textContent.replace(/\sitems?/, '');
    this.interactionPopup = SHTHelper.qs("sht-interaction-popup");
    this.eventsTriggered = {
      change: false,
      blur: false
    };
  }

  connectedCallback() {
    this.bindEventHandlers();
    this.quickForm.addEventListener('total-product-bulk-updated', this.handleTotalProductBulkUpdated.bind(this));
  }

  bindEventHandlers() {
    if (this.quickForm) {
      this.quickForm.addEventListener('change', this.handleChange.bind(this));
    }
    this.quantityContainer.forEach(item => {
      item.addEventListener('mouseleave', this.handleBlur.bind(this));
      item.addEventListener('mouseenter', this.handleEnter.bind(this));
    });
    this.deleteBtn.forEach(btn => btn.addEventListener('click', this.handleChange.bind(this)));
    this.allInputs.forEach(input => input.addEventListener('blur', this.handleBlur.bind(this)));
    this.addEventListener("on:cart-input:change", (event) => {
      this.elementFocus = event.detail.element;
    });
  }

  handleEnter() {
    this.eventsTriggered.blur = false;
  }

  handleChange() {
    this.eventsTriggered.change = true;
    this.handleTotalProductBulkUpdated();
  }

  handleBlur() {
    this.eventsTriggered.blur = true;
    this.handleTotalProductBulkUpdated();
  }

  checkAndHandleCartNotification(totalProductBulk) {
    if (this.eventsTriggered.change && this.eventsTriggered.blur) {
      setTimeout(() => this.handleCartNotification(totalProductBulk), 300);
      this.eventsTriggered.change = false;
      this.eventsTriggered.blur = false;
    }
  }

  handleTotalProductBulkUpdated(event) {
    if (event?.detail) {
      const { totalProductBulk } = event.detail;
      this.totalProductBulk = totalProductBulk;
      this.checkAndHandleCartNotification(this.totalProductBulk);
    }
  }

  handleCartNotification(totalProductBulk) {
    switch (this.cartNotiType) {
      case "popover_notification":
        if (this.cartNotification) {
          this.cartNotification.renderQuantityContents(true, totalProductBulk, this.elementFocus);
        }
        break;
      case "cart_noti":
        if (this.cartType === "drawer") {
          if (this.cartDrawer) {
            this.cartDrawer.openDrawer(this.elementFocus);
            this.cartDrawer.querySelector(".js-drawer-message")?.setActiveMessage();
          }
          break;
        }
        if(this.cartType === "page") {
          window.location.assign(window.routes.cart_url);
          break;
        }
      case "do_nothing":
        break;
    }

    if (this.interactionPopup) this.interactionPopup.handleShowPopupAddToCart();
  }
}
customElements.define("sht-quick-order-list", SHTQuickOrderList);

class SHTQuickShopForm extends SHTCustomComponent {
  constructor() {
    super();
    this.form = this.$("form");
    this.totalItems = Array.from(this.$$(".js-quantity-input")).reduce((total, ele) => total + parseInt(ele.value), 0);
    this.variantId = '';
    this.errorMessage = this.$$(".js-max-quantity-message");
    this.sellingPlanErrorMessage = this.$$(".js-selling-plan-error-message");
    this.quantityErrorMessage = this.$$(".js-quantity-pricing-message");
    this.totalProductBulk = this.closest('.js-quick-shop-container')?.querySelector('.js-total-product-bulk');
    this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm");
    this.headerCartStatus = SHTHelper.qs("#headerCartStatus");
    this.allInputs = this.$$('.js-quantity-input');
    this.previousItems = [];
    this.quantityPricingBtn = this.$$('.js-quantity-pricing-btn');
  }

  connectedCallback() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    const variantSelectorQuantity = this.closest('.js-quick-shop-container')?.querySelector('.js-variant-selector-quantity');
    if (this.totalProductBulk) this.totalProductBulk.value = Number(variantSelectorQuantity?.textContent.replace(/\sitems?/, ''));
    this.addEventListener('change', SHTHelper.debounce(this.onChange.bind(this), 300));
    this.allInputs.forEach(input => {
      input.addEventListener('input', this.onChange.bind(this));
    });
    this.onClickQuantityPricingBtn();
  }

  onClickQuantityPricingBtn() {
    this.quantityPricingBtn?.forEach(btn => {
      if (window.matchMedia("(max-width: 1024px)").matches) {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          btn.classList.toggle('active');
        });
      } else {
        btn.parentElement.addEventListener('mouseleave', () => {
          btn.classList.remove('active');
        });
        btn.parentElement.addEventListener('mouseenter', () => {
          btn.classList.add('active');
        });
      }

      document.addEventListener('click', (event) => {
        if (!btn.parentElement.contains(event.target)) {
          btn.classList.remove('active');
        }
      });
    });
  }

  onChange(event) {
    if (event.target.name === "note") return;
    const closestVariantItem = event.target.closest('.js-variant-bulk-item');
    if (!closestVariantItem) return;
    this.variantId = closestVariantItem.dataset.variantId;
    const items = {
      [this.variantId]: parseInt(event.target.value)
    }
    
    const allErrorMessagesHidden = areAllMessagesHidden(this.errorMessage);
    const allSellingPlanMessagesHidden = areAllMessagesHidden(this.sellingPlanErrorMessage);
    const allQuantityMessagesHidden = areAllMessagesHidden(this.quantityErrorMessage);
    if(allErrorMessagesHidden && allSellingPlanMessagesHidden && allQuantityMessagesHidden) this.updateQuantity(items, this.variantId);

    function areAllMessagesHidden(elements) {
      return Array.from(elements).every(element => element.classList.contains('d-none-important'));
    }
  }

  getSectionsToRender() {
    return [
      {
        id: `quickShopForm-${this.id}`,
        section: this.dataset.sectionId,
        selectors: [".js-quick-shop-form-wrapper"],
      },
      {
        id: "cartDrawer",
        section: "cart-drawer",
        selectors: [".js-cart-drawer-wrapper"],
      },
      {
        id: "HeaderCartStatus",
        section: "header-cart-status",
        selectors: [".shopify-section"],
      }
    ];
  }

  updateQuantity(items, variantId) {
    const selectors = ['.js-variant-selector-quantity', '.js-bulk-total-price'];
    const section = this.getSectionsToRender().map((section) => section.section);
    let body = JSON.stringify({
      updates: items,
      sections: section,
      sections_url: this.dataset.url
    });
    fetch(`${window.routes.cart_update_url}`, {
      ...SHTHelper.fetchConfigJSON,
      ...{ body },
    })
    .then((response) => response.text())
    .then((state) => {
      let parsedState = JSON.parse(state);
      if (!parsedState.errors) {
        let item = parsedState.items.find((item) => item.id == variantId);
        const totalVariantPrice = this.querySelector(`#totalPrice-${this.dataset.sectionId}-${variantId}`);
        const dialogContent = this.closest('.js-quick-shop-container');
        const variantSelectorQuantity = dialogContent?.querySelector('.js-variant-selector-quantity');
        if (this.previousItems.length > 0 && this.previousItems.length > parsedState.items.length) {
          item = this.previousItems.filter(previousItem => !parsedState.items.some(newItem => previousItem.id === newItem.id))[0];
          item.quantity = 0;
        }
        if (this.cartDrawerForm && item) {
          item.sections = parsedState.sections;
          this.cartDrawerForm.renderContents(item);
        }
        if(this.headerCartStatus) {
          this.headerCartStatus.innerHTML = this.getSectionInnerHTML(parsedState.sections["header-cart-status"], ".shopify-section");
        }
        
        selectors.forEach(selector => {
          const updatedVariant = this.closest('.js-quick-shop-container')?.querySelector(selector);
          if (updatedVariant) {
            updatedVariant.innerHTML = this.getSectionInnerHTML(parsedState.sections[this.dataset.sectionId], selector);
          }
        });
        
        if (totalVariantPrice) {
          totalVariantPrice.innerHTML = this.getSectionInnerHTML(parsedState.sections[this.dataset.sectionId], `#totalPrice-${this.dataset.sectionId}-${variantId}`);
        }
        this.variantId = '';
        const totalProductBulk = Number(variantSelectorQuantity?.textContent.replace(/\sitems?/, ''));
        if (this.totalProductBulk) this.totalProductBulk.value = totalProductBulk;
        this.dispatchEvent(new CustomEvent("total-product-bulk-updated", {
          detail: { totalProductBulk },
          bubbles: true,
          composed: true
        }));
        this.previousItems = parsedState.items;
      }
    })
    .catch((e) => {
      // this.$(".js-cart-form-errors").textContent = SHTLanguage.cart.ERROR;
      console.log(e);
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define("sht-quick-shop-frm", SHTQuickShopForm);

class SHTRemoveButton extends SHTCustomComponent {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.container = this.closest('.js-quantity-wrapper');
    this.message = this.container?.querySelector('.js-max-quantity-message');
    this.sellingPlanMessage = this.container?.querySelector('.js-selling-plan-error-message');
    this.cartDrawerNumber = SHTHelper.qs('.js-cart-drawer-count-number');
    this.cartCountNumber = SHTHelper.qs(".js-cart-count-number");
  }

  connectedCallback() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.addEventListener("click", (event) => {
      this.cartDrawerNumber.innerHTML = this.cartCountNumber.innerHTML;
      event.preventDefault();
      this.updateVariant(this.dataset.variantId, 0);
      this.updateErrorMessage();
    });

    this.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        this.updateVariant(this.dataset.variantId, 0);
        this.updateErrorMessage();
      }
    });
  }

  updateErrorMessage() {
    const maxQuantityMessage = this.container?.querySelector('.js-max-quantity-message');
    const sellingPlanMessage = this.container?.querySelector('.js-selling-plan-error-message');
    const quantityPricingMessage = this.container?.querySelector('.js-quantity-pricing-message');
    [maxQuantityMessage, sellingPlanMessage, quantityPricingMessage].forEach(element => element.classList.add('d-none-important'));
  }

  updateVariant(variantId, quantity) {
    this.queue.push({ variantId, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue, variantId).then(() => {
            this.requestStarted = false;
          });
          this.closest('.js-quantity-wrapper').querySelector('.js-quantity-input').value = 0;
          [this, this.message, this.sellingPlanMessage].forEach(element => element.classList.add('d-none-important'));
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  async sendRequest(queue, variantId) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.variantId)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('sht-quick-shop-frm');
    quickBulkElement.updateQuantity(items, variantId);
  }
}

customElements.define("sht-remove-btn", SHTRemoveButton);

class SHTCartDrawerComplementary extends SHTCarousel {
  constructor() {
    super();
    this.textListIds = this.dataset.productId;
    this.url = this.dataset.url;
    this.body = this.$('.js-cart-complementary-product-main');
    this.cartDrawerSection = SHTHelper.qs("#shtCartDrawer");
    this.limitProduct = parseInt(this.cartDrawerSection.dataset.limit);
    this.complementaryHeading = this.cartDrawerSection.dataset.heading;
    this.complementaryHeadingContent = this.$('.js-cart-complementary-heading-content');
    this.arrayIds = this.handleListId(this.textListIds);
    this.complementaryProductIds = new Set();
  }

  connectedCallback() {
    super.connectedCallback();
    this.handleIntersection();
  }

  handleListId(ids) {
    return ids.split(',');
  }

  async handleIntersection() {
    try {
      const urls = this.arrayIds.map((id) => `${this.url}${id}`);
      const productHTMLs = await Promise.all(urls.map((url) => this.fetchProductHTML(url)));

      const targetContainer = this.querySelector(".js-cart-complementary-product-list");
      const btnNavigation = this.querySelector(".js-cart-complementary-product-btn");
      if (!targetContainer) {
        return;
      }

      let renderedProductCount = 0;
      const maxProducts = parseInt(this.limitProduct, 10);

      for (const productHTML of productHTMLs) {
        if (renderedProductCount >= maxProducts) break;
        const tempContainer = document.createElement("div");
        tempContainer.innerHTML = productHTML;
        btnNavigation.classList.add("d-none-important");
        this.complementaryHeadingContent.innerHTML = this.complementaryHeading;

        const complementaryProducts = tempContainer.querySelectorAll(".js-cart-complementary-product-item");
        for (const product of complementaryProducts) {
          if (renderedProductCount >= maxProducts) break;

          const productId = product.dataset.id;
          if (productId && !this.complementaryProductIds.has(productId)) {
            this.body.classList.remove("d-none");
            this.complementaryProductIds.add(productId);

            const clonedProduct = product.cloneNode(true);
            targetContainer.appendChild(clonedProduct);

            renderedProductCount++;
          }
        }
      }

      if (targetContainer.childElementCount === 1) {
        targetContainer.classList.add("complementary-one-value");
        btnNavigation.classList.add("d-none-important");
      } else if (targetContainer.childElementCount === 2) {
        targetContainer.classList.remove("complementary-one-value");
        btnNavigation.classList.add("d-none-important");
      } else {
        targetContainer.classList.remove("complementary-one-value");
        btnNavigation.classList.remove("d-none-important");
      }

      this.carousels = this.body.querySelectorAll('.js-carousel-item');
      this.updateVisibility();
    } catch (error) {
      console.error('Error fetching complementary products:', error);
    }
  }

  updateVisibility() {
    const { enableVendor, enablePrice } = this.cartDrawerSection.dataset;

    const complementaryItems = [
      { isEnabled: enableVendor !== 'false', elements: this.$$('.js-cart-complementary-product-item .js-mini-card-vendor') },
      { isEnabled: enablePrice !== 'false', elements: this.$$('.js-cart-complementary-product-item .js-mini-card-price') }
    ];

    complementaryItems.forEach(({ isEnabled, elements }) => {
      if (!isEnabled) {
        elements.forEach(item => item.classList.add('d-none-important'));
      }
    });
  }

  async fetchProductHTML(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error(`Failed to fetch product from ${url}:`, response.statusText);
        return null;
      }

      const text = await response.text();
      const html = document.createElement("div");
      html.innerHTML = text;

      const recommendations = html.querySelector(".js-cart-complementary-product-list");
      if (recommendations && recommendations.innerHTML.trim().length) {
        return recommendations.innerHTML;
      }

      return null;
    } catch (error) {
      console.error(`Error fetching product from ${url}:`, error);
      return null;
    }
  }
}

customElements.define("sht-cart-drwr-cpry", SHTCartDrawerComplementary);

class SHTSpotlightQuote extends SHTCustomComponent {
  constructor() {
    super();
    this.spotlightItems = this.$(".js-spotlight-items");
    this.totalElm = this.$(".js-spotlight-total");
    this.currentElm = this.$(".js-spotlight-current");
    this.separatorElm = this.$(".js-spotlight-separator");
    this.prevBtn = this.$(".js-spotlight-prev-btn");
    this.nextBtn = this.$(".js-spotlight-next-btn");
    this.startNStopBtn = this.$(".js-spotlight-start-n-stop-btn");
    this.imageItems = this.$$(".js-spotlight-content");
    this.pauseIcon = this.startNStopBtn?.querySelector(".js-spotlight-pause-icon");
    this.playIcon = this.startNStopBtn?.querySelector(".js-spotlight-play-icon");
    this.properties = JSON.parse(this.dataset.spotlightProperties);

    this.autoplay = this.properties.autoplay || false;
    this.image = null;
    this.template = null;
    this.current = 1;
    this.anchors = [];
    this.lastScrollTimeout = null;
    this.autoplayInterval = null;
    this.content = this.spotlightItems.children;
    this.total = this.content.length;
    this.spotlightItems.scrollLeft = 0;
    this.observer = null;
    this.isPaused = false;
    this.pagination = this.$(".js-spotlight-pagination");
    this.pagination_items = this.pagination?.querySelectorAll(".js-spotlight-pagination-item");
  }
  cloneSlideItem() {
    if (this.total == 2) {
      let firstItem = this.spotlightItems.querySelector(`.js-spotlight-item:first-of-type`);
      let lastItem = this.spotlightItems.querySelector(`.js-spotlight-item:last-of-type`);
      if (lastItem) {
        let clonedItem = lastItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.spotlightItems.append(clonedItem);
      }
      if (firstItem) {
        let clonedItem = firstItem.cloneNode(true);
        clonedItem.classList.add("slider-slide--clone");
        this.spotlightItems.append(clonedItem);
      }
    }
  }
  execute() {
    if (this.total <= 1) return;

    this.cloneSlideItem();
    this.observerSlideShow();
    this.prepare();
    this.bindEventHandlers();
    this.init();
  }
  connectedCallback() {
    this.execute();
  }
  init() {
    this.slideItems = this.$$(".js-spotlight-item");
    this.currentItemClass = "js-spotlight-content--current";
    this.slideContainer = this.$(".js-spotlight-items");
    this.containerObserver = this.$(".js-spotlight");
    this.slideContent = this.$$(".js-spotlight-content");
    if (this.autoplay) {
      this.resumeAutoPlay();
      this.isPaused = true;
    }
    this.updateSort();
  }
  updateSort() {
    if (this.total <= 1) return;

    let scrollLeftB = this.spotlightItems.scrollLeft;
    let scrollLeft = Math.round(scrollLeftB);
    let offsetWidth = this.spotlightItems.offsetWidth;
    let scrollWidth = this.spotlightItems.scrollWidth;
    if (scrollLeft < offsetWidth) {
      this.spotlightItems.prepend(this.content[this.total - 1]);
      this.spotlightItems.scrollLeft = scrollLeft + offsetWidth;
    }
    if (Math.floor(scrollWidth - scrollLeftB) <= offsetWidth) {
      this.spotlightItems.append(this.content[0]);
      this.spotlightItems.scrollLeft = scrollLeft - offsetWidth;
    }
  }
  startAutoPlay() {
    if (this.autoplay) {
      this.autoplayInterval = setInterval(
        function () {
          this.nextSlide();
        }.bind(this),
        this.properties.duration
      );
    }
  }
  bindEventHandlers() {
    this.spotlightItems.addEventListener(
      "wheel",
      function (evt) {
        if (Math.abs(evt.deltaX) == 5) {
          this.stopAutoPlay();
        }
      }.bind(this),
      {
        passive: true,
      }
    );
    this.spotlightItems.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100));
    this.nextBtn.addEventListener(
      "click",
      SHTHelper.debounce(
        function () {
          this.nextSlide();
          this.stopAutoPlay();
        }.bind(this),
        300
      )
    );
    this.prevBtn.addEventListener(
      "click",
      SHTHelper.debounce(
        function () {
          this.prevSlide();
          this.stopAutoPlay();
        }.bind(this),
        300
      )
    );
    this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this));
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this.handleScrollToItemInAdmin();
    }
  }
  onStartNStopEventHandle(e) {
    e.preventDefault();
    if (this.autoplay) {
      this.stopAutoPlay();
    } else {
      this.resumeAutoPlay();
    }
  }
  stopAutoPlay() {
    clearInterval(this.autoplayInterval);

    this.pauseIcon.classList.add("d-none");
    this.playIcon.classList.remove("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
    this.spotlightItems.setAttribute("aria-live", "polite");
    this.autoplay = false;
  }
  resumeAutoPlay() {
    this.autoplay = true;

    this.pauseIcon.classList.remove("d-none");
    this.playIcon.classList.add("d-none");

    this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]);
    this.spotlightItems.setAttribute("aria-live", "off");
    this.startAutoPlay();
  }
  onScrollEventHandle(e) {
    e.preventDefault();
    if (this.lastScrollTimeout) {
      clearTimeout(this.lastScrollTimeout);
    }
    this.lastScrollTimeout = setTimeout(
      function () {
        this.updateSort();
      }.bind(this),
      100
    );
    this.updateCurrent();
    this.updatePagination();
  }
  updatePagination() {
    if (this.pagination) {
      let item = this.pagination.querySelector(`li[data-spotlight-index="${this.current}"]`);
      if (item) {
        this.pagination_items.forEach(el => el.classList.remove("is-active"));
        item.classList.add("is-active");
      }
    }
  }
  prepare() {
    this.totalElm.textContent = this.total;
    this.currentElm.textContent = this.current;
    this.separatorElm.textContent = this.properties.separatorText;
    if (this.autoplay) {
      this.startNStopBtn.toggleAttribute("hidden", false);
      this.startNStopBtn.querySelector(".js-spotlight-pause-icon").classList.remove("d-none");
      this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]);
      this.spotlightItems.setAttribute("aria-live", "off");
    }
  }
  updateCurrent() {
    let currentItem = this.$(".js-spotlight-content--current");
    if (currentItem) {
      this.current = currentItem.dataset.spotlightIndex;
    }
    this.currentElm.textContent = this.current;
  }
  prevSlide() {
    if (this.total > 2) {
      let index = +this.current - 1;
      if (this.current == 1) {
        index = this.total;
      }
      let matchingItem = this.$(`div[data-item-index="${index}"]`);
      if (matchingItem) {
        this.spotlightItems.scrollTo({ left: this.spotlightItems.scrollLeft - matchingItem.offsetWidth, behavior: "smooth" });
      }
    } else {
      let index = this.$(".slider-slide--active").dataset.itemIndex == 2 ? 1 : 2;
      let matchingItem = this.$(`div[data-item-index="${index}"]`);
      if (matchingItem) {
        this.spotlightItems.scrollTo({ left: this.spotlightItems.scrollLeft - matchingItem.offsetWidth, behavior: "smooth" });
      }
    }
  }
  nextSlide() {
    if (this.total > 2) {
      let index = +this.current + 1;
      if (this.current == this.total) {
        index = 1;
      }
      let matchingItem = this.$(`div[data-item-index="${index}"]`);
      if (matchingItem) {
        this.spotlightItems.scrollTo({ left: this.spotlightItems.scrollLeft + matchingItem.offsetWidth, behavior: "smooth" });
      }
    } else {
      let matchingItem = this.$(`.slider-slide--active + .js-spotlight-item`);
      if (matchingItem) {
        this.spotlightItems.scrollTo({ left: this.spotlightItems.scrollLeft + matchingItem.offsetWidth, behavior: "smooth" });
      }
    }
  }
  observerSlideShow() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          const contentElement = entry.target.querySelector(".js-spotlight-content");
          const slideItem = contentElement.closest(".js-spotlight-item");
          if (entry.isIntersecting) {
            if (contentElement) {
              this.clearAllCurrentItemClass();
              this.clearAllActiveItemClass();
              contentElement.classList.add(this.currentItemClass);
              this.setSlideItemVisibility(true, slideItem);
            }
          } else {
            this.setSlideItemVisibility(false, slideItem);
          }
        });
      },
      {
        root: this.containerObserver,
        rootMargin: `100px -2px 100px -2px`,
        threshold: 0.5,
      }
    );
    this.slideItems = this.$$(".js-spotlight-item");
    this.slideItems.forEach(item => {
      if (item) {
        this.observer.observe(item);
      }
    });
  }
  clearAllCurrentItemClass() {
    this.slideContent.forEach(item => {
      item.classList.remove(this.currentItemClass);
      const slideItem = item.closest(".js-spotlight-item");
      slideItem.classList.remove(this.currentItemClass);
    });
  }
  clearAllActiveItemClass() {
    this.slideItems.forEach(item => {
      item.classList.remove(this.currentItemClass);
    });
  }
  setSlideItemVisibility(flag, slideItem) {
    if (!flag) {
      slideItem.setAttribute("aria-hidden", "true");
      slideItem.setAttribute("tabindex", "-1");
      slideItem.classList.remove("slider-slide--active");
    } else {
      slideItem.setAttribute("aria-hidden", "false");
      slideItem.removeAttribute("tabindex");
      slideItem.classList.add("slider-slide--active");
    }
  }
  handleScrollToItemInAdmin() {
    let inSlideshow = true;
    document.addEventListener('shopify:block:select', (event) => {
      if(event.target.classList.contains('slider-slide')) {
        inSlideshow = true;
        const slideshowItems = event.target.closest('.js-spotlight-items');
        slideshowItems.scrollTo({
          left: event.target.offsetLeft
        });
        this.stopAutoPlay();
      }
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      if(event.target.classList.contains('slider-slide')) {
        inSlideshow = false;
        setTimeout(() => {
          if(!inSlideshow && JSON.parse(this.dataset.spotlightProperties).autoplay) {
            this.resumeAutoPlay();
          }
        }, 500);
      }
    });
  }
}
customElements.define("sht-spotlight-quote", SHTSpotlightQuote);

class SHTCopyToClipboard extends SHTCustomComponent {
  constructor() {
    super();
    this.copyButton = this.$(".js-copy-button");
    this.copyText = this.$(".js-copy-text");
    this.successMessage = this.$(".js-copy-success-message");

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.copyButton?.addEventListener("click", this.handleCopy.bind(this));
  }

  async handleCopy() {
    try {
      const textToCopy = this.copyText.textContent;
      await navigator.clipboard.writeText(textToCopy);

      this.copyButton.classList.add("copied");
      this.successMessage.style.display = "flex";
      setTimeout(() => {
        this.copyButton.classList.remove("copied");
        this.successMessage.style.display = "none";
      }, 3000);

    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  }
}

customElements.define("sht-copy-clipboard", SHTCopyToClipboard);

document.addEventListener('DOMContentLoaded', () => {
  const cartBtn = SHTHelper.qs('.js-cart-drawer-trigger');
  const cartDrawerSection = SHTHelper.qs('sht-cart-drwr');

  if (!cartDrawerSection && cartBtn) {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      if (cartBtn.dataset.event === 'drawer') {
        cartBtn.removeAttribute('onclick');

        cartBtn.addEventListener('click', (event) => {
          event.preventDefault();
          alert('Cart is unavailable due to a conflict in the cart settings. Please unhide the ‘Cart Drawer’ section or change the search behavior to ‘Cart Page’ to resolve this issue. This message is only visible in the theme editor. In the live store, the system will automatically default to the ‘Cart Page’.');
        });
      }
    }
  }
});

class SHTDialogProductBundle extends SHTDialogCore {
  constructor() {
    super();
    this.bundlePanel = null;
    this.sectionId = this.dataset.section;
  }

  showModal(opener, sectionId) {
    this.opener = opener;
    this.opener?.setAttribute("disabled", "disabled");
    this.processData(opener, sectionId);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        void this.offsetHeight;
        this.classList.add("is-active");
        this.classList.remove('hidden-xs');
      });
    });
  }

  processData(opener, sectionId) {
    fetch(opener.getAttribute("data-product-url"))
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        const productElement = responseHTML.querySelector(".section-product-bundle-dialog");

        if (window.Shopify?.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        this.body.innerHTML = productElement.innerHTML;
        const btnAddToBundle = this.body.querySelector('.js-btn-add-to-bundle');

        const scrollElement = productElement.querySelector(".js-scroll-element");
        this.handleInitOverflow(scrollElement);

        this.bundlePanel = SHTHelper.qs(`sht-product-bundle-panel[data-section="${sectionId}"]`);

        this.bundlePanel?.initialize(btnAddToBundle, opener);
      })
      .finally(() => {
        this.toggleAttribute("hidden", false);
        this.opener?.removeAttribute("disabled");
      });
  }

  handleInitOverflow(scrollElement) {
    if (scrollElement) {
      const isScroll = scrollElement.scrollHeight <= scrollElement.clientHeight;
      if (isScroll) {
        this.querySelector('.js-bundle-body').classList.remove('gradient-overlay');
      }
    }
  }

  closeModal() {
    this.setAttribute("hidden", true);
    void this.offsetHeight;
    this.classList.add("drawer-out");
    setTimeout(() => {
      this.classList.remove("is-active");
      this.classList.replace("drawer-out", "hidden-xs");
    }, 300);
    setTimeout(() => {
      this.body.innerHTML = "";
      this.bundlePanel = null;
    }, 300);
  }
}
customElements.define('sht-dialog-product-bundle', SHTDialogProductBundle);
class SHTProductBundlePanel extends SHTCustomComponent {
  constructor() {
    super();
    this.sectionId = this.dataset.section;
    this.dialogBundle = SHTHelper.qs(`sht-dialog-product-bundle`);
    this.bundleItems = this.querySelector('.js-bundle-panel-items');
    this.placeholderBundle = this.querySelector('.js-placeholder-compare');
    this.bundleForm = this.querySelector('sht-prd-bundle-frm');
    this.productCount = 0;
    this.minProducts = parseInt(this.dataset.minProducts) || 2;
    this.enableUnlimitedAdd = this.dataset.enableUnlimitedAdd === 'true';
    this.boundHandleBundleItemsClick = this.handleBundleItemsClick.bind(this);
    this.bundlePanelHeader = this.querySelector('.js-bundle-panel-header');
    this.bundlePanelBody = this.querySelector('.js-bundle-panel-body');
    this.bundlePanelFooter = this.querySelector('.js-bundle-panel-footer');
    this.bundlePanelCarousel = this.bundlePanelBody.querySelector('.sht-carousel');
    this.bundlePanelButton = this.bundlePanelFooter.querySelector('.js-bundle-button');
    this.calculateBundleHeight();
  }

  initialize(btnAddToBundle, opener, noVariant = false) {
    this.updateBundleState();
    this.bindEventHandlers(btnAddToBundle, opener, noVariant);
    this.initializeScrollBehavior();
  }

  bindEventHandlers(btnAddToBundle, opener, noVariant) {
    this.bundleItems?.removeEventListener('click', this.boundHandleBundleItemsClick);

    if (!noVariant) {
      btnAddToBundle.addEventListener('click', (event) => {
        event.preventDefault();
        btnAddToBundle.disabled = true;
        this.handleAddToBundle(btnAddToBundle, opener);
      });
    } else {
      this.handleAddToBundle(btnAddToBundle, opener, noVariant);
    }

    this.bundleItems?.addEventListener('click', this.boundHandleBundleItemsClick);
  }

  handleBundleItemsClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const removeButton = event.target.closest('.js-remove-product-bundle');
    if (!removeButton) return;

    const carouselItem = removeButton.closest('sht-carousel-itm');
    if (!carouselItem) return;

    this.removeFromBundle(carouselItem, removeButton);

    const carouselItemIndex = carouselItem?.getAttribute('data-item-index');
    if (carouselItemIndex) {
      this.bundleForm.removeBundleProduct(carouselItemIndex);
    }
  }

  handleAddToBundle(button, opener, noVariant = false) {
    if (!noVariant) {
      const productUrl = button.getAttribute('data-product-url');
      const variantInput = button.parentElement.querySelector('input[name="id"]');
      if (!variantInput) return;
      const productId = variantInput.value;
      this.addToBundle(productId, productUrl, opener);
    } else {
      const productUrl = button.getAttribute('data-product-url');
      const productId = button.getAttribute('data-product-id');
      this.addToBundle(productId, productUrl, opener, noVariant);
    }
  }

  addToBundle(productId, productUrl, opener) {
    if (!this.bundleItems) return;

    this.renderProductInfo(productId, productUrl, opener)
      .then(() => {
        this.updateBundleState();
        this.initializeCarousel();

        this.bundleForm?.addBundleProduct(productId);

        if (this.container) {
          this.container.scrollTo({
            left: this.container.scrollWidth,
            behavior: 'smooth'
          });
        }

        SHTHelper.removeTrapFocus(opener);

        if (this.productCount >= 1 && this.classList.contains('expanded')) {
          this.bundlePanelBody.style.display = 'block';
          requestAnimationFrame(() => {
            this.bundlePanelBody.style.opacity = '1';
            this.bundlePanelBody.style.height = '100%';
            this.calculateBundleHeight();
          });
        } else if (this.productCount === 1) {
          this.classList.add('expanded');
          this.bundlePanelButton.style.width = window.innerWidth <= 459 ? '100%' : 'auto';
          this.addEventListener('transitionend', () => {
            this.bundlePanelBody.style.display = 'block';
            requestAnimationFrame(() => {
              this.bundlePanelBody.style.opacity = '1';
              this.bundlePanelBody.style.height = '100%';
              this.calculateBundleHeight();
            });
          }, { once: true });
        }

        if (this.productCount >= 3) this.placeholderBundle.classList.add('d-none-important');
      })
      .catch((error) => {
        console.error('Error adding to bundle:', error);
      });
  }

  renderProductInfo(productId, productUrl, opener) {
    return fetch(`${productUrl}?variant=${productId}&section_id=product-bundle-mini-card`)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        const markup = new DOMParser().parseFromString(responseText, "text/html");
        const productMiniCard = markup.querySelector('.section-mini-card-product-bundle');

        if (!productMiniCard) throw new Error('Product mini card not found');

        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = productMiniCard.innerHTML;

        opener.disabled = false;

        const carouselItem = tempContainer.querySelector('sht-carousel-itm');
        if (carouselItem) {
          const newIndex = this.productCount + 1;
          const totalItems = this.minProducts;
          carouselItem.setAttribute('aria-label', `Slide ${newIndex} of ${totalItems}`);
          carouselItem.setAttribute('data-item-index', newIndex.toString());
          const idBundle = opener.getAttribute('data-id-product-bundle');
          if (!this.enableUnlimitedAdd && idBundle) {
            carouselItem.querySelector('.js-remove-product-bundle').setAttribute('data-id-bundle', idBundle);
          }
        }

        const fragment = document.createDocumentFragment();
        const elements = Array.from(tempContainer.children);

        elements.forEach((element) => {
          // element.style.transition = 'var(--duration-fast-01) var(--s-ease-e)';
          element.style.opacity = '0';
          fragment.appendChild(element);
        });

        this.bundleItems.appendChild(fragment);
        requestAnimationFrame(() => {
          elements.forEach((element) => {
            element.style.opacity = '1';
          });
        });

        this.updateButtonSelected(opener);
        this.productCount++;
        this.dialogBundle.closeModal();
      })
      .catch((error) => {
        console.error('Error rendering product info:', error);
      });
  }


  updateCarouselItemsAttributes() {
    if (!this.bundleItems) return;

    const carouselItems = this.bundleItems.querySelectorAll('sht-carousel-itm');
    carouselItems.forEach((item, index) => {
      const newIndex = index + 1;
      const totalItems = this.minProducts;

      item.setAttribute('aria-label', `Slide ${newIndex} of ${totalItems}`);
      item.setAttribute('data-item-index', newIndex.toString());
    });
  }

  updateButtonSelected(opener) {
    if (opener && !this.enableUnlimitedAdd) {
      if (!opener.dataset.originalText) {
        opener.dataset.originalText = opener.innerHTML;
      }
      opener.disabled = true;
      opener.innerHTML = 'Added to bundle';
    }
  }

  removeFromBundle(bundleItem, removeButton) {
    let dataIdBundle = removeButton.getAttribute('data-id-bundle');

    if (!this.enableUnlimitedAdd && dataIdBundle) {
      const addToBundleBtn = document.querySelector(`[data-id-product-bundle="${dataIdBundle}"]`);
      if (addToBundleBtn) {
        addToBundleBtn.disabled = false;
        if (addToBundleBtn.dataset.originalText) {
          addToBundleBtn.innerHTML = addToBundleBtn.dataset.originalText;
        }
      }
    }
    if (!bundleItem) return;

    bundleItem.remove();
    this.productCount = Math.max(0, this.productCount - 1);


    this.updateCarouselItemsAttributes();
    this.updateBundleState();
    this.initializeCarousel();

    if (this.productCount === 0) {
      this.classList.remove('expanded');
      this.bundlePanelButton.style.width = window.innerWidth <= 459 ? '100%' : 'calc(320px - var(--fix-s)*2)';
      this.addEventListener('transitionstart', () => {
        this.bundlePanelBody.style.display = 'none';
        requestAnimationFrame(() => {
          this.bundlePanelBody.style.opacity = '0';
          this.bundlePanelBody.style.height = '0';
          this.calculateBundleHeight();
        });
      }, { once: true });
    }

    if (this.productCount < 3) {
      this.placeholderBundle.classList.remove('d-none-important');
    }

  }

  updateBundleState() {
    const counter = this.querySelector('.js-quatity-product-bundle');
    if (counter) counter.textContent = this.productCount;

    const addToCartBtn = this.querySelector('.js-bundle-panel-footer .js-bundle-button');
    if (addToCartBtn) {
      addToCartBtn.disabled = this.productCount < this.minProducts;
    }
    const addToCartBtnText = this.querySelector('.js-product-bundle-form-submit-btn-text');
    if (addToCartBtnText) {
      addToCartBtnText.textContent =
        this.productCount < this.minProducts
          ? `Add ${this.minProducts - this.productCount} more`
          : 'Add to cart';
    }
  }

  initializeCarousel() {
    this.carousels = this.querySelectorAll('.js-carousel-item');
    this.container = this.querySelector('.js-carousel-items');
    this.prevButton = this.querySelector('.js-carousel-prev-btn');
    this.nextButton = this.querySelector('.js-carousel-next-btn');
    this.paginationElement = this.$(".js-carousel-pagination");
    this.itemsToShow = Array.from(this.carousels).filter(element => element.clientWidth > 0);

    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }

    this.gutter = parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) + parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"));
    this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor((this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset);

    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.updateCarousel();

    if (!this.container || !this.prevButton || !this.nextButton) return;

    this.prevButton?.addEventListener("click", (e) => {
      this.onButtonClick(e);
    });
    this.nextButton?.addEventListener("click", (e) => {
      this.onButtonClick(e);
    });
    this.container.addEventListener("scroll", () => {
      SHTHelper.debounce(this.updateCarousel(), 100);
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    if (this.container.scrollLeft == 0 || this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      gutter = this.gutter;
    }
    this.itemScrollPosition = event.currentTarget.name === "next" ? this.container.scrollLeft - gutter + step * this.itemOffset : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }

  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this.container,
          },
        })
      );
    }
    if (this.isItemVisible(this.itemsToShow[0]) && this.container.scrollLeft === 0) {
      this.prevButton?.setAttribute("disabled", "disabled");
    } else {
      this.prevButton?.removeAttribute("disabled");
    }

    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextButton?.setAttribute("disabled", "disabled");
    } else {
      this.nextButton?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }
  }

  isItemVisible(element, offset = 0) {
    if (typeof element == "undefined") return false;

    let lastVisibleItem = this.container.clientWidth + this.container.scrollLeft;

    return Math.floor(element.getBoundingClientRect().width + element.offsetLeft) <= Math.round(lastVisibleItem) && element.offsetLeft >= this.container.scrollLeft;
  }

  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
    } else {
      this.paginationElement?.classList.add("d-none-important");
    }
  }

  initializeScrollBehavior() {
    const scrollElement = this.querySelector(".js-scroll-element");
    const bundleBody = this.querySelector('.js-bundle-body');

    if (scrollElement?.scrollHeight <= scrollElement?.clientHeight) {
      bundleBody?.classList.remove('gradient-overlay');
    }
  }

  calculateBundleHeight() {
    let bundleHeaderHeight = this.bundlePanelHeader.scrollHeight;
    let bundleBodyHeight = this.bundlePanelBody.scrollHeight;
    let bundleFooterHeight = this.bundlePanelFooter.scrollHeight;

    let contentHeight = this.classList.contains('expanded')
    ? bundleHeaderHeight + bundleBodyHeight + bundleFooterHeight
    : bundleHeaderHeight + bundleFooterHeight;

    let gap = this.classList.contains('expanded') ? 'var(--fix-m)*2' : 'var(--fix-m)';
    this.style.height = `calc(${contentHeight}px + var(--fix-s)*2 + ${gap})`;
  }
}
customElements.define('sht-product-bundle-panel', SHTProductBundlePanel);
class SHTProductBundle extends SHTCustomComponent {
  constructor() {
    super();
    this.bundlePanel = this.querySelector('sht-product-bundle-panel');
    this.sectionId = this.bundlePanel?.dataset.section;
    this.dialog = SHTHelper.qs(`sht-dialog-product-bundle`);
    this.bundleBtnNoVariants = this.$$('.js-btn-add-to-bundle');
    this.expandPanelBtn = this.$('.js-expand-panel');
    this.triggers = this.$$('.js-product-add-bundle')
    this.togglePanel = this.togglePanel.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (this.expandPanelBtn) {
      this.expandPanelBtn.addEventListener('click', (e) => this.togglePanel(e));
    }

    this.triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.dialog.showModal(e.target, this.sectionId);
      })
    })

    if (this.bundleBtnNoVariants) {
      this.bundleBtnNoVariants.forEach(btn => btn.addEventListener('click', (event) => {
        this.addToBundle(event, btn);
        btn.disabled = true;
      }));
    }
  }

  togglePanel(event) {
    event.preventDefault();

    const isExpanded = this.bundlePanel.classList.toggle('expanded');
    if (isExpanded) {
      this.bundlePanel.bundlePanelButton.style.width = window.innerWidth <= 459 ? '100%' : 'auto';
      this.bundlePanel.addEventListener('transitionend', () => {
        this.bundlePanel.bundlePanelBody.style.display = 'block';
        requestAnimationFrame(() => {
          this.bundlePanel.bundlePanelBody.style.opacity = '1';
          this.bundlePanel.bundlePanelBody.style.height = '100%';
          this.bundlePanel.calculateBundleHeight();
        });
      }, { once: true });
    } else {
      this.bundlePanel.bundlePanelButton.style.width = window.innerWidth <= 459 ? '100%' : 'calc(320px - var(--fix-s)*2)';
      this.bundlePanel.addEventListener('transitionstart', () => {
        this.bundlePanel.bundlePanelBody.style.display = 'none';
        requestAnimationFrame(() => {
          this.bundlePanel.bundlePanelBody.style.opacity = '0';
          this.bundlePanel.bundlePanelBody.style.height = '0';
          this.bundlePanel.calculateBundleHeight();
        });
      }, { once: true });
    }
    this.expandPanelBtn.setAttribute(
      'aria-label',
      isExpanded
        ? SHTLanguage.bundle.EXPAND_MODAL
        : SHTLanguage.bundle.COLLAPSE_MODAL
    );
  }

  addToBundle(event, btn) {
    event.preventDefault();
    if (this.bundlePanel && typeof this.bundlePanel.initialize === 'function') {
      this.bundlePanel.initialize(btn, btn, true);
    }
  }
}
customElements.define('sht-product-bundle', SHTProductBundle);

class SHTProductBundleForm extends SHTCustomComponent {
  constructor() {
    super();
    this.bundleProducts = [];
    this.cartNotiType = document.body.getAttribute("data-cart-noti-type");
    this.cartType = document.body.getAttribute("data-cart-type");
    this.cartNotification = SHTHelper.qs("sht-cart-noti");
    this.cartDrawer = SHTHelper.qs("sht-cart-drwr");
    this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm");
    this.mainCartForm = SHTHelper.qs("sht-cart-frm");
    this.header_cart_status = SHTHelper.qs("#headerCartStatus");
    this.sectionId = this.closest('sht-product-bundle-panel')?.dataset.section;
    this.interactionPopup = SHTHelper.qs("sht-interaction-popup");
    this.header_cart_status?.classList.remove("header-cart-status--animate");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.spinner = this.$(".js-product-form-spinner");
    this.bundleAddToCartBtn = this.$(".js-bundle-button");
    this.bundlePanel = this.closest('sht-product-bundle-panel');
    this.enableUnlimitedAdd = this.bundlePanel?.dataset.enableUnlimitedAdd === 'true';
    this.placeholderBundle = this.bundlePanel?.querySelector('.js-placeholder-compare')
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.bundleAddToCartBtn.addEventListener("click", this.onSubmitHandler.bind(this));
  }

  addBundleProduct(variantId, quantity = 1) {
    this.bundleProducts.push({
      id: parseInt(variantId),
      quantity: quantity
    });
  }

  removeBundleProduct(index) {
    if (index >= 0 && index < this.bundleProducts.length) {
      this.bundleProducts.splice(index, 1);
    }
  }

  getBundleItems() {
    if (!this.enableUnlimitedAdd) {
      const mergedProducts = new Map();

      this.bundleProducts.forEach(item => {
        const existingItem = mergedProducts.get(item.id);
        if (existingItem) {
          existingItem.quantity += item.quantity;
        } else {
          mergedProducts.set(item.id, { ...item });
        }
      });

      return Array.from(mergedProducts.values());
    }

    return this.bundleProducts;
  }

  onSubmitHandler(e) {
    e.preventDefault();

    if (this.bundleAddToCartBtn.classList.contains("loading")) return;
    if (!this.bundleProducts.length) return;

    const minProducts = parseInt(this.bundlePanel?.dataset.minProducts || 2);
    if (this.bundleProducts.length < minProducts) {
      return;
    }

    this.toggleSubmitButtons(false);
    this.spinner?.classList.remove("hidden");

    let sections = [];
    if (this.cartNotification) {
      sections = this.cartNotification.getSectionsToRender();
    }
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }
    if (this.mainCartForm) {
      sections = [...sections, ...this.mainCartForm.getSectionsToRender(false)];
    }

    const formData = {
      items: this.getBundleItems()
    };

    if (sections.length) {
      formData.sections = sections.map(section => section.id);
      formData.sections_url = window.location.pathname;
    }

    let elementToFocus = this.bundleAddToCartBtn;

    fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(response => {

        if (response.status === 422 || response.status === 400) {
          const errorMessage = response.description || 'Error adding products to cart';
          this.handleErrorMessage(errorMessage, response?.message);
          return;
        }

        this.resetBundleButtons();

        switch (this.cartNotiType) {
          case "popover_notification":
            this.handlePopoverNotification(response, elementToFocus, formData.items.length);
            break;
          case "cart_noti":
            this.handleCartNotification(response);
            break;
          case "do_nothing":
            this.handleDoNothingNotification(response, elementToFocus);
            break;
        }

        if (this.interactionPopup) this.interactionPopup.handleShowPopupAddToCart();
      })
      .catch(e => {
        console.error(e);
        this.handleErrorMessage('An error occurred while adding products to cart');
      })
      .finally(() => {
        this.toggleSubmitButtons(true);
        this.spinner?.classList.add("hidden");
        this.bundleProducts = [];
        this.clearBundlePanel();
      });
  }

  resetBundleButtons() {
    this.bundlePanel?.querySelectorAll("[data-id-bundle]").forEach(btn => {
      const button = document.querySelector(`[data-id-product-bundle="${btn.dataset.idBundle}"]`);
      if (button) {
        button.disabled = false;
        button.innerHTML = button.dataset.originalText || button.innerHTML;
      }
    });
  }

  clearBundlePanel() {
    const addToCartBtnText = this.querySelector('.js-product-bundle-form-submit-btn-text');
    if (addToCartBtnText) {
      addToCartBtnText.textContent = `Add ${this.minProducts} more`;
      addToCartBtnText.parentElement.disabled = true;
    }

    if (this.bundlePanel) {
      this.bundlePanel.bundleItems.innerHTML = '';
      this.bundlePanel.productCount = 0;
      this.bundlePanel.updateBundleState();
      this.bundlePanel.initializeCarousel();
      this.bundlePanel.classList.remove('expanded');
      this.placeholderBundle?.classList.remove('d-none-important');
      this.bundlePanel.bundlePanelBody.style.display = 'none';
      this.bundlePanel.calculateBundleHeight();
    }
  }

  toggleSubmitButtons(enable = true) {
    const action = enable ? 'remove' : 'add';
    const ariaDisabled = enable ? false : true;

    this.bundleAddToCartBtn.classList[action]("loading");
    this.bundleAddToCartBtn.setAttribute("aria-disabled", ariaDisabled);
    if (enable) {
      this.bundleAddToCartBtn.removeAttribute("disabled");
    } else {
      this.bundleAddToCartBtn.setAttribute("disabled", true);
    }
  }

  handlePopoverNotification(response, elementToFocus, productQuantity) {
    this.cartNotification?.renderContents(response, true, elementToFocus, productQuantity);
    this.cartDrawerForm?.renderContents(response);
  }

  handleCartNotification(response) {
    if (this.cartType === "drawer") {
      this.cartNotification?.renderContents(response, false);
      this.cartDrawerForm?.renderContents(response);
      this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage();
      this.cartDrawer?.openDrawer();
    } else if (this.cartType === "page") {
      this.cartNotification?.renderContents(response, false);
      window.location.assign(window.routes.cart_url);
    }
  }

  handleDoNothingNotification(response, elementToFocus) {
    this.cartNotification?.renderContents(response, false, elementToFocus);
    this.cartDrawerForm?.renderContents(response);
  }

  handleErrorMessage(errorMessage = false, message = "") {
    if (errorMessage) {
      const error_wrapper = SHTHelper.qs(`sht-product-bundle[data-section="${this.sectionId}"] .js-product-form-error-wrapper`);
      const error_message = SHTHelper.qs(`sht-product-bundle[data-section="${this.sectionId}"] .js-product-form-error-message`);
      if (typeof errorMessage == "string") {
        error_wrapper.toggleAttribute("hidden", !errorMessage);
        error_message.textContent = errorMessage;
      }
    }
  }
}
customElements.define("sht-prd-bundle-frm", SHTProductBundleForm);

class SHTBeforeAfterImages extends SHTCustomComponent {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.isClicked = false;
    this.posSplitCursor = 20;

    this.afterImage = this.$(".js-after-image");
    this.splitCursor = this.$(".js-split-cursor");
    this.stepSize = 1;
    this.elements = [this.afterImage, this.splitCursor];

    if (this.afterImage && this.splitCursor) {
      this.init();
    }
  }

  connectedCallback() {
    this.observeResize();
    this.firstLoadAnimation();
  }
  firstLoadAnimation() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.closest('.section').classList.add('is-animated');
          this.querySelectorAll('.tag').forEach(tag => tag.classList.add('is-animated'));
          this.updateSplitPosition(50);
          this.elements.forEach(element => {
            element.classList.add('animation-init');
            element.addEventListener('transitionend', this.handleTransitionEnd.bind(this), { once: true });
          });
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(this);
  }
  handleTransitionEnd(event) {
    const propertiesToCheck = ['left'];
    if (propertiesToCheck.includes(event.propertyName)) {
      event.target.classList.remove('animation-init');
      const allDone = this.elements.every(el => !el.classList.contains('animation-init'));
      !allDone && this.elements.forEach(el => el.classList.remove('animation-init'));
    }
  }
  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    this.imageWidth = this.afterImage.offsetWidth;
    this.imageHeight = this.afterImage.offsetHeight;

    this.addEventListeners();
    this.updateSplitPosition(this.posSplitCursor);
    this.setupA11y();
  }

  setupA11y() {
    const dragButton = this.splitCursor.querySelector('.js-split-cursor');
    dragButton.setAttribute('role', 'slider');
    dragButton.setAttribute('aria-label', 'Image comparison slider');
    dragButton.setAttribute('aria-valuemin', '1');
    dragButton.setAttribute('aria-valuemax', '99');
    dragButton.setAttribute('aria-valuenow', this.posSplitCursor);
    dragButton.setAttribute('tabindex', '0');

    dragButton.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(e) {
    let newPosition = this.posSplitCursor;

    switch (e.key) {
      case 'ArrowLeft':
      case 'ArrowDown':
        newPosition = Math.max(0, this.posSplitCursor - this.stepSize);
        e.preventDefault();
        break;
      case 'ArrowRight':
      case 'ArrowUp':
        newPosition = Math.min(100, this.posSplitCursor + this.stepSize);
        e.preventDefault();
        break;
      case 'Home':
        newPosition = 0;
        e.preventDefault();
        break;
      case 'End':
        newPosition = 100;
        e.preventDefault();
        break;
      default:
        return;
    }

    this.posSplitCursor = newPosition;
    this.updateSplitPosition(this.posSplitCursor);
    this.updateA11yAttributes();
  }

  observeResize() {
    this.resizeObserver = new ResizeObserver(() => {
      this.imageWidth = this.afterImage.offsetWidth;
      this.imageHeight = this.afterImage.offsetHeight;
      this.updateSplitPosition(this.posSplitCursor);
    });
    this.resizeObserver.observe(this.afterImage);
  }


  addEventListeners() {
    this.splitCursor.addEventListener("mousedown", this.slideReady.bind(this));
    this.splitCursor.addEventListener("touchstart", this.slideReady.bind(this), { passive: true });
    document.addEventListener("mouseup", this.slideFinish.bind(this));
    document.addEventListener("touchend", this.slideFinish.bind(this), { passive: true });
  }

  cleanup() {
    this.resizeObserver?.disconnect();
    document.removeEventListener("mousemove", this.slideMove.bind(this));
    document.removeEventListener("touchmove", this.slideMove.bind(this));
  }

  slideReady(e) {
    this.isClicked = true;
    document.addEventListener("mousemove", this.slideMove.bind(this));
    document.addEventListener("touchmove", this.slideMove.bind(this));
  }

  slideFinish() {
    this.isClicked = false;
    document.removeEventListener("mousemove", this.slideMove.bind(this));
    document.removeEventListener("touchmove", this.slideMove.bind(this));
  }

  slideMove(e) {
    if (!this.isClicked) return;
    e = e.changedTouches ? e.changedTouches[0] : e;
    const containerLeft = this.offsetLeft;
    const touchPoint = e.clientX - containerLeft;

    const minPosition = 10;
    const maxPosition = this.imageWidth - 10;

    const clampedPosition = Math.min(maxPosition, Math.max(minPosition, touchPoint));

    this.posSplitCursor = (clampedPosition / this.imageWidth) * 100;

    this.updateSplitPosition(this.posSplitCursor);
  }

  updateSplitPosition(position) {
    this.style.setProperty("--before-after-initial-drag-position", `${position}%`);
    this.updateA11yAttributes();
  }

  updateA11yAttributes() {
    const dragButton = this.splitCursor.querySelector('.js-split-cursor');
    dragButton.setAttribute('aria-valuenow', Math.round(this.posSplitCursor));
  }
}
customElements.define("sht-before-after-images", SHTBeforeAfterImages);

class SHTMasonry extends SHTCustomComponent {
  constructor() {
    super();
    this.masonry = this.$('.js-masonry');
    this.items = Array.from(this.$$('.js-masonry-item'));
    this.enableOffset = this.dataset.enableOffset === "true";
    this.columnHeights = [];
    this.firstItemInColumn = {};
    this.columns = this.calculateColumnCount();

    this.debounce = (fn, delay) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
      };
    };
  }

  connectedCallback() {
    if (!this.masonry) return;
    this.baseSize = parseFloat(this.dataset.baseSize) || 16;
    this.gap = this.baseSize / 2;
    this.offset = this.calculateOffset();

    this.initializeGrid();
    this.observeGridChanges();
    window.addEventListener('resize', this.debounce(() => this.handleResize(), 200));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.debounce);
  }

  calculateOffset() {
    const { innerWidth: width } = window;
    if (width >= 1025) return this.baseSize * 2.5;
    if (width >= 459) return this.baseSize * 2.25;
    return this.baseSize * 2;
  }

  calculateColumnCount() {
    const { innerWidth: width } = window;
    const desktopColumns = parseInt(this.masonry?.dataset.columnDesktop, 10) || 4;
    if (width >= 1025) return desktopColumns;
    if (width >= 459) return 3;
    return 2;
  }

  initializeGrid() {
    this.updateGridStructure();
    this.updateGridItems();
  }

  updateGridStructure() {
    this.columns = this.calculateColumnCount();
    this.columnHeights = Array(this.columns).fill(0);
    this.firstItemInColumn = {};
    this.offset = this.calculateOffset();
  }

  updateGridItems() {
    if (!this.masonry || !this.items.length) return;

    const columnWidth = (this.masonry.offsetWidth - this.gap * (this.columns - 1)) / this.columns;
    this.items.forEach((item) => {
      const columnIndex = this.getShortestColumnIndex();
      const x = columnIndex * (columnWidth + this.gap);
      const isFirstItem = !this.firstItemInColumn[columnIndex];
      const marginTop = this.enableOffset && columnIndex % 2 && isFirstItem ? this.offset : 0;
      const y = this.columnHeights[columnIndex] + marginTop;
      const height = this.calculateItemHeight(item, columnWidth);

      this.positionItem(item, x, y, columnWidth, height);

      this.columnHeights[columnIndex] += height + this.gap + marginTop;
      this.firstItemInColumn[columnIndex] = true;
    });

    this.updateContainerHeight();
  }

  calculateItemHeight(item, width) {
    const ratio = item.dataset.ratio;
    if (ratio.includes('/')) {
      const [numerator, denominator] = ratio.split('/').map(Number);

      return denominator ? (width * denominator) / numerator : width;
    } else {
      const parsedRatio = parseFloat(ratio);

      if (!isNaN(parsedRatio)) return width / parsedRatio;
    }
  }

  getShortestColumnIndex() {
    return this.columnHeights.indexOf(Math.min(...this.columnHeights));
  }

  positionItem(item, x, y, width, height) {
    Object.assign(item.style, {
      width: `${width}px`,
      height: `${height}px`,
      transform: `translate(${x}px, ${y}px)`,
    });
  }

  updateContainerHeight() {
    this.masonry.style.height = `${Math.max(...this.columnHeights)}px`;
  }

  observeGridChanges() {
    new ResizeObserver(() => this.initializeGrid()).observe(this.masonry);
    new MutationObserver(() => {
      this.items = Array.from(this.$$('.js-masonry-item'));
      this.initializeGrid();
    }).observe(this.masonry, { childList: true, subtree: true });
  }

  handleResize() {
    this.initializeGrid();
  }
}

customElements.define('sht-masonry', SHTMasonry);

class SHTImageGalleryItem extends SHTCustomComponent {
  constructor() {
    super();
    this.openGalleryButton = this.$(".js-open-image-gallery-btn");

    if (this.openGalleryButton) {
      this.openGalleryButton.addEventListener("click", e => {
        this.openDialogGallery(e);
      });
    }
  }

  openDialogGallery(e) {
    let dialog = SHTHelper.qs(`#${e.currentTarget.dataset.galleryDialogId}`);
    if (dialog) {
      dialog.showModal(e.currentTarget, true);
    }
  }
}

customElements.define('sht-image-gallery-item', SHTImageGalleryItem);

class CountdownFlip extends HTMLElement {
  constructor() {
    super();
    this.trackers = {};
    this.interval = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    // Parse initial data
    this.isExpired = JSON.parse(this.dataset.isExpired);
    if (this.isExpired) return true;

    // Get configuration from dataset
    this.timeZoneName = this.dataset.timeZoneName;
    this.timeZoneOffset = this.dataset.timeZoneOffset;
    this.endTime = this.dataset.endTime;
    this.endDate = this.dataset.endDate;
    this.hideOnEnd = JSON.parse(this.dataset.hideOnEnd);

    // Validate and set default values
    if (!this.validateDateValue(this.endDate)) {
      this.endDate = this.getCurrentDateTime(true);
    }

    if (!this.validateTimeValue(this.endTime)) {
      this.endTime = "23:59:59";
    }

    // Initialize time values
    this.expiredAt = new Date(this.convertDateStringToISOString(`${this.endDate}:${this.endTime}`)).getTime();
    this.currentTime = this.convertDateTimeToSpecificTimeZone(this.getCurrentDateTime());

    // Setup display elements
    this.setupDisplay();
    this.start();
  }

  setupDisplay() {
    this.messageElement = this.querySelector(".js-counter-message");
    this.counterElement = this.querySelector(".js-counter");

    // Setup flip cards for each unit
    ['days', 'hours', 'minutes', 'seconds'].forEach(unit => {
      const element = this.querySelector(`.js-counter-${unit}`);
      if (element) {
        this.setupFlipCard(element, unit);
        this.trackers[unit] = {
          element,
          currentValue: null,
          top: element.querySelector('.flip-card__top'),
          bottom: element.querySelector('.flip-card__bottom'),
          back: element.querySelector('.flip-card__back'),
          backBottom: element.querySelector('.flip-card__bottom-flip'),
          label: element.nextElementSibling.textContent
        };
      }
    });
  }

  setupFlipCard(element, unit) {
    const wrapper = document.createElement('span');
    wrapper.className = 'flip-card p-relative';

    const cardHTML = `
        <span class="flip-card__top"></span>
        <span class="flip-card__bottom"></span>
        <span class="flip-card__back">
          <span class="flip-card__bottom-flip"></span>
        </span>
    `;
    const originalText = element.textContent;
    // element.setAttribute('aria-label', `${originalText} ${unit}`);

    wrapper.innerHTML = cardHTML;
    element.textContent = '';
    element.appendChild(wrapper);
  }

  updateTracker(unit, newValue) {
    const tracker = this.trackers[unit];
    if (!tracker) return;

    newValue = String(newValue).padStart(2, '0');

    if (newValue === tracker.currentValue) {
      return;
    }

    if (tracker.currentValue !== null) {
      tracker.back.setAttribute('data-value', tracker.currentValue);
      tracker.bottom.setAttribute('data-value', tracker.currentValue);
    }

    tracker.currentValue = newValue;
    tracker.top.textContent = tracker.currentValue;
    tracker.backBottom.setAttribute('data-value', tracker.currentValue);

    tracker.element.classList.remove('flip');
    void tracker.element.offsetWidth;
    tracker.element.classList.add('flip');

    tracker.element.setAttribute('aria-label', `${newValue} ${tracker.label}`);
  }

  start() {
    this.updateDisplay();
    this.interval = setInterval(() => this.updateDisplay(), 1000);
  }

  updateDisplay() {
    const diff = this.expiredAt - this.currentTime;

    if (diff <= 0) {
      this.handleExpired();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.updateTracker('days', days);
    this.updateTracker('hours', hours);
    this.updateTracker('minutes', minutes);
    this.updateTracker('seconds', seconds);

    this.currentTime = this.currentTime + 1000;
  }

  handleExpired() {
    this.destroy();
    this.setAttribute('data-is-expired', 'true');

    // Update all displays to zero
    ['days', 'hours', 'minutes', 'seconds'].forEach(unit => {
      this.updateTracker(unit, 0);
    });

    if (this.messageElement && this.messageElement.innerHTML !== "") {
      this.messageElement.classList.remove("d-none");
    }

    if (this.hideOnEnd && this.counterElement) {
      this.counterElement.classList.add("d-none-important");
    }
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  // Utility methods
  getCurrentDateTime(onlyDate = false) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    return onlyDate
      ? `${year}-${month}-${day}`
      : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  convertDateTimeToSpecificTimeZone(dateString, timestamp = true) {
    const inputDate = new Date(dateString);
    const isNegativeOffset = this.timeZoneOffset[0] === "-";
    const offsetHours = parseInt(this.timeZoneOffset.substring(1, 3));
    const offsetMinutes = parseInt(this.timeZoneOffset.substring(3, 5));
    let timeDifferenceMillis = (offsetHours * 60 + offsetMinutes) * 60 * 1000;

    if (isNegativeOffset) {
      timeDifferenceMillis = -timeDifferenceMillis;
    }

    const targetTime = new Date(inputDate.getTime() + timeDifferenceMillis);
    return timestamp ? targetTime.getTime() : targetTime.toISOString();
  }

  convertDateStringToISOString(inputDateStr) {
    const reformatDateStr = inputDateStr.replace(/:/, "T");
    return `${reformatDateStr}.000Z`;
  }

  validateDateValue(dateString) {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    return datePattern.test(dateString);
  }

  validateTimeValue(timeString) {
    const timePattern = /^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;
    return timePattern.test(timeString);
  }
}

// Register the custom element
customElements.define('sht-countdown-flip', CountdownFlip);

class SHTVariation extends SHTCustomComponent {
  constructor() {
    super();
    this.productVariations = this.$$('.js-variation-item');
    this.sectionId = this.dataset.sectionId;
    this.isQuickView = this.classList.contains('js-variation-quick-view');
    this.cachedData = {};
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const item = event.target.closest('.js-variation-item');
    if (item) {
      this.handleVariationClick(item.dataset.variationUrl);
    }
  }

  handleVariationClick(url) {
    if (!this.isQuickView) {
      window.history.replaceState(null, '', url);
    }
    this.fetchData(url);
  }

  async fetchData(productUrl) {
    try {
      if (this.cachedData[productUrl]) {
        this.updateDOM(this.cachedData[productUrl], productUrl);
        return;
      }

      const fetchUrl = `${productUrl}?section_id=${this.sectionId}`;
      const response = await fetch(fetchUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.status} ${response.statusText}`);
      }

      const html = await response.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      this.cachedData[productUrl] = tempDiv;

      await this.preloadImages(tempDiv);
      this.updateDOM(tempDiv, productUrl);
    } catch (error) {
      console.error('Error fetching product variation:', error);
    }
  }

  preloadImages(dom) {
    const images = dom.querySelectorAll('img[src]:not([loading="lazy"])');

    if (images.length === 0) {
      return Promise.resolve();
    }

    const promises = Array.from(images).map(img => {
      return new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = () => resolve();
          img.onerror = () => resolve();
        }
      });
    });

    return Promise.all(promises);
  }

  updateDOM(responseHTML, productUrl) {
    const targetSectionId = this.isQuickView ? 'dialogBodyQuickView' : this.sectionId;
    const currentSection = document.querySelector(`#${targetSectionId}`);

    if (!responseHTML || !currentSection) {
      console.warn('Product elements not found in current or new product');
      return;
    }

    const animateEl = responseHTML.querySelector('.js-main-product');
    if (animateEl) {
      animateEl.removeAttribute('data-animate');
    }

    if (this.isQuickView) {
      const quickViewContainer = responseHTML.querySelector('.js-quick-view-container');
      if (quickViewContainer) {
        currentSection.innerHTML = quickViewContainer.innerHTML;

        const viewFullBtn = document.querySelector('#dialogQuickShop .js-view-full-btn a') || document.querySelector('.js-quick-view-drawer .js-view-full-btn a');
        if (viewFullBtn && productUrl) {
          viewFullBtn.href = productUrl;
        }
      }
    } else {
      currentSection.parentElement.innerHTML = responseHTML.children[0].innerHTML;
    }

    if (window.Shopify?.PaymentButton) {
      Shopify.PaymentButton.init();
    }
  }
}
customElements.define('sht-variation', SHTVariation);
